// src/public/error-codes.ts
import { PlayerError as PublicErrorCodes } from "@foundation-player/error-codes";
var ErrorCodes = {
  ...PublicErrorCodes
  // Custom error codes go here.
  //
  // TODO: Once we are confident that the error codes are stable,
  // we must move them to the @foundation-player/error-codes package.
};

// src/public/foundation-error.ts
var internal_FoundationErrorSymbol = Symbol.for("internal_FoundationError");
var isFoundationError = (error) => !!error && typeof error === "object" && "_type" in error && error._type === internal_FoundationErrorSymbol;
var FoundationError = class extends Error {
  constructor(message, opts = {}) {
    super(message);
    this._type = internal_FoundationErrorSymbol;
    this.code = opts.code || ErrorCodes.ERROR_NOT_TREATED_59000.code;
    this.context = {
      message: opts.message,
      ...opts.context
    };
  }
};
var createFoundationError = (message, context, error) => {
  const errorMessage = error?.message || message;
  return new FoundationError(errorMessage, {
    code: error?.code || ErrorCodes.ERROR_NOT_TREATED_59000.code,
    context,
    message
  });
};

// src/_internal/logger/get-logger.ts
var getLogger = (namespace) => {
  if (!namespace) {
    throw createFoundationError("Cannot return a logger for an empty namespace.");
  }
  const rootLogger = typeof window !== "undefined" && window.foundation?.internal_RootLogger;
  if (!rootLogger) {
    throw createFoundationError(
      "Logger on the window object wasn't initialized yet when getLogger() was called"
    );
  }
  return rootLogger.getLogger(namespace);
};

// src/_internal/autoplay/assert-video-element-attributes.ts
function assertVideoElementAttributes(videoElement) {
  const logger = getLogger("autoplay.assertVideoElementAttributes");
  removeUnsupportedAttributes(videoElement, logger);
  addRequiredAttributes(videoElement);
}
function removeUnsupportedAttributes(videoElement, logger) {
  const unsupportedAttributes = ["loop", "autoplay", "preload", "muted", "controls"];
  const removedAttributes = [];
  for (const attribute of unsupportedAttributes) {
    if (videoElement.hasAttribute(attribute)) {
      removedAttributes.push(attribute);
      videoElement.removeAttribute(attribute);
    }
  }
  if (removedAttributes.length > 0) {
    logger.warn(
      "The following attributes are not supported on the <video> element and have been removed",
      removedAttributes.join(", ")
    );
  }
}
function addRequiredAttributes(videoElement) {
  videoElement.playsInline = true;
  videoElement.disableRemotePlayback = true;
}

// src/_internal/asset/minimal-video-source-aac.ts
function getMinimalVideoSourceAac() {
  return new Blob(
    [
      new Uint8Array([
        0,
        0,
        0,
        28,
        102,
        116,
        121,
        112,
        105,
        115,
        111,
        109,
        0,
        0,
        2,
        0,
        105,
        115,
        111,
        109,
        105,
        115,
        111,
        50,
        109,
        112,
        52,
        49,
        0,
        0,
        0,
        8,
        102,
        114,
        101,
        101,
        0,
        0,
        2,
        239,
        109,
        100,
        97,
        116,
        33,
        16,
        5,
        32,
        164,
        27,
        255,
        192,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        55,
        167,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        112,
        33,
        16,
        5,
        32,
        164,
        27,
        255,
        192,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        55,
        167,
        128,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        112,
        0,
        0,
        2,
        194,
        109,
        111,
        111,
        118,
        0,
        0,
        0,
        108,
        109,
        118,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        232,
        0,
        0,
        0,
        47,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        1,
        236,
        116,
        114,
        97,
        107,
        0,
        0,
        0,
        92,
        116,
        107,
        104,
        100,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        47,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        101,
        100,
        116,
        115,
        0,
        0,
        0,
        28,
        101,
        108,
        115,
        116,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        47,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        100,
        109,
        100,
        105,
        97,
        0,
        0,
        0,
        32,
        109,
        100,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        8,
        0,
        85,
        196,
        0,
        0,
        0,
        0,
        0,
        45,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        115,
        111,
        117,
        110,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0,
        0,
        0,
        1,
        15,
        109,
        105,
        110,
        102,
        0,
        0,
        0,
        16,
        115,
        109,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        100,
        105,
        110,
        102,
        0,
        0,
        0,
        28,
        100,
        114,
        101,
        102,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        12,
        117,
        114,
        108,
        32,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        211,
        115,
        116,
        98,
        108,
        0,
        0,
        0,
        103,
        115,
        116,
        115,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        87,
        109,
        112,
        52,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        16,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        0,
        0,
        0,
        51,
        101,
        115,
        100,
        115,
        0,
        0,
        0,
        0,
        3,
        128,
        128,
        128,
        34,
        0,
        2,
        0,
        4,
        128,
        128,
        128,
        20,
        64,
        21,
        0,
        0,
        0,
        0,
        1,
        244,
        0,
        0,
        1,
        243,
        249,
        5,
        128,
        128,
        128,
        2,
        18,
        16,
        6,
        128,
        128,
        128,
        1,
        2,
        0,
        0,
        0,
        24,
        115,
        116,
        116,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        28,
        115,
        116,
        115,
        99,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        28,
        115,
        116,
        115,
        122,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        1,
        115,
        0,
        0,
        1,
        116,
        0,
        0,
        0,
        20,
        115,
        116,
        99,
        111,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        44,
        0,
        0,
        0,
        98,
        117,
        100,
        116,
        97,
        0,
        0,
        0,
        90,
        109,
        101,
        116,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        33,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        109,
        100,
        105,
        114,
        97,
        112,
        112,
        108,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        45,
        105,
        108,
        115,
        116,
        0,
        0,
        0,
        37,
        169,
        116,
        111,
        111,
        0,
        0,
        0,
        29,
        100,
        97,
        116,
        97,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        76,
        97,
        118,
        102,
        53,
        54,
        46,
        52,
        48,
        46,
        49,
        48,
        49
      ])
    ],
    { type: "video/mp4" }
  );
}

// src/_internal/asset/minimal-video-source-mp3.ts
function getMinimalVideoSourceMp3() {
  return new Blob(
    [
      new Uint8Array([
        0,
        0,
        0,
        28,
        102,
        116,
        121,
        112,
        105,
        115,
        111,
        109,
        0,
        0,
        2,
        0,
        105,
        115,
        111,
        109,
        105,
        115,
        111,
        50,
        109,
        112,
        52,
        49,
        0,
        0,
        0,
        8,
        102,
        114,
        101,
        101,
        0,
        0,
        4,
        237,
        109,
        100,
        97,
        116,
        255,
        251,
        144,
        100,
        0,
        15,
        240,
        0,
        0,
        105,
        0,
        0,
        0,
        8,
        0,
        0,
        13,
        32,
        0,
        0,
        1,
        0,
        0,
        1,
        164,
        0,
        0,
        0,
        32,
        0,
        0,
        52,
        128,
        0,
        0,
        4,
        76,
        65,
        77,
        69,
        51,
        46,
        49,
        48,
        48,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        76,
        65,
        77,
        69,
        51,
        46,
        49,
        48,
        48,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        255,
        251,
        146,
        100,
        64,
        143,
        240,
        0,
        0,
        105,
        0,
        0,
        0,
        8,
        0,
        0,
        13,
        32,
        0,
        0,
        1,
        0,
        0,
        1,
        164,
        0,
        0,
        0,
        32,
        0,
        0,
        52,
        128,
        0,
        0,
        4,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        76,
        65,
        77,
        69,
        51,
        46,
        49,
        48,
        48,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        255,
        251,
        146,
        100,
        64,
        143,
        240,
        0,
        0,
        105,
        0,
        0,
        0,
        8,
        0,
        0,
        13,
        32,
        0,
        0,
        1,
        0,
        0,
        1,
        164,
        0,
        0,
        0,
        32,
        0,
        0,
        52,
        128,
        0,
        0,
        4,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        85,
        0,
        0,
        2,
        218,
        109,
        111,
        111,
        118,
        0,
        0,
        0,
        108,
        109,
        118,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        232,
        0,
        0,
        0,
        47,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        2,
        5,
        116,
        114,
        97,
        107,
        0,
        0,
        0,
        92,
        116,
        107,
        104,
        100,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        47,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        101,
        100,
        116,
        115,
        0,
        0,
        0,
        28,
        101,
        108,
        115,
        116,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        46,
        0,
        0,
        4,
        81,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        125,
        109,
        100,
        105,
        97,
        0,
        0,
        0,
        32,
        109,
        100,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        12,
        81,
        85,
        196,
        0,
        0,
        0,
        0,
        0,
        45,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        115,
        111,
        117,
        110,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0,
        0,
        0,
        1,
        40,
        109,
        105,
        110,
        102,
        0,
        0,
        0,
        16,
        115,
        109,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        100,
        105,
        110,
        102,
        0,
        0,
        0,
        28,
        100,
        114,
        101,
        102,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        12,
        117,
        114,
        108,
        32,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        236,
        115,
        116,
        98,
        108,
        0,
        0,
        0,
        116,
        115,
        116,
        115,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        100,
        109,
        112,
        52,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        16,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        0,
        0,
        0,
        44,
        101,
        115,
        100,
        115,
        0,
        0,
        0,
        0,
        3,
        128,
        128,
        128,
        27,
        0,
        1,
        0,
        4,
        128,
        128,
        128,
        13,
        107,
        21,
        0,
        0,
        0,
        0,
        2,
        35,
        170,
        0,
        2,
        35,
        170,
        6,
        128,
        128,
        128,
        1,
        2,
        0,
        0,
        0,
        20,
        98,
        116,
        114,
        116,
        0,
        0,
        0,
        0,
        0,
        2,
        35,
        170,
        0,
        2,
        35,
        170,
        0,
        0,
        0,
        32,
        115,
        116,
        116,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        2,
        0,
        0,
        4,
        128,
        0,
        0,
        0,
        1,
        0,
        0,
        3,
        81,
        0,
        0,
        0,
        28,
        115,
        116,
        115,
        99,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        32,
        115,
        116,
        115,
        122,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        1,
        161,
        0,
        0,
        1,
        162,
        0,
        0,
        1,
        162,
        0,
        0,
        0,
        20,
        115,
        116,
        99,
        111,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        44,
        0,
        0,
        0,
        97,
        117,
        100,
        116,
        97,
        0,
        0,
        0,
        89,
        109,
        101,
        116,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        33,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        109,
        100,
        105,
        114,
        97,
        112,
        112,
        108,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        44,
        105,
        108,
        115,
        116,
        0,
        0,
        0,
        36,
        169,
        116,
        111,
        111,
        0,
        0,
        0,
        28,
        100,
        97,
        116,
        97,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        76,
        97,
        118,
        102,
        54,
        49,
        46,
        55,
        46,
        49,
        48,
        48
      ])
    ],
    { type: "video/mp4" }
  );
}

// src/_internal/autoplay/test-autoplay.ts
async function testAutoplay(videoElement, options = {}) {
  const isMuted = options.isMuted ?? false;
  const hasAacCodecSupport = options.hasAacCodecSupport ?? true;
  const timeoutInMilliseconds = options.timeoutInMilliseconds ?? 250;
  const logger = getLogger("autoplay.testAutoplay");
  logger.trace("Test autoplay support", { isMuted });
  const mutedValue = videoElement.muted;
  logger.trace("Video element muted value was", mutedValue);
  videoElement.muted = isMuted;
  videoElement.autoplay = true;
  logger.debug("Test autoplay support with autoplay and muted value", {
    autoplay: true,
    muted: isMuted
  });
  const videoSource = hasAacCodecSupport ? getMinimalVideoSourceAac() : getMinimalVideoSourceMp3();
  const source = URL.createObjectURL(videoSource);
  videoElement.src = source;
  videoElement.load();
  let playResult;
  let timeoutId;
  let sendOutput;
  const result = await new Promise((resolve) => {
    playResult = videoElement.play();
    timeoutId = setTimeout(() => {
      sendOutput(false, new Error(`Timeout ${timeoutInMilliseconds}ms has been reached`));
    }, timeoutInMilliseconds);
    sendOutput = (result2, error = null) => {
      videoElement.src = "";
      URL.revokeObjectURL(source);
      clearTimeout(timeoutId);
      resolve({ result: result2, error });
    };
    if (playResult !== void 0) {
      playResult.then(() => sendOutput(true)).catch((playError) => sendOutput(false, playError));
    } else {
      sendOutput(true);
    }
  });
  logger.debug("Autoplay support result", result);
  videoElement.autoplay = false;
  videoElement.muted = mutedValue;
  logger.debug("Reset video element autoplay and muted value", {
    autoplay: false,
    muted: mutedValue
  });
  return result;
}

// src/_internal/create-player/bundle-options.ts
var internal_BundleOptions = [
  "@foundation-player/player-dashjs",
  "@foundation-player/player-chromecast",
  "@foundation-player/plugin-smartclip",
  "@foundation-player/plugin-npaw",
  "@foundation-player/plugin-ui",
  "@foundation-player/plugin-shorts",
  "@foundation-player/plugin-yospace",
  "@foundation-player/plugin-posthog"
];
function internal_createBundleOptionsMap() {
  const variants = Array.from(
    { length: 2 ** internal_BundleOptions.length },
    (_, i) => i.toString(2).padStart(internal_BundleOptions.length, "0")
  );
  return variants.reduce(
    (map, variant) => {
      map[variant] = internal_BundleOptions.reduce(
        (options, option, index) => {
          options[option] = variant[index] === "1" ? "true" : "false";
          return options;
        },
        {}
      );
      return map;
    },
    {}
  );
}
function convertFlagsToBinary(flags) {
  return internal_BundleOptions.map((option) => flags[option] ? "1" : "0").join("");
}

// src/public/generated/load-request.schema.ts
var ManifestType = {
  /**
   * The DASH manifest type is used for MPEG-DASH streams. This is the most common format for ABR streaming. It is resolved in software and can thus be played by virtually any client which supports HTML Media Source Extensions (MSE).
   *
   * DASH can also be encrypted using Widevine or PlayReady. This is done to conform with the content protection requirements of the content owner.
   *
   * At RTL DASH is used for all long form content and live streams. It is also used for Audiobooks.
   *
   * This commonly has the file extension .mpd
   */
  Dash: "dash",
  /**
   * The HLS manifest type is used for HTTP Live Streaming in short HLS. This is the most common format for ABR streaming on Apple devices. It can be resolved in software with MSE support or in hardware with the native HLS support of the device.
   *
   * HLS can also be encrypted using FairPlay. This is done to conform with the content protection requirements of the content owner.
   *
   * At RTL HLS is used for all long form content and live streams. It is also used for Audiobooks. We use HLS only if it can be resolved in hardware, as this is the most efficient way to play HLS streams.
   *
   * This commonly has the file extension .m3u8
   */
  Hls: "hls",
  /**
   * The Progressive manifest type is used for progressive download streams. This is the most common format for short form content and audio only content. It is resolved in software and can be played by virtually any client which supports HTML5 video and audio.
   *
   * Progressive is not encrypted and can thus freely be shared and played by anyone, as long as you get a hold of the file. For this reason this is only used for content which is not subject to any content protection requirements e.g. Advertisements, News Clips, Podcasts.
   *
   * At RTL Progressive is used for Radio Streams, Podcasts, Advertisements. In some cases it is also used for short form content instead of DASH or HLS. This is usually the case if the stream is provided via VMS.
   *
   * This can be any playable file by a video tag like .mp4, .ogv, .webm, etc.
   * The same applies for audio only content like .mp3, .ogg, .wav, etc.
   */
  Progressive: "progressive"
};
var KeySystem = {
  /**
   * Google Widevine DRM system
   *
   * Widevine is a DRM system from Google that is used to encrypt media streams.
   *
   * Widevine is available on most Android devices, as well as most Smart TVs and set-top boxes.
   * In general if available, we recommend to use Widevine, unless the device has known issues with it or performs better with PlayReady.
   *
   * We recommend to use Widevine on the following devices:
   * - Desktop Chrome browser
   * - Android devices
   * - Tizen devices
   * - WebOS devices
   * - PlayStation devices
   * - Sky XiOne devices
   * - Sky Stream devices
   * - TeleColumbus devices
   * - Kepler devices
   * - Chromecast devices
   *
   * @see https://www.widevine.com/
   */
  Widevine: "widevine",
  /**
   * Microsoft PlayReady DRM system
   *
   * PlayReady is a DRM system from Microsoft that is used to encrypt media streams.
   *
   * PlayReady is only available on Windows and Xbox devices in combination with the Edge browser,
   * as well some Smart TVs and set-top boxes.
   *
   * We recommend to use PlayReady on the following devices:
   * - Xbox devices
   * - Sky Q devices
   * - Magenta devices
   * - Vodafone devices
   *
   * @see https://www.microsoft.com/playready/documents/
   */
  Playready: "playready",
  /**
   * Apple FairPlay DRM system
   *
   * FairPlay is a DRM system from Apple that is used to encrypt media streams.
   *
   * FairPlay is only available on iOS and macOS devices in combination with the Safari browser.
   * In general if available, we recommend to use FairPlay.
   *
   * Beware that we support FairPlay **only** in conjunction with HLS streams.
   *
   * We recommend to use FairPlay on the following devices:
   * - iOS devices
   * - macOS devices
   *
   * @see https://developer.apple.com/streaming/fps/
   */
  Fairplay: "fairplay"
};
var DeviceType = {
  /**
   * A generic mobile device, usually a smartphone.
   */
  Mobile: "mobile",
  /**
   * A generic tablet device.
   *
   * A tablet is similar to a mobile device, but usually has a larger screen.
   */
  Tablet: "tablet",
  /**
   * A generic desktop device.
   *
   * This is usually a laptop or a desktop computer.
   * The difference is that this device type is usually operated with a mouse and keyboard and connected to multiple screens.
   */
  Desktop: "desktop",
  /**
   * LG WebOS 3.x (2016-2017)
   *
   * The browser on this platform is based on Chromium 38 according to LG.
   *
   * This is also the first version based on Chromium.
   * We currently do not support this platform, but we may do so in the future.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_3: "webos-3",
  /**
   * LG WebOS 4.x (2018-2019)
   *
   * The browser on this platform is based on Chromium 53 according to LG.
   *
   * This is the oldest generation of WebOS we currently support.
   * LG still actively sells devices with this version of WebOS.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_4: "webos-4",
  /**
   * LG WebOS 5.x (2020)
   *
   * The browser on this platform is based on Chromium 68 according to LG.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_5: "webos-5",
  /**
   * LG WebOS 6.x (2021)
   *
   * The browser on this platform is based on Chromium 79 according to LG.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_6: "webos-6",
  /**
   * LG WebOS 22 (2022)
   *
   * The browser on this platform is based on Chromium 87 according to LG.
   *
   * Devices with WebOS 22 may also show up as WebOS 7.x, but LG specifies this version as 22 on their website.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_22: "webos-22",
  /**
   * LG WebOS 23 (2023)
   *
   * The browser on this platform is based on Chromium 94 according to LG.
   *
   * Devices with WebOS 23 may also show up as WebOS 8.x, but LG specifies this version as 23 on their website.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_23: "webos-23",
  /**
   * LG WebOS 24 (2024)
   *
   * The browser on this platform is based on Chromium 108 according to LG.
   *
   * Devices with WebOS 24 may also show up as WebOS 9.x, but LG specifies this version as 24 on their website.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_24: "webos-24",
  /**
   * LG WebOS 25 (2025)
   *
   * The browser on this platform is based on Chromium 120 according to LG.
   *
   * Devices with WebOS 25 may also show up as WebOS 10.x, but LG specifies this version as 25 on their website.
   *
   * @see https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
   */
  Webos_25: "webos-25",
  /**
   * Tizen 3.0 (2017)
   *
   * The browser on this platform is based on Chromium 47 according to Samsung.
   *
   * This is the oldest generation of Tizen we currently support.
   * This is also the generation with the most known issues.
   * In general if the player works on this platform, it will work on newer versions of Tizen as well.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_3_0: "tizen-3.0",
  /**
   * Tizen 4.0 (2018)
   *
   * The browser on this platform is based on Chromium 56 according to Samsung.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_4_0: "tizen-4.0",
  /**
   * Tizen 5.0 (2019)
   *
   * The browser on this platform is based on Chromium 63 according to Samsung.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_5_0: "tizen-5.0",
  /**
   * Tizen 5.5 (2020)
   *
   * The browser on this platform is based on Chromium 69 according to Samsung.
   *
   * Beware that Tizen widgets for this versions act differently than for the versions prior to this one.
   * The widget manifest validation is stricter and the player may not work as expected.
   * Newer generations use the same validation.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_5_5: "tizen-5.5",
  /**
   * Tizen 6.0 (2021)
   *
   * The browser on this platform is based on Chromium 76 according to Samsung.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_6_0: "tizen-6.0",
  /**
   * Tizen 6.5 (2022)
   *
   * The browser on this platform is based on Chromium 85 according to Samsung.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_6_5: "tizen-6.5",
  /**
   * Tizen 7.0 (2023)
   *
   * The browser on this platform is based on Chromium 94 according to Samsung.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_7_0: "tizen-7.0",
  /**
   * Tizen 8.0 (2024)
   *
   * The browser on this platform is based on Chromium 108 according to Samsung.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_8_0: "tizen-8.0",
  /**
   * Tizen 9.0 (2025)
   *
   * The browser on this platform is based on Chromium (version unspecified) according to Samsung.
   *
   * @see https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
   */
  Tizen_9_0: "tizen-9.0",
  /**
   * Sky Q STB, also known as Amidala or ES160
   *
   * Sky has three different devices. The big one, a normal set-top-box format, is the Sky Q.
   *
   * We do not know the exact version of the browser on this platform.
   * According to the user agent it seems to be based on Chromium 56 or similar.
   *
   * We force the dash.js player on this platform, because the Bitmovin player has a multitude of issues,
   * ranging from excessive buffering, memory leaks, to not playing at all.
   *
   * @see https://www.sky.de/produkte/sky-q
   */
  Skyq: "skyq",
  /**
   * Sky XiOne STB
   *
   * This may be also be called Xi1 or Q IPTV Box.
   *
   * Sky has three different devices. The small one and two slim square boxes, these are the Sky Stream and
   * XiOne. From the outside, they aren't distinguishable, just through details. Like the small button
   * at the bottom showing an on-off sign for the Sky Stream and two arrows on the XiOne.
   *
   * We do not know the exact version of the browser on this platform.
   * According to the user agent it seems to be based on WebKit, WPE specifically, in version 601.1.
   *
   * This platform does not force dash.js, because it seems to work fine with the Bitmovin player.
   *
   * Even though this is also a Sky device, even called Sky Q IPTV according to Sky,
   * this platform is fundamentally different from the Sky Q.
   *
   * @see https://www.sky.de/produkte/sky-q
   */
  Skyxione: "skyxione",
  /**
   * Sky Stream STB
   *
   * Sky has three different devices. The small one and two slim square boxes, these are the Sky Stream and
   * XiOne. From the outside, they aren't distinguishable, just through details. Like the small button
   * at the bottom showing an on-off sign for the Sky Stream and two arrows on the XiOne.
   *
   * :::caution
   * This device is not auto detectable. You have to set it manually if you want to use it.
   *
   * Sky Q and Sky XiOne use different hardware with unique user agents.
   * Sky Stream reuses the same hardware as the XiOne, but with different software.
   * Unfortunately to our knowledge, the user agent is the same for the XiOne and the Stream,
   * thus we cannot distinguish between the two.
   * :::
   */
  Skystream: "skystream",
  /**
   * Magenta G4 STB
   *
   * They have the same form factor and design as the Magenta G3.9.
   * The device designations are usually MR201, MR401 and MR601.
   *
   * The devices are fundamentally different from the Magenta G3.9.
   * The browser is roughly equal to a Safari 11.1. According to the specs it is based on WebKit.
   *
   * This is the oldest generation of Magenta devices we currently support.
   *
   * We force the dash.js player on this platform, because the Bitmovin player has a multitude of issues,
   * ranging from excessive buffering to not playing at all.
   * The Telekom also suggests to use the dash.js player on this platform.
   */
  Magenta_G4: "magenta-g4",
  /**
   * Magenta G5 STB
   *
   * They look distinctly different in comparison to the G4 devices.
   * The device designations are usually MRG5.
   *
   * G5 devices come in two form factors. A small square box and a slim box.
   * The slim G5 devices do not have a separate hard drive slot, but also perform worse.
   * According to Telekom this should not be the case, but we have observed this in practice.
   *
   * The browser is roughly equal to a Safari 11.1. According to the specs it is based on WebKit.
   * The G4 and G5 devices use the same browser, but the G5 devices have better hardware and thus perform better.
   *
   * We force the dash.js player on this platform, because the Bitmovin player has a multitude of issues,
   * ranging from excessive buffering to not playing at all.
   * The Telekom also suggests to use the dash.js player on this platform.
   */
  Magenta_G5: "magenta-g5",
  /**
   * Vodafone GTV STB
   *
   * This is the oldest generation of Vodafone devices we currently support.
   *
   * The browser is roughly similar to a Safari 9 according to our testing.
   *
   * This platform does not support a lot of DOM features and thus uses Canvas for rendering.
   * This also limits our abilities to debug issues on this platform and what features we can support.
   *
   * One of the most notable changes is that we do not use two video elements on this platform,
   * but instead force ads to play in the same video element as the content.
   *
   * We force the dash.js player on this platform, because the Bitmovin player does not even start properly most of the time.
   */
  Vodafone_Gtv: "vodafone-gtv",
  /**
   * Vodafone VTV STB
   *
   * The browser is roughly similar to Opera 36 according to our testing and communication with Vodafone.
   *
   * The devices are fundamentally different from the Vodafone GTV.
   * Unlike the Vodafone GTV, this platform supports normal DOM features.
   *
   * We force the dash.js player on this platform, because the dash.js player has better performance on this platform.
   */
  Vodafone_Vtv: "vodafone-vtv",
  /**
   * Chromecast 2nd Gen and later
   *
   * This is meant for second generation Chromecasts and newer as well as Chrome with Google TV.
   * In general this should be explicitly set, because the detection is not always reliable.
   *
   * We force a custom player on this platform, which will use Chromecast CAF v3 for the playback.
   */
  Chromecast: "chromecast",
  /**
   * TeleColumbus PYUR STB
   *
   * TeleColumbus is an Android TV set-top-box, but RTL+ uses a HTML5 app on it.
   *
   * The deployed Android app integrates modern Chrome browser to facilitate the HTML5 app.
   */
  Telecolumbus: "telecolumbus",
  /**
   * Amazon Kepler
   *
   * Kepler uses React Native and is a new platform from Amazon.
   *
   * We only support the WebView mode for Kepler.
   */
  Kepler: "kepler"
};
var UserType = {
  /**
   * The user is not logged in and is therefore anonymous.
   */
  Anonymous: "anonymous",
  /**
   * The user is logged in and uses an account without a subscription.
   */
  Free: "free",
  /**
   * The user is logged in and is a premium user.
   */
  Pay: "pay"
};
var Environment = {
  /**
   * For production use.
   */
  Prod: "prod",
  /**
   * For staging environments which closely resemble production.
   */
  Preprod: "preprod",
  /**
   * For development environments which are only used for testing purposes.
   */
  Dev: "dev"
};
var ContentType = {
  /**
   * Regular video on demand content with a fixed duration.
   */
  Vod: "vod",
  /**
   * A livestream which is running 24/7
   *
   * Technically this is the same as a regular livestream that is running for an indefinite amount of time.
   * In the context of RTL this is used for normal TV channels.
   * In this context the player has to behave differently than for an event livestream.
   * Specifically we may have to cap the bitrate for certain devices, because the streams are different and send other analytics data.
   *
   * Because the stream is running an indefinite amount of time, some features like post-roll ads are not possible.
   */
  Live: "live",
  /**
   * A livestreams with a scheduled start and end date.
   *
   * Technically this is the same as a regular livestream on other streaming platforms.
   *
   * In the context of RTL this is used for special events like football games, music events, etc.
   * In this context the player has to behave differently than for a live-tv livestream.
   * Specifically we may have to cap the bitrate for certain devices, because the streams are different and send other analytics data.
   *
   * The most important difference for the client is, that the player can also play post-roll ads for event livestreams,
   * and emit events when the content and session ends.
   */
  Event: "event",
  /**
   * A livestream that is running 24/7 with advertising.
   *
   * FAST is the acronym for "Free Ad-Supported Streaming TV".
   */
  Fast: "fast",
  /**
   * Written content which is read to the user.
   */
  Text_To_Speech: "text-to-speech",
  /**
   * A podcast episode.
   */
  Podcast: "podcast",
  /**
   * An audiobook chapter.
   */
  Audiobook: "audiobook",
  /**
   * A radio live stream that is running 24/7
   */
  Radio: "radio",
  /**
   * This playback will only contain advertisements.
   * This can be the case if the player is used before or during html5 games to show ads.
   */
  Advertisement: "advertisement"
};

// src/_internal/dom/find-video-element.ts
function findVideoElement(mountPoint) {
  return mountPoint.querySelector("video") || void 0;
}

// src/_internal/platform-check/vendor/ua-parser.ts
var UAParser = function(ua, extensions) {
  const EMPTY = "";
  const UNKNOWN = "?";
  const FUNC_TYPE = "function";
  const UNDEF_TYPE = "undefined";
  const OBJ_TYPE = "object";
  const STR_TYPE = "string";
  const MAJOR = "major";
  const MODEL = "model";
  const NAME = "name";
  const TYPE = "type";
  const VENDOR = "vendor";
  const VERSION = "version";
  const ARCHITECTURE = "architecture";
  const CONSOLE = "console";
  const MOBILE = "mobile";
  const TABLET = "tablet";
  const SMARTTV = "smarttv";
  const WEARABLE = "wearable";
  const EMBEDDED = "embedded";
  const UA_MAX_LENGTH = 500;
  const AMAZON = "Amazon";
  const APPLE = "Apple";
  const ASUS = "ASUS";
  const BLACKBERRY = "BlackBerry";
  const BROWSER = "Browser";
  const CHROME = "Chrome";
  const EDGE = "Edge";
  const FIREFOX = "Firefox";
  const GOOGLE = "Google";
  const HUAWEI = "Huawei";
  const LG = "LG";
  const MICROSOFT = "Microsoft";
  const MOTOROLA = "Motorola";
  const OPERA = "Opera";
  const SAMSUNG = "Samsung";
  const SHARP = "Sharp";
  const SONY = "Sony";
  const XIAOMI = "Xiaomi";
  const ZEBRA = "Zebra";
  const FACEBOOK = "Facebook";
  const CHROMIUM_OS = "Chromium OS";
  const MAC_OS = "Mac OS";
  const extend = (regexes2, extensions2) => {
    const mergedRegexes = {};
    for (const i in regexes2) {
      if (extensions2[i] && extensions2[i].length % 2 === 0) {
        mergedRegexes[i] = extensions2[i].concat(regexes2[i]);
      } else {
        mergedRegexes[i] = regexes2[i];
      }
    }
    return mergedRegexes;
  };
  const enumerize = (arr) => {
    const enums = {};
    for (let i = 0; i < arr.length; i++) {
      enums[arr[i].toUpperCase()] = arr[i];
    }
    return enums;
  };
  const has = (str1, str2) => typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
  const lowerize = (str) => str.toLowerCase();
  const majorize = (version) => typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : void 0;
  const trim = (str, len) => {
    if (typeof str === STR_TYPE) {
      str = str.replace(/^\s\s*/, EMPTY);
      return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
    }
  };
  const rgxMapper = function(ua2, arrays) {
    let i = 0;
    let j;
    let k;
    let p;
    let q;
    let matches;
    let match;
    while (i < arrays.length && !matches) {
      const regex = arrays[i];
      const props = arrays[i + 1];
      j = k = 0;
      while (j < regex.length && !matches) {
        if (!regex[j]) {
          break;
        }
        matches = regex[j++].exec(ua2);
        if (matches) {
          for (p = 0; p < props.length; p++) {
            match = matches[++k];
            q = props[p];
            if (typeof q === OBJ_TYPE && q.length > 0) {
              if (q.length === 2) {
                if (typeof q[1] === FUNC_TYPE) {
                  this[q[0]] = q[1].call(this, match);
                } else {
                  this[q[0]] = q[1];
                }
              } else if (q.length === 3) {
                if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                  this[q[0]] = match ? q[1].call(this, match, q[2]) : void 0;
                } else {
                  this[q[0]] = match ? match.replace(q[1], q[2]) : void 0;
                }
              } else if (q.length === 4) {
                this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : void 0;
              }
            } else {
              this[q] = match ? match : void 0;
            }
          }
        }
      }
      i += 2;
    }
  };
  const strMapper = (str, map) => {
    for (const i in map) {
      if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
        for (let j = 0; j < map[i].length; j++) {
          if (has(map[i][j], str)) {
            return i === UNKNOWN ? void 0 : i;
          }
        }
      } else if (has(map[i], str)) {
        return i === UNKNOWN ? void 0 : i;
      }
    }
    return str;
  };
  const oldSafariMap = {
    "1.0": "/8",
    "1.2": "/1",
    "1.3": "/3",
    "2.0": "/412",
    "2.0.2": "/416",
    "2.0.3": "/417",
    "2.0.4": "/419",
    "?": "/"
  };
  const windowsVersionMap = {
    ME: "4.90",
    "NT 3.11": "NT3.51",
    "NT 4.0": "NT4.0",
    "2000": "NT 5.0",
    XP: ["NT 5.1", "NT 5.2"],
    Vista: "NT 6.0",
    "7": "NT 6.1",
    "8": "NT 6.2",
    "8.1": "NT 6.3",
    "10": ["NT 6.4", "NT 10.0"],
    RT: "ARM"
  };
  const regexes = {
    browser: [
      [
        /\b(?:crmo|crios)\/([\w\.]+)/i
        // Chrome for Android/iOS
      ],
      [VERSION, [NAME, "Chrome"]],
      [
        /edg(?:e|ios|a)?\/([\w\.]+)/i
        // Microsoft Edge
      ],
      [VERSION, [NAME, "Edge"]],
      [
        // Presto based
        /(opera mini)\/([-\w\.]+)/i,
        // Opera Mini
        /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
        // Opera Mobi/Tablet
        /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        // Opera
      ],
      [NAME, VERSION],
      [
        /opios[\/ ]+([\w\.]+)/i
        // Opera mini on iphone >= 8.0
      ],
      [VERSION, [NAME, `${OPERA} Mini`]],
      [
        /\bop(?:rg)?x\/([\w\.]+)/i
        // Opera GX
      ],
      [VERSION, [NAME, `${OPERA} GX`]],
      [
        /\bopr\/([\w\.]+)/i
        // Opera Webkit
      ],
      [VERSION, [NAME, OPERA]],
      [
        // Mixed
        /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
        // Baidu
      ],
      [VERSION, [NAME, "Baidu"]],
      [
        /(kindle)\/([\w\.]+)/i,
        // Kindle
        /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
        // Lunascape/Maxthon/Netfront/Jasmine/Blazer
        // Trident based
        /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
        // Avant/IEMobile/SlimBrowser
        /(?:ms|\()(ie) ([\w\.]+)/i,
        // Internet Explorer
        // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
        /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
        // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
        /(heytap|ovi)browser\/([\d\.]+)/i,
        // Heytap/Ovi
        /(weibo)__([\d\.]+)/i
        // Weibo
      ],
      [NAME, VERSION],
      [
        /\bddg\/([\w\.]+)/i
        // DuckDuckGo
      ],
      [VERSION, [NAME, "DuckDuckGo"]],
      [
        /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
        // UCBrowser
      ],
      [VERSION, [NAME, `UC${BROWSER}`]],
      [
        /microm.+\bqbcore\/([\w\.]+)/i,
        // WeChat Desktop for Windows Built-in Browser
        /\bqbcore\/([\w\.]+).+microm/i,
        /micromessenger\/([\w\.]+)/i
        // WeChat
      ],
      [VERSION, [NAME, "WeChat"]],
      [
        /konqueror\/([\w\.]+)/i
        // Konqueror
      ],
      [VERSION, [NAME, "Konqueror"]],
      [
        /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
        // IE11
      ],
      [VERSION, [NAME, "IE"]],
      [
        /ya(?:search)?browser\/([\w\.]+)/i
        // Yandex
      ],
      [VERSION, [NAME, "Yandex"]],
      [
        /slbrowser\/([\w\.]+)/i
        // Smart Lenovo Browser
      ],
      [VERSION, [NAME, `Smart Lenovo ${BROWSER}`]],
      [
        /(avast|avg)\/([\w\.]+)/i
        // Avast/AVG Secure Browser
      ],
      [[NAME, /(.+)/, `$1 Secure ${BROWSER}`], VERSION],
      [
        /\bfocus\/([\w\.]+)/i
        // Firefox Focus
      ],
      [VERSION, [NAME, `${FIREFOX} Focus`]],
      [
        /\bopt\/([\w\.]+)/i
        // Opera Touch
      ],
      [VERSION, [NAME, `${OPERA} Touch`]],
      [
        /coc_coc\w+\/([\w\.]+)/i
        // Coc Coc Browser
      ],
      [VERSION, [NAME, "Coc Coc"]],
      [
        /dolfin\/([\w\.]+)/i
        // Dolphin
      ],
      [VERSION, [NAME, "Dolphin"]],
      [
        /coast\/([\w\.]+)/i
        // Opera Coast
      ],
      [VERSION, [NAME, `${OPERA} Coast`]],
      [
        /miuibrowser\/([\w\.]+)/i
        // MIUI Browser
      ],
      [VERSION, [NAME, `MIUI ${BROWSER}`]],
      [
        /fxios\/([-\w\.]+)/i
        // Firefox for iOS
      ],
      [VERSION, [NAME, FIREFOX]],
      [
        /\bqihu|(qi?ho?o?|360)browser/i
        // 360
      ],
      [[NAME, `360 ${BROWSER}`]],
      [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i],
      [[NAME, /(.+)/, `$1 ${BROWSER}`], VERSION],
      [
        // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
        /samsungbrowser\/([\w\.]+)/i
        // Samsung Internet
      ],
      [VERSION, [NAME, `${SAMSUNG} Internet`]],
      [
        /(comodo_dragon)\/([\w\.]+)/i
        // Comodo Dragon
      ],
      [[NAME, /_/g, " "], VERSION],
      [
        /metasr[\/ ]?([\d\.]+)/i
        // Sogou Explorer
      ],
      [VERSION, [NAME, "Sogou Explorer"]],
      [
        /(sogou)mo\w+\/([\d\.]+)/i
        // Sogou Mobile
      ],
      [[NAME, "Sogou Mobile"], VERSION],
      [
        /(electron)\/([\w\.]+) safari/i,
        // Electron-based App
        /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
        // Tesla
        /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
        // QQBrowser/2345 Browser
      ],
      [NAME, VERSION],
      [
        /(lbbrowser)/i,
        // LieBao Browser
        /\[(linkedin)app\]/i
        // LinkedIn App for iOS & Android
      ],
      [NAME],
      [
        // WebView
        /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
        // Facebook App for iOS & Android
      ],
      [[NAME, FACEBOOK], VERSION],
      [
        /(Klarna)\/([\w\.]+)/i,
        // Klarna Shopping Browser for iOS & Android
        /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
        // Kakao App
        /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
        // Naver InApp
        /safari (line)\/([\w\.]+)/i,
        // Line App for iOS
        /\b(line)\/([\w\.]+)\/iab/i,
        // Line App for Android
        /(alipay)client\/([\w\.]+)/i,
        // Alipay
        /(twitter)(?:and| f.+e\/([\w\.]+))/i,
        // Twitter
        /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
        // Chromium/Instagram/Snapchat
      ],
      [NAME, VERSION],
      [
        /\bgsa\/([\w\.]+) .*safari\//i
        // Google Search Appliance on iOS
      ],
      [VERSION, [NAME, "GSA"]],
      [
        /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
        // TikTok
      ],
      [VERSION, [NAME, "TikTok"]],
      [
        /headlesschrome(?:\/([\w\.]+)| )/i
        // Chrome Headless
      ],
      [VERSION, [NAME, `${CHROME} Headless`]],
      [
        / wv\).+(chrome)\/([\w\.]+)/i
        // Chrome WebView
      ],
      [[NAME, `${CHROME} WebView`], VERSION],
      [
        /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
        // Android Browser
      ],
      [VERSION, [NAME, `Android ${BROWSER}`]],
      [
        /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
        // Chrome/OmniWeb/Arora/Tizen/Nokia
      ],
      [NAME, VERSION],
      [
        /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
        // Mobile Safari
      ],
      [VERSION, [NAME, "Mobile Safari"]],
      [
        /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
        // Safari & Safari Mobile
      ],
      [VERSION, NAME],
      [
        /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
        // Safari < 3.0
      ],
      [NAME, [VERSION, strMapper, oldSafariMap]],
      [/(webkit|khtml)\/([\w\.]+)/i],
      [NAME, VERSION],
      [
        // Gecko based
        /(navigator|netscape\d?)\/([-\w\.]+)/i
        // Netscape
      ],
      [[NAME, "Netscape"], VERSION],
      [
        /mobile vr; rv:([\w\.]+)\).+firefox/i
        // Firefox Reality
      ],
      [VERSION, [NAME, `${FIREFOX} Reality`]],
      [
        /ekiohf.+(flow)\/([\w\.]+)/i,
        // Flow
        /(swiftfox)/i,
        // Swiftfox
        /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
        // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
        /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
        // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
        /(firefox)\/([\w\.]+)/i,
        // Other Firefox-based
        /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
        // Mozilla
        // Other
        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
        // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
        /(links) \(([\w\.]+)/i,
        // Links
        /panasonic;(viera)/i
        // Panasonic Viera
      ],
      [NAME, VERSION],
      [
        /(cobalt)\/([\w\.]+)/i
        // Cobalt
      ],
      [NAME, [VERSION, /master.|lts./, ""]]
    ],
    cpu: [
      [
        /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
        // AMD64 (x64)
      ],
      [[ARCHITECTURE, "amd64"]],
      [
        /(ia32(?=;))/i
        // IA32 (quicktime)
      ],
      [[ARCHITECTURE, lowerize]],
      [
        /((?:i[346]|x)86)[;\)]/i
        // IA32 (x86)
      ],
      [[ARCHITECTURE, "ia32"]],
      [
        /\b(aarch64|arm(v?8e?l?|_?64))\b/i
        // ARM64
      ],
      [[ARCHITECTURE, "arm64"]],
      [
        /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
        // ARMHF
      ],
      [[ARCHITECTURE, "armhf"]],
      [
        // PocketPC mistakenly identified as PowerPC
        /windows (ce|mobile); ppc;/i
      ],
      [[ARCHITECTURE, "arm"]],
      [
        /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
        // PowerPC
      ],
      [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
      [
        /(sun4\w)[;\)]/i
        // SPARC
      ],
      [[ARCHITECTURE, "sparc"]],
      [
        /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ],
      [[ARCHITECTURE, lowerize]]
    ],
    device: [
      [
        //////////////////////////
        // MOBILES & TABLETS
        /////////////////////////
        // Samsung
        /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
      ],
      [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
      [
        /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
        /samsung[- ]([-\w]+)/i,
        /sec-(sgh\w+)/i
      ],
      [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
      [
        // Apple
        /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
        // iPod/iPhone
      ],
      [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
      [
        /\((ipad);[-\w\),; ]+apple/i,
        // iPad
        /applecoremedia\/[\w\.]+ \((ipad)/i,
        /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
      ],
      [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
      [/(macintosh);/i],
      [MODEL, [VENDOR, APPLE]],
      [
        // Sharp
        /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
      ],
      [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
      [
        // Huawei
        /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
      ],
      [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
      [
        /(?:huawei|honor)([-\w ]+)[;\)]/i,
        /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
      ],
      [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
      [
        // Xiaomi
        /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
        // Xiaomi POCO
        /\b; (\w+) build\/hm\1/i,
        // Xiaomi Hongmi 'numeric' models
        /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
        // Xiaomi Hongmi
        /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
        // Xiaomi Redmi
        /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
        // Xiaomi Redmi 'numeric' models
        /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
        // Xiaomi Mi
      ],
      [
        [MODEL, /_/g, " "],
        [VENDOR, XIAOMI],
        [TYPE, MOBILE]
      ],
      [
        /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
        // Redmi Pad
        /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
        // Mi Pad tablets
      ],
      [
        [MODEL, /_/g, " "],
        [VENDOR, XIAOMI],
        [TYPE, TABLET]
      ],
      [
        // OPPO
        /; (\w+) bui.+ oppo/i,
        /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
      ],
      [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
      [/\b(opd2\d{3}a?) bui/i],
      [MODEL, [VENDOR, "OPPO"], [TYPE, TABLET]],
      [
        // Vivo
        /vivo (\w+)(?: bui|\))/i,
        /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
      ],
      [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
      [
        // Realme
        /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
      ],
      [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
      [
        // Motorola
        /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
        /\bmot(?:orola)?[- ](\w*)/i,
        /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
      ],
      [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
      [/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
      [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
      [
        // LG
        /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
      ],
      [MODEL, [VENDOR, LG], [TYPE, TABLET]],
      [
        /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
        /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
        /\blg-?([\d\w]+) bui/i
      ],
      [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
      [
        // Lenovo
        /(ideatab[-\w ]+)/i,
        /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
      ],
      [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
      [
        // Nokia
        /(?:maemo|nokia).*(n900|lumia \d+)/i,
        /nokia[-_ ]?([-\w\.]*)/i
      ],
      [
        [MODEL, /_/g, " "],
        [VENDOR, "Nokia"],
        [TYPE, MOBILE]
      ],
      [
        // Google
        /(pixel c)\b/i
        // Google Pixel C
      ],
      [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
      [
        /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
        // Google Pixel
      ],
      [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
      [
        // Sony
        /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
      ],
      [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
      [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
      [
        [MODEL, "Xperia Tablet"],
        [VENDOR, SONY],
        [TYPE, TABLET]
      ],
      [
        // OnePlus
        / (kb2005|in20[12]5|be20[12][59])\b/i,
        /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
      ],
      [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
      [
        // Amazon
        /(alexa)webm/i,
        /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
        // Kindle Fire without Silk / Echo Show
        /(kf[a-z]+)( bui|\)).+silk\//i
        // Kindle Fire HD
      ],
      [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
      [
        /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
        // Fire Phone
      ],
      [
        [MODEL, /(.+)/g, "Fire Phone $1"],
        [VENDOR, AMAZON],
        [TYPE, MOBILE]
      ],
      [
        // BlackBerry
        /(playbook);[-\w\),; ]+(rim)/i
        // BlackBerry PlayBook
      ],
      [MODEL, VENDOR, [TYPE, TABLET]],
      [
        /\b((?:bb[a-f]|st[hv])100-\d)/i,
        /\(bb10; (\w+)/i
        // BlackBerry 10
      ],
      [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
      [
        // Asus
        /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
      ],
      [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
      [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
      [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
      [
        // HTC
        /(nexus 9)/i
        // HTC Nexus 9
      ],
      [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
      [
        /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
        // HTC
        // ZTE
        /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
        /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
        // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ],
      [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
      [
        // Acer
        /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
      ],
      [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
      [
        // Meizu
        /droid.+; (m[1-5] note) bui/i,
        /\bmz-([-\w]{2,})/i
      ],
      [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
      [
        // Ulefone
        /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
      ],
      [MODEL, [VENDOR, "Ulefone"], [TYPE, MOBILE]],
      [
        // MIXED
        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
        // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
        /(hp) ([\w ]+\w)/i,
        // HP iPAQ
        /(asus)-?(\w+)/i,
        // Asus
        /(microsoft); (lumia[\w ]+)/i,
        // Microsoft Lumia
        /(lenovo)[-_ ]?([-\w]+)/i,
        // Lenovo
        /(jolla)/i,
        // Jolla
        /(oppo) ?([\w ]+) bui/i
        // OPPO
      ],
      [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /(kobo)\s(ereader|touch)/i,
        // Kobo
        /(archos) (gamepad2?)/i,
        // Archos
        /(hp).+(touchpad(?!.+tablet)|tablet)/i,
        // HP TouchPad
        /(kindle)\/([\w\.]+)/i,
        // Kindle
        /(nook)[\w ]+build\/(\w+)/i,
        // Nook
        /(dell) (strea[kpr\d ]*[\dko])/i,
        // Dell Streak
        /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
        // Le Pan Tablets
        /(trinity)[- ]*(t\d{3}) bui/i,
        // Trinity Tablets
        /(gigaset)[- ]+(q\w{1,9}) bui/i,
        // Gigaset Tablets
        /(vodafone) ([\w ]+)(?:\)| bui)/i
        // Vodafone
      ],
      [VENDOR, MODEL, [TYPE, TABLET]],
      [
        /(surface duo)/i
        // Surface Duo
      ],
      [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
      [
        /droid [\d\.]+; (fp\du?)(?: b|\))/i
        // Fairphone
      ],
      [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
      [
        /(u304aa)/i
        // AT&T
      ],
      [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
      [
        /\bsie-(\w*)/i
        // Siemens
      ],
      [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
      [
        /\b(rct\w+) b/i
        // RCA Tablets
      ],
      [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
      [
        /\b(venue[\d ]{2,7}) b/i
        // Dell Venue Tablets
      ],
      [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
      [
        /\b(q(?:mv|ta)\w+) b/i
        // Verizon Tablet
      ],
      [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
      [
        /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
        // Barnes & Noble Tablet
      ],
      [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
      [/\b(tm\d{3}\w+) b/i],
      [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
      [
        /\b(k88) b/i
        // ZTE K Series Tablet
      ],
      [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
      [
        /\b(nx\d{3}j) b/i
        // ZTE Nubia
      ],
      [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
      [
        /\b(gen\d{3}) b.+49h/i
        // Swiss GEN Mobile
      ],
      [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
      [
        /\b(zur\d{3}) b/i
        // Swiss ZUR Tablet
      ],
      [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
      [
        /\b((zeki)?tb.*\b) b/i
        // Zeki Tablets
      ],
      [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
      [
        /\b([yr]\d{2}) b/i,
        /\b(dragon[- ]+touch |dt)(\w{5}) b/i
        // Dragon Touch Tablet
      ],
      [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
      [
        /\b(ns-?\w{0,9}) b/i
        // Insignia Tablets
      ],
      [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
      [
        /\b((nxa|next)-?\w{0,9}) b/i
        // NextBook Tablets
      ],
      [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
      [
        /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
        // Voice Xtreme Phones
      ],
      [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
      [
        /\b(lvtel\-)?(v1[12]) b/i
        // LvTel Phones
      ],
      [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
      [
        /\b(ph-1) /i
        // Essential PH-1
      ],
      [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
      [
        /\b(v(100md|700na|7011|917g).*\b) b/i
        // Envizen Tablets
      ],
      [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
      [
        /\b(trio[-\w\. ]+) b/i
        // MachSpeed Tablets
      ],
      [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
      [
        /\btu_(1491) b/i
        // Rotor Tablets
      ],
      [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
      [
        /(shield[\w ]+) b/i
        // Nvidia Shield Tablets
      ],
      [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
      [
        /(sprint) (\w+)/i
        // Sprint Phones
      ],
      [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /(kin\.[onetw]{3})/i
        // Microsoft Kin
      ],
      [
        [MODEL, /\./g, " "],
        [VENDOR, MICROSOFT],
        [TYPE, MOBILE]
      ],
      [
        /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
        // Zebra
      ],
      [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
      [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
      [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
      [
        ///////////////////
        // SMARTTVS
        ///////////////////
        /smart-tv.+(samsung)/i
        // Samsung
      ],
      [VENDOR, [TYPE, SMARTTV]],
      [/hbbtv.+maple;(\d+)/i],
      [
        [MODEL, /^/, "SmartTV"],
        [VENDOR, SAMSUNG],
        [TYPE, SMARTTV]
      ],
      [
        /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
        // LG SmartTV
      ],
      [
        [VENDOR, LG],
        [TYPE, SMARTTV]
      ],
      [
        /(apple) ?tv/i
        // Apple TV
      ],
      [VENDOR, [MODEL, `${APPLE} TV`], [TYPE, SMARTTV]],
      [
        /crkey/i
        // Google Chromecast
      ],
      [
        [MODEL, `${CHROME}cast`],
        [VENDOR, GOOGLE],
        [TYPE, SMARTTV]
      ],
      [
        /droid.+aft(\w+)( bui|\))/i
        // Fire TV
      ],
      [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
      [
        /\(dtv[\);].+(aquos)/i,
        /(aquos-tv[\w ]+)\)/i
        // Sharp
      ],
      [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
      [
        /(bravia[\w ]+)( bui|\))/i
        // Sony
      ],
      [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
      [
        /(mitv-\w{5}) bui/i
        // Xiaomi
      ],
      [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
      [
        /Hbbtv.*(technisat) (.*);/i
        // TechniSAT
      ],
      [VENDOR, MODEL, [TYPE, SMARTTV]],
      [
        /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
        // Roku
        /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
        // HbbTV devices
      ],
      [
        [VENDOR, trim],
        [MODEL, trim],
        [TYPE, SMARTTV]
      ],
      [
        /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        // SmartTV from Unidentified Vendors
      ],
      [[TYPE, SMARTTV]],
      [
        ///////////////////
        // CONSOLES
        ///////////////////
        /(ouya)/i,
        // Ouya
        /(nintendo) ([wids3utch]+)/i
        // Nintendo
      ],
      [VENDOR, MODEL, [TYPE, CONSOLE]],
      [
        /droid.+; (shield) bui/i
        // Nvidia
      ],
      [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
      [
        /(playstation [345portablevi]+)/i
        // Playstation
      ],
      [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
      [
        /\b(xbox(?: one)?(?!; xbox))[\); ]/i
        // Microsoft Xbox
      ],
      [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
      [
        ///////////////////
        // WEARABLES
        ///////////////////
        /((pebble))app/i
        // Pebble
      ],
      [VENDOR, MODEL, [TYPE, WEARABLE]],
      [
        /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
        // Apple Watch
      ],
      [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
      [
        /droid.+; (glass) \d/i
        // Google Glass
      ],
      [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
      [/droid.+; (wt63?0{2,3})\)/i],
      [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
      [
        /(quest( \d| pro)?)/i
        // Oculus Quest
      ],
      [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
      [
        ///////////////////
        // EMBEDDED
        ///////////////////
        /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
        // Tesla
      ],
      [VENDOR, [TYPE, EMBEDDED]],
      [
        /(aeobc)\b/i
        // Echo Dot
      ],
      [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
      [
        ////////////////////
        // MIXED (GENERIC)
        ///////////////////
        /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
        // Android Phones from Unidentified Vendors
      ],
      [MODEL, [TYPE, MOBILE]],
      [
        /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
        // Android Tablets from Unidentified Vendors
      ],
      [MODEL, [TYPE, TABLET]],
      [
        /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
        // Unidentifiable Tablet
      ],
      [[TYPE, TABLET]],
      [
        /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
        // Unidentifiable Mobile
      ],
      [[TYPE, MOBILE]],
      [
        /(android[-\w\. ]{0,9});.+buil/i
        // Generic Android Device
      ],
      [MODEL, [VENDOR, "Generic"]]
    ],
    engine: [
      [
        /windows.+ edge\/([\w\.]+)/i
        // EdgeHTML
      ],
      [VERSION, [NAME, `${EDGE}HTML`]],
      [
        /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
        // Blink
      ],
      [VERSION, [NAME, "Blink"]],
      [
        /(presto)\/([\w\.]+)/i,
        // Presto
        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
        // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
        /ekioh(flow)\/([\w\.]+)/i,
        // Flow
        /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
        // KHTML/Tasman/Links
        /(icab)[\/ ]([23]\.[\d\.]+)/i,
        // iCab
        /\b(libweb)/i
      ],
      [NAME, VERSION],
      [
        /rv\:([\w\.]{1,9})\b.+(gecko)/i
        // Gecko
      ],
      [VERSION, NAME]
    ],
    os: [
      [
        // Windows
        /microsoft (windows) (vista|xp)/i
        // Windows (iTunes)
      ],
      [NAME, VERSION],
      [
        /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
        // Windows Phone
      ],
      [NAME, [VERSION, strMapper, windowsVersionMap]],
      [
        /windows nt 6\.2; (arm)/i,
        // Windows RT
        /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
        /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
      ],
      [
        [VERSION, strMapper, windowsVersionMap],
        [NAME, "Windows"]
      ],
      [
        // iOS/macOS
        /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
        // iOS
        /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
        /cfnetwork\/.+darwin/i
      ],
      [
        [VERSION, /_/g, "."],
        [NAME, "iOS"]
      ],
      [
        /(mac os x) ?([\w\. ]*)/i,
        /(macintosh|mac_powerpc\b)(?!.+haiku)/i
        // Mac OS
      ],
      [
        [NAME, MAC_OS],
        [VERSION, /_/g, "."]
      ],
      [
        // Mobile OSes
        /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
        // Android-x86/HarmonyOS
      ],
      [VERSION, NAME],
      [
        // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
        /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
        /(blackberry)\w*\/([\w\.]*)/i,
        // Blackberry
        /(tizen|kaios)[\/ ]([\w\.]+)/i,
        // Tizen/KaiOS
        /\((series40);/i
        // Series 40
      ],
      [NAME, VERSION],
      [
        /\(bb(10);/i
        // BlackBerry 10
      ],
      [VERSION, [NAME, BLACKBERRY]],
      [
        /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
        // Symbian
      ],
      [VERSION, [NAME, "Symbian"]],
      [
        /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
        // Firefox OS
      ],
      [VERSION, [NAME, `${FIREFOX} OS`]],
      [
        /web0s;.+rt(tv)/i,
        /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
        // WebOS
      ],
      [VERSION, [NAME, "webOS"]],
      [
        /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
        // watchOS
      ],
      [VERSION, [NAME, "watchOS"]],
      [
        // Google Chromecast
        /crkey\/([\d\.]+)/i
        // Google Chromecast
      ],
      [VERSION, [NAME, `${CHROME}cast`]],
      [
        /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
        // Chromium OS
      ],
      [[NAME, CHROMIUM_OS], VERSION],
      [
        // Smart TVs
        /panasonic;(viera)/i,
        // Panasonic Viera
        /(netrange)mmh/i,
        // Netrange
        /(nettv)\/(\d+\.[\w\.]+)/i,
        // NetTV
        // Console
        /(nintendo|playstation) ([wids345portablevuch]+)/i,
        // Nintendo/Playstation
        /(xbox); +xbox ([^\);]+)/i,
        // Microsoft Xbox (360, One, X, S, Series X, Series S)
        // Other
        /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
        // Joli/Palm
        /(mint)[\/\(\) ]?(\w*)/i,
        // Mint
        /(mageia|vectorlinux)[; ]/i,
        // Mageia/VectorLinux
        /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
        // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
        /(hurd|linux) ?([\w\.]*)/i,
        // Hurd/Linux
        /(gnu) ?([\w\.]*)/i,
        // GNU
        /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
        // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
        /(haiku) (\w+)/i
        // Haiku
      ],
      [NAME, VERSION],
      [
        /(sunos) ?([\w\.\d]*)/i
        // Solaris
      ],
      [[NAME, "Solaris"], VERSION],
      [
        /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
        // Solaris
        /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
        // AIX
        /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
        // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
        /(unix) ?([\w\.]*)/i
        // UNIX
      ],
      [NAME, VERSION]
    ]
  };
  const _navigator = typeof window !== UNDEF_TYPE && window.navigator ? window.navigator : void 0;
  const _uach = _navigator?.userAgentData ? _navigator.userAgentData : void 0;
  const _rgxmap = extensions ? extend(regexes, extensions) : regexes;
  const getUA = () => ua || (_navigator?.userAgent ? _navigator.userAgent : EMPTY);
  const getBrowser = () => {
    const _ua = getUA();
    const _isSelfNav = _navigator && _navigator.userAgent === _ua;
    const _browser = {};
    _browser[NAME] = void 0;
    _browser[VERSION] = void 0;
    rgxMapper.call(_browser, _ua, _rgxmap.browser);
    _browser[MAJOR] = majorize(_browser[VERSION]);
    if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave === FUNC_TYPE) {
      _browser[NAME] = "Brave";
    }
    return _browser;
  };
  const getCPU = () => {
    const _ua = getUA();
    const _cpu = {};
    _cpu[ARCHITECTURE] = void 0;
    rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
    return _cpu;
  };
  const getDevice = () => {
    const _ua = getUA();
    const _isSelfNav = _navigator && _navigator.userAgent === _ua;
    const _device = {};
    _device[VENDOR] = void 0;
    _device[MODEL] = void 0;
    _device[TYPE] = void 0;
    rgxMapper.call(_device, _ua, _rgxmap.device);
    if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
      _device[TYPE] = MOBILE;
    }
    if (_isSelfNav && _device[MODEL] === "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
      _device[MODEL] = "iPad";
      _device[TYPE] = TABLET;
    }
    return _device;
  };
  const getEngine = () => {
    const _ua = getUA();
    const _engine = {};
    _engine[NAME] = void 0;
    _engine[VERSION] = void 0;
    rgxMapper.call(_engine, _ua, _rgxmap.engine);
    return _engine;
  };
  const getOS = () => {
    const _ua = getUA();
    const _isSelfNav = _navigator && _navigator.userAgent === _ua;
    const _os = {};
    _os[NAME] = void 0;
    _os[VERSION] = void 0;
    rgxMapper.call(_os, _ua, _rgxmap.os);
    if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform !== "Unknown") {
      _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
    }
    return _os;
  };
  return {
    getBrowser,
    getCPU,
    getDevice,
    getEngine,
    getOS,
    getUA
  };
};

// src/_internal/platform-check/get-ua-parser.ts
var getUAParser = () => {
  return UAParser();
};

// src/_internal/platform-check/is-sky-q.ts
var isSkyQ = () => getUAParser().getUA().includes("Sky, ES160");

// src/_internal/platform-check/is-sky-stream.ts
var isSkyStream = () => {
  const userAgent = getUAParser().getUA();
  return ["SKXI11AEISODE"].some((identifier) => userAgent.includes(identifier));
};

// src/_internal/platform-check/is-sky-xione.ts
var isSkyXiOne = () => {
  const userAgent = getUAParser().getUA();
  return ["Sky, XiOne", "Sky, ES340", "SKXI11AIS"].some(
    (identifier) => userAgent.includes(identifier)
  );
};

// src/_internal/platform-check/is-sky-stb.ts
var isSkySTB = () => {
  return isSkyQ() || isSkyXiOne() || isSkyStream();
};

// src/_internal/platform-check/is-kepler.ts
var isKepler = () => {
  const ua = getUAParser().getUA();
  return ua.includes("AFTCA002") || ua.includes("Kepler");
};

// src/_internal/platform-check/get-os-name.ts
var getOSName = () => {
  if (isKepler()) {
    return "Kepler";
  }
  return getUAParser().getOS().name ?? "";
};

// src/_internal/platform-check/is-tizen.ts
var isTizen = () => {
  return ["tizen"].includes(getOSName().toLocaleLowerCase());
};

// src/_internal/platform-check/is-vodafone-gtv.ts
var isVodafoneGTV = () => getUAParser().getUA().includes("Vodafone_Germany_GigaTV_4k_Box");

// src/_internal/platform-check/is-vodafone-vtv.ts
var isVodafoneVTV = () => getUAParser().getUA().includes("VODAFONE_STB");

// src/_internal/platform-check/is-vodafone-stb.ts
var isVodafoneSTB = () => {
  return isVodafoneGTV() || isVodafoneVTV();
};

// src/_internal/platform-check/is-webos.ts
var isWebOS = () => {
  return getOSName().toLocaleLowerCase().includes("webos");
};

// src/_internal/platform-check/get-browser-name.ts
var getBrowserName = () => {
  if (isTizen()) {
    return "Chrome";
  }
  const browser = getUAParser().getBrowser().name || "";
  if (isSkyXiOne() || isSkyStream()) {
    return "WebKit";
  }
  if (browser === "Safari" && (isVodafoneSTB() || isSkySTB() || isWebOS())) {
    return "WebKit";
  }
  return browser || "";
};

// src/_internal/platform-check/get-browser-version.ts
var getBrowserVersion = () => {
  if (isTizen()) {
    return "";
  }
  if (isSkyXiOne() || isSkyStream()) {
    return getUAParser().getUA().match(/Version\/(\d*(?:.\d*)?)/)?.[1] || "";
  }
  return getUAParser().getBrowser().version || "";
};

// src/_internal/platform-check/is-magenta-g4.ts
var isMagentaG4 = () => {
  const userAgent = getUAParser().getUA();
  return ["DT,MR601SAT", "DT,MR401", "DT,MR201"].some(
    (identifier) => userAgent.includes(identifier)
  );
};

// src/_internal/platform-check/is-magenta-g5.ts
var isMagentaG5 = () => getUAParser().getUA().includes("DT,MRG5");

// src/_internal/platform-check/get-device-model.ts
var getDeviceModel = () => {
  const parser = getUAParser();
  const model = parser.getDevice().model;
  if (model) {
    return model;
  }
  switch (true) {
    case isSkyQ():
      return "Q";
    case isSkyXiOne():
      return "XiOne";
    case isSkyStream():
      return "Stream";
    case isMagentaG4():
      return "G4";
    case isMagentaG5():
      return "G5";
    case isVodafoneGTV():
      return "GTV";
    case isVodafoneVTV():
      return "VTV";
    case isTizen():
      return "TV";
    case isWebOS():
      return "TV";
    case isKepler():
      return "Kepler";
    default:
      return "";
  }
};

// src/_internal/platform-check/is-magenta-stb.ts
var isMagentaSTB = () => {
  if (isMagentaG4()) {
    return true;
  }
  if (isMagentaG5()) {
    return true;
  }
  return getUAParser().getUA().includes("DT_STB_BCM72");
};

// src/_internal/platform-check/is-samsung-internet-browser.ts
var isSamsungInternetBrowser = () => {
  return getBrowserName().toLocaleLowerCase().includes("samsung internet");
};

// src/_internal/platform-check/is-telecolumbus-stb.ts
var isTelecolumbusSTB = () => getUAParser().getUA().includes("TeleColumbus");

// src/_internal/platform-check/get-device-vendor.ts
var getDeviceVendor = () => {
  const parser = getUAParser();
  const vendor = parser.getDevice().vendor;
  if (vendor) {
    return vendor;
  }
  switch (true) {
    case isSamsungInternetBrowser():
    case isTizen():
      return "Samsung";
    case isTelecolumbusSTB():
      return "TeleColumbus";
    case isWebOS():
      return "LG";
    case isSkySTB():
      return "Sky";
    case isMagentaSTB():
      return "Telekom";
    case isVodafoneGTV():
    case isVodafoneVTV():
      return "Vodafone";
    case isKepler():
      return "Amazon";
    default:
      return "";
  }
};

// src/_internal/platform-check/get-os-version.ts
var getOSVersion = () => {
  if (isTelecolumbusSTB()) {
    return "";
  }
  if (isKepler()) {
    const osVersionRegex = /; Kepler ([\d.]*);/;
    const match = osVersionRegex.exec(getUAParser().getUA());
    return match ? match[1] : "";
  }
  const osVersion = getUAParser().getOS().version || "";
  if (osVersion.startsWith("armv7")) {
    return "";
  }
  return osVersion;
};

// src/_internal/platform-check/is-android.ts
var isAndroid = () => {
  return getOSName().toLocaleLowerCase().includes("android") || false;
};

// src/_internal/platform-check/is-chromecast.ts
var isChromecast = () => {
  if (window.cast) {
    return true;
  }
  const userAgent = getUAParser().getUA();
  return userAgent.includes("CrKey");
};

// src/_internal/platform-check/is-edge-browser.ts
var isEdgeBrowser = () => {
  return getBrowserName().toLocaleLowerCase().includes("edge");
};

// src/_internal/platform-check/is-ipad.ts
var isIpad = () => {
  return getDeviceModel().toLocaleLowerCase().includes("ipad") || false;
};

// src/_internal/platform-check/is-iphone.ts
var isIphone = () => {
  return getDeviceModel().toLocaleLowerCase().includes("iphone") || false;
};

// src/_internal/platform-check/is-stb.ts
var isSTB = () => {
  return isSkySTB() || isTelecolumbusSTB() || isMagentaSTB() || isVodafoneSTB() || isChromecast() || isKepler();
};

// src/_internal/platform-check/is-tv.ts
var isTV = () => {
  const parser = getUAParser();
  return isWebOS() || isTizen() || isSTB() || isChromecast() || parser.getDevice().type === "smarttv";
};

// src/_internal/platform-check/is-mobile.ts
var isMobile = () => {
  if (isKepler()) {
    return false;
  }
  return getUAParser().getDevice().type === "mobile";
};

// src/_internal/platform-check/is-safari-browser.ts
var isSafariBrowser = () => {
  if (isTV()) {
    return false;
  }
  return getBrowserName().toLocaleLowerCase().includes("safari");
};

// src/_internal/platform-check/is-tablet.ts
var isTablet = () => getUAParser().getDevice().type === "tablet" || isIpad();

// src/_internal/platform-check/is-webkit-engine.ts
var isWebkitEngine = () => {
  if (isTizen()) {
    return false;
  }
  return getUAParser().getEngine().name?.toLocaleLowerCase() === "webkit";
};

// src/_internal/capability/drm-probe.ts
var PLAYREADY_KEY_SYSTEMS = [
  "com.microsoft.playready",
  "com.microsoft.playready.recommendation"
];
var WIDEVINE_KEY_SYSTEMS = ["com.widevine.alpha"];
var FAIRPLAY_KEY_SYSTEMS = ["com.apple.fps.1_0", "com.apple.fps"];
var DrmProbe = class {
  constructor(videoElement, logger) {
    this.videoElement = videoElement;
    this.logger = logger;
    this.keySystems = [
      "org.w3.clearkey",
      // only for completeness but not used currently
      ...WIDEVINE_KEY_SYSTEMS,
      ...PLAYREADY_KEY_SYSTEMS,
      ...FAIRPLAY_KEY_SYSTEMS,
      "com.adobe.primetime"
      // only for completeness but not used currently
    ];
    this.basicVideoCapabilities = [
      { contentType: 'video/mp4; codecs="avc1.42E01E"' },
      { contentType: 'video/webm; codecs="vp8"' }
    ];
    this.basicConfig = {
      initDataTypes: ["cenc"],
      videoCapabilities: this.basicVideoCapabilities
    };
    this.offlineConfig = {
      videoCapabilities: this.basicVideoCapabilities,
      persistentState: "required",
      sessionTypes: ["persistent-license"]
    };
    this.configs = [this.offlineConfig, this.basicConfig];
  }
  static canDetectDRMSupport(_videoElement) {
    return false;
  }
  /**
   * Detect which DRM key systems are supported by the client.
   *
   * @see https://github.com/shaka-project/shaka-player/blob/a3d5dc54ff0e6eacd2af2602037cccabbd525c03/lib/media/drm_engine.js#L1812
   */
  async detectDRMSupport() {
    this.logger.debug(
      "Test drm support with the following media key system configurations",
      this.configs
    );
    const supportedDrmSystems = await Promise.all(
      this.keySystems.map(async (keySystem) => {
        if (keySystem === "org.w3.clearkey" && isSafariBrowser()) {
          this.logger.debug(`Disable "${keySystem}" support for Safari`);
          const support2 = { supported: false };
          return [keySystem, support2];
        }
        this.logger.debug(`Test access support for "${keySystem}"`);
        const support = await this.checkKeySystem(keySystem);
        return [keySystem, support];
      })
    );
    this.logger.debug(
      "Detected drm support for",
      supportedDrmSystems.filter(([_keySystem, support]) => support.supported)
    );
    return Object.fromEntries(supportedDrmSystems);
  }
};
var DRMProbeWithRequestMediaKeySystemAccess = class extends DrmProbe {
  static canDetectDRMSupport(_videoElement) {
    return typeof navigator.requestMediaKeySystemAccess === "function";
  }
  async checkKeySystem(keySystem) {
    let support;
    try {
      this.logger.debug(`Test access support for "${keySystem}"`);
      const access = await navigator.requestMediaKeySystemAccess(keySystem, this.configs);
      const sessionTypes = access.getConfiguration().sessionTypes;
      const persistentState = sessionTypes ? sessionTypes.includes("persistent-license") : false;
      this.logger.debug(`Set preliminary support for "${keySystem}"`);
      support = {
        supported: true,
        persistentState
      };
      this.logger.debug(`Create media keys for "${keySystem}"`);
      await access.createMediaKeys();
    } catch (e) {
      support = {
        supported: false
      };
      this.logger.debug(`Disable support for "${keySystem}"`, e);
    }
    return support;
  }
};
var DRMProbeWithMSMediaKeys = class extends DrmProbe {
  static canDetectDRMSupport(_videoElement) {
    return typeof window.MSMediaKeys !== "undefined";
  }
  checkKeySystem(keySystem) {
    return {
      supported: window.MSMediaKeys?.isTypeSupported(keySystem) || false
    };
  }
};
var DRMProbeWithCanPlayType = class extends DrmProbe {
  static canDetectDRMSupport(videoElement) {
    return "webkitGenerateKeyRequest" in videoElement && typeof videoElement.webkitGenerateKeyRequest === "function";
  }
  checkKeySystem(keySystem) {
    return {
      // Older versions of `canPlayType` accepted the key system as second
      // parameter. This second parameter is deprecated, therefore we get a
      // TypeScript error.
      //
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      supported: Boolean(this.videoElement.canPlayType("video/mp4", keySystem))
    };
  }
};
function drmProbe(videoElement) {
  const logger = getLogger("capability.drmProbe");
  const drmProbeSystems = [
    DRMProbeWithRequestMediaKeySystemAccess,
    DRMProbeWithMSMediaKeys,
    DRMProbeWithCanPlayType
  ];
  const drmProbeSystemClass = drmProbeSystems.find(
    (system) => system.canDetectDRMSupport(videoElement)
  );
  if (!drmProbeSystemClass) {
    logger.warn("No support for checking DRM found");
    return Promise.resolve({});
  }
  const drmProbeSystem = new drmProbeSystemClass(videoElement, logger);
  return drmProbeSystem.detectDRMSupport();
}

// src/_internal/capability/manifest-probe.ts
var DASH_MIME_TYPES = ["application/dash+xml"];
var HLS_MIME_TYPES = ["application/x-mpegurl", "application/vnd.apple.mpegurl"];
function manifestProbe(video) {
  const logger = getLogger("capability.manifestProbe");
  const mimeTypes = [
    ...DASH_MIME_TYPES,
    ...HLS_MIME_TYPES,
    // SmoothStreaming, only for completeness but not used currently
    "application/vnd.ms-sstr+xml"
  ];
  const support = {};
  for (const mimeType of mimeTypes) {
    const result = video.canPlayType(mimeType);
    support[mimeType] = !!result;
    logger.trace(`Test native manifest support for "${mimeType}"`, {
      mimeType,
      supported: result || false
    });
  }
  return support;
}

// src/_internal/capability/media-probe.ts
function mediaProbe(video) {
  const logger = getLogger("capability.mediaProbe");
  const mimeTypes = [
    // MP4 types
    'video/mp4; codecs="avc1.42E01E"',
    'video/mp4; codecs="avc3.42E01E"',
    'video/mp4; codecs="hev1.1.6.L93.90"',
    'video/mp4; codecs="hvc1.1.6.L93.90"',
    'video/mp4; codecs="hev1.2.4.L153.B0"; eotf="smpte2084"',
    // HDR HEVC
    'video/mp4; codecs="hvc1.2.4.L153.B0"; eotf="smpte2084"',
    // HDR HEVC
    'video/mp4; codecs="vp9"',
    'video/mp4; codecs="vp09.00.10.08"',
    'video/mp4; codecs="av01.0.01M.08"',
    'audio/mp4; codecs="mp4a.40.2"',
    'audio/mp4; codecs="ac-3"',
    'audio/mp4; codecs="ec-3"',
    'audio/mp4; codecs="opus"',
    'audio/mp4; codecs="flac"',
    'audio/mp4; codecs="dtsc"',
    // DTS Digital Surround
    'audio/mp4; codecs="dtse"',
    // DTS Express
    'audio/mp4; codecs="dtsx"',
    // DTS:X
    // WebM types
    'video/webm; codecs="vp8"',
    'video/webm; codecs="vp9"',
    'video/webm; codecs="vp09.00.10.08"',
    'audio/webm; codecs="vorbis"',
    'audio/webm; codecs="opus"',
    // MPEG2 TS types (video/ is also used for audio: https://bit.ly/TsMse)
    'video/mp2t; codecs="avc1.42E01E"',
    'video/mp2t; codecs="avc3.42E01E"',
    'video/mp2t; codecs="hvc1.1.6.L93.90"',
    'video/mp2t; codecs="mp4a.40.2"',
    'video/mp2t; codecs="ac-3"',
    'video/mp2t; codecs="ec-3"',
    // WebVTT types
    "text/vtt",
    'application/mp4; codecs="wvtt"',
    // TTML types
    "application/ttml+xml",
    'application/mp4; codecs="stpp"',
    // Containerless types
    "audio/aac",
    "audio/ac3",
    "audio/ec3",
    "audio/mpeg"
  ];
  const support = {};
  for (const mimeType of mimeTypes) {
    const result = video.canPlayType(mimeType);
    support[mimeType] = !!result;
    logger.debug(`Test native media type support for "${mimeType}"`, {
      mimeType,
      supported: result || false
    });
  }
  return support;
}

// src/_internal/capability/detect-client-support.ts
async function detectClientSupport(mountPoint) {
  const isChromecastReceiver = isChromecast();
  if (isChromecastReceiver) {
    return chromecastCapabilities();
  }
  const videoElement = findVideoElement(mountPoint) || document.createElement("video");
  const logger = getLogger("capability.detectClientSupport");
  const manifest = manifestProbe(videoElement);
  const media = mediaProbe(videoElement);
  const drm = await drmProbe(videoElement);
  const capabilities = {
    manifestTypes: [ManifestType.Progressive],
    // devices can always play StreamType.Progressive
    keySystems: []
  };
  const nativeDASHSupport = DASH_MIME_TYPES.filter((mimeType) => manifest[mimeType]);
  if (typeof MediaSource !== "undefined") {
    logger.debug("Add manifestType", {
      manifestType: ManifestType.Dash,
      nativeSupport: nativeDASHSupport
    });
    capabilities.manifestTypes.push(ManifestType.Dash);
  }
  const nativeHLSSupport = HLS_MIME_TYPES.filter((mimeType) => manifest[mimeType]);
  if (isWebkitEngine() && nativeHLSSupport.length > 0) {
    capabilities.manifestTypes.push(ManifestType.Hls);
    logger.debug("Add manifestType", {
      manifestType: ManifestType.Hls,
      nativeSupport: nativeHLSSupport
    });
  }
  const playReadySupport = PLAYREADY_KEY_SYSTEMS.filter(
    (keySystem) => keySystem in drm && drm[keySystem].supported
  );
  if (playReadySupport.length > 0) {
    capabilities.keySystems.push(KeySystem.Playready);
    logger.debug("Add keySystem", {
      keySystem: KeySystem.Playready,
      drmSupport: playReadySupport
    });
  }
  const widevineSupport = WIDEVINE_KEY_SYSTEMS.filter(
    (keySystem) => keySystem in drm && drm[keySystem].supported
  );
  if (widevineSupport.length > 0) {
    capabilities.keySystems.push(KeySystem.Widevine);
    logger.debug("Add keySystem", {
      keySystem: KeySystem.Widevine,
      drmSupport: widevineSupport
    });
  }
  const fairplaySupport = FAIRPLAY_KEY_SYSTEMS.filter(
    (keySystem) => keySystem in drm && drm[keySystem].supported
  );
  if (fairplaySupport.length > 0) {
    capabilities.keySystems.push(KeySystem.Fairplay);
    logger.debug("Add keySystem", {
      keySystem: KeySystem.Fairplay,
      drmSupport: fairplaySupport
    });
  }
  return {
    capabilities,
    manifest,
    media,
    drm
  };
}
function chromecastCapabilities() {
  const capabilities = {
    manifestTypes: [ManifestType.Progressive, ManifestType.Dash],
    keySystems: [KeySystem.Widevine]
  };
  const manifest = {};
  const media = {};
  const drm = {};
  return { capabilities, manifest, media, drm };
}

// src/_internal/debug-interface.ts
var internal_DebugInterface = class {
  constructor(createPlayerOptions) {
    /**
     * The load request provided by the integrator to create the player instance.
     */
    this.providedLoadRequests = [];
    /**
     * The current index of the manifest configurations array.
     *
     * @remarks
     * This is tracked additionally to the current media to avoid unnecessary lookups.
     * This also helps if manifest configuration objects were modified by plugins and the reference is not the same anymore.
     */
    this.currentManifestSourceConfigurationIndex = 0;
    this.providedCreatePlayerOptions = createPlayerOptions;
    this.providedLoadRequests.push(createPlayerOptions.loadRequest);
    this.registerToGlobal();
  }
  registerToGlobal() {
    const foundationWindow = window;
    foundationWindow.foundation ||= {};
    foundationWindow.foundation.internal_DebugInterfaces ||= [];
    foundationWindow.foundation.internal_DebugInterfaces.push(this);
  }
};

// src/_internal/environment/detect-device-type.ts
var detectDeviceType = () => {
  if (isMagentaG5()) {
    return DeviceType.Magenta_G5;
  }
  if (isMagentaG4()) {
    return DeviceType.Magenta_G4;
  }
  if (isVodafoneGTV()) {
    return DeviceType.Vodafone_Gtv;
  }
  if (isVodafoneVTV()) {
    return DeviceType.Vodafone_Vtv;
  }
  if (isSkyQ()) {
    return DeviceType.Skyq;
  }
  if (isSkyXiOne()) {
    return DeviceType.Skyxione;
  }
  if (isChromecast()) {
    return DeviceType.Chromecast;
  }
  if (isTelecolumbusSTB()) {
    return DeviceType.Telecolumbus;
  }
  if (isKepler()) {
    return DeviceType.Kepler;
  }
  const osVersion = getOSVersion();
  if (isTizen()) {
    switch (osVersion) {
      case "3.0":
        return DeviceType.Tizen_3_0;
      case "4.0":
        return DeviceType.Tizen_4_0;
      case "5.0":
        return DeviceType.Tizen_5_0;
      case "5.5":
        return DeviceType.Tizen_5_5;
      case "6.0":
        return DeviceType.Tizen_6_0;
      case "6.5":
        return DeviceType.Tizen_6_5;
      case "7.0":
        return DeviceType.Tizen_7_0;
      case "8.0":
        return DeviceType.Tizen_8_0;
      case "9.0":
        return DeviceType.Tizen_9_0;
      default:
        return DeviceType.Tizen_3_0;
    }
  }
  const majorBrowserVersion = getBrowserVersion().split(".")[0];
  if (isWebOS()) {
    switch (majorBrowserVersion) {
      case "38":
        return DeviceType.Webos_3;
      case "53":
        return DeviceType.Webos_4;
      case "68":
        return DeviceType.Webos_5;
      case "79":
        return DeviceType.Webos_6;
      case "87":
        return DeviceType.Webos_22;
      case "94":
        return DeviceType.Webos_23;
      case "108":
        return DeviceType.Webos_24;
      case "120":
        return DeviceType.Webos_25;
      default:
        return DeviceType.Webos_3;
    }
  }
  if (isMobile()) {
    return DeviceType.Mobile;
  }
  if (isTablet()) {
    return DeviceType.Tablet;
  }
  return DeviceType.Desktop;
};

// src/_internal/generator/id.ts
import { v4 } from "@lukeed/uuid/secure";
var generateId = () => {
  return v4();
};

// src/public/logger-configuration.ts
var WILDCARD_NAMESPACE = "*";
var LogLevel = {
  None: 0,
  Error: 10,
  Warn: 20,
  Info: 30,
  Debug: 40,
  Trace: 50
};

// src/_internal/polyfills/once.ts
function once(target, type, listener, filter) {
  const handler = (event) => {
    if (filter && !filter(event)) {
      return;
    }
    listener(event);
    target.removeEventListener(type, handler);
  };
  target.addEventListener(type, handler);
  return () => target.removeEventListener(type, handler);
}

// src/_internal/race-against-timeout.ts
async function raceAgainstTimeout(values, timeout, rejectError) {
  let timeOutShouldFire = true;
  let timeoutHandlerId;
  const timeOutPromise = new Promise((resolve) => {
    const timeoutHandler = () => {
      timeoutHandlerId = void 0;
      if (!timeOutShouldFire) {
        return;
      }
      const error = rejectError || createFoundationError(
        `The operation did not finish within ${Math.floor(timeout / 1e3)} seconds`
      );
      resolve(error);
    };
    timeoutHandlerId = setTimeout(timeoutHandler, timeout);
  });
  return Promise.race([...values, timeOutPromise]).then((response) => {
    if (timeoutHandlerId) {
      timeOutShouldFire = false;
      clearTimeout(timeoutHandlerId);
      timeoutHandlerId = void 0;
    }
    return response;
  });
}
async function raceAgainstTimeoutWithThrowOnFailure(values, timeout, rejectError) {
  return raceAgainstTimeout(values, timeout, rejectError).then((responseOrError) => {
    if (isFoundationError(responseOrError)) {
      throw responseOrError;
    }
    return responseOrError;
  });
}

// src/_internal/state/wait-for-event.ts
function waitForEvent(target, type, options = {}) {
  const waitPromise = new Promise((resolve) => {
    once(target, type, resolve, options.filter);
  });
  if (!options.timeoutInMs) {
    return waitPromise;
  }
  const rejectValue = options.rejectValue || createFoundationError(`Timeout while waiting for event ${type}`);
  return raceAgainstTimeoutWithThrowOnFailure([waitPromise], options.timeoutInMs, rejectValue);
}

// src/_internal/drm/fairplay.ts
async function handleFairplayDrm(event, drmConfig) {
  const logger = getLogger("drm.fairplay");
  logger.debug("Handling Fairplay DRM", { event, drmConfig });
  if (!drmConfig) {
    logger.error("No DRM configuration provided", new Error(), { drmConfig });
    throw createFoundationError(
      "No DRM configuration provided",
      {},
      ErrorCodes.FALLBACK_DRM_ERROR_10000
    );
  }
  const fairplayConfig = drmConfig.find((config) => config.keySystem === KeySystem.Fairplay);
  if (!fairplayConfig) {
    throw createFoundationError(
      "No Fairplay configuration provided",
      { fairplayConfig },
      ErrorCodes.FALLBACK_DRM_ERROR_10000
    );
  }
  if (!fairplayConfig.licenseServerUrl) {
    throw createFoundationError(
      "No license server URL provided",
      { fairplayConfig },
      ErrorCodes.INVALID_MISSING_FAIRPLAY_CERTIFICATE_URL_13310
    );
  }
  if (!fairplayConfig.certificateUrl) {
    throw createFoundationError(
      "No certificate URL provided",
      { fairplayConfig },
      ErrorCodes.INVALID_MISSING_FAIRPLAY_CERTIFICATE_URL_13310
    );
  }
  const { initDataType, initData } = event;
  if (!initData) {
    logger.debug("Returning Fairplay DRM config without initData", { fairplayConfig });
    return { drmConfig: fairplayConfig };
  }
  const video = event.target;
  if (!video.mediaKeys) {
    logger.debug("Creating media keys for Fairplay DRM", { fairplayConfig });
    await createMediaKeys(initDataType, fairplayConfig.certificateUrl, video);
    if (!video.mediaKeys) {
      throw createFoundationError(
        "Empty media keys after setMediaKeys",
        {},
        ErrorCodes.DRM_NOT_FULLY_IMPLEMENTED_32120
      );
    }
  }
  logger.debug("Creating Fairplay session");
  const session = video.mediaKeys.createSession();
  logger.debug("Generating Fairplay request");
  await session.generateRequest(initDataType, initData);
  const keyTimeoutInMs = 1e4;
  const keyMessage = await waitForEvent(session, "message", {
    timeoutInMs: keyTimeoutInMs,
    rejectValue: createFoundationError(
      `Key request timed out after ${keyTimeoutInMs / 1e3} seconds`,
      {},
      ErrorCodes.INVALID_FAIRPLAY_CERTIFICATE_DATA_13320
    )
  });
  logger.debug("Received Fairplay key message", { keyMessage });
  const spcString = btoa(bufferToString(keyMessage.message));
  if (!spcString) {
    throw createFoundationError(
      "spc string is empty",
      {},
      ErrorCodes.INVALID_FAIRPLAY_CERTIFICATE_DATA_13320
    );
  }
  const initDataRequest = new URL(bufferToString(initData));
  const keyId = initDataRequest.searchParams.get("keyId");
  if (!keyId) {
    throw createFoundationError(
      "keyId not found or empty",
      {},
      ErrorCodes.INVALID_FAIRPLAY_CERTIFICATE_DATA_13320
    );
  }
  logger.debug("Requesting Fairplay license from license server", { fairplayConfig, keyId });
  const licenseServerResponse = await new Promise((resolve, reject) => {
    const xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("POST", fairplayConfig.licenseServerUrl);
    xmlHttpRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    const headerEntries = Object.entries(fairplayConfig.headers || {});
    for (const [key, value] of headerEntries) {
      if (value) {
        xmlHttpRequest.setRequestHeader(key, value);
      }
    }
    xmlHttpRequest.onload = () => {
      const status = xmlHttpRequest.status;
      if (status === 0 || status >= 200 && status < 400) {
        resolve(base64StringToBuffer(xmlHttpRequest.response));
      } else {
        const json = JSON.parse(xmlHttpRequest.response);
        reject(
          new FoundationError(ErrorCodes.FALLBACK_DRM_ERROR_10000.message, {
            code: json.errorCode,
            context: { response: json, message: json.error }
          })
        );
      }
    };
    xmlHttpRequest.onabort = reject;
    xmlHttpRequest.onerror = (e) => {
      reject(
        createFoundationError(
          "DRM Request has thrown an error",
          { originalError: e },
          ErrorCodes.FALLBACK_DRM_ERROR_10000
        )
      );
    };
    xmlHttpRequest.send(`spc=${encodeURIComponent(spcString)}&keyId=${keyId}`);
  });
  logger.debug("Updating Fairplay session with license", { licenseServerResponse });
  await session.update(licenseServerResponse);
  logger.trace("Fairplay session updated", { session, fairplayConfig });
  return { session, drmConfig: fairplayConfig };
}
async function createMediaKeys(initDataType, certificateUrl, video) {
  const [mediaKeyAccess, serverCertificate] = await Promise.all([
    navigator.requestMediaKeySystemAccess("com.apple.fps", [
      {
        initDataTypes: [initDataType],
        videoCapabilities: [{ contentType: "application/vnd.apple.mpegurl", robustness: "" }],
        distinctiveIdentifier: "not-allowed",
        persistentState: "not-allowed",
        sessionTypes: ["temporary"]
      }
    ]),
    fetch(certificateUrl).then((response) => response.arrayBuffer())
  ]);
  const mediaKeys = await mediaKeyAccess.createMediaKeys();
  await mediaKeys.setServerCertificate(serverCertificate);
  await video.setMediaKeys(mediaKeys);
}
function bufferToString(buffer) {
  return String.fromCharCode.apply(null, [...new Uint8Array(buffer)]);
}
function base64StringToBuffer(b64string) {
  return Uint8Array.from(atob(b64string), (c) => c.charCodeAt(0));
}

// src/_internal/event-bus/typed-event-target.ts
var TypedEventTarget = class {
  constructor(eventTarget) {
    this.eventTarget = eventTarget;
    this.unsubscribers = [];
  }
  addEventListener(type, listener, options) {
    this.eventTarget.addEventListener(
      type,
      listener,
      options
    );
    const unsubscriber = () => {
      this.removeEventListener(type, listener);
    };
    this.unsubscribers.push(unsubscriber);
    return unsubscriber;
  }
  removeEventListener(type, listener, options) {
    this.eventTarget.removeEventListener(
      type,
      listener,
      options
    );
  }
  dispatchEvent(event) {
    return this.eventTarget.dispatchEvent(event);
  }
  destroy() {
    while (this.unsubscribers.length) {
      const unsubscribe = this.unsubscribers.pop();
      if (unsubscribe) {
        unsubscribe();
      }
    }
  }
};

// src/_internal/hls/parse-audio-codec.ts
function parseAudioCodec(manifest) {
  const firstPlaylist = manifest.playlists[0];
  if (!firstPlaylist) {
    return void 0;
  }
  const rawCodecsString = firstPlaylist.attributes.CODECS || "";
  const codecs = rawCodecsString.split(",").map((codec) => codec.trim());
  const audioCodecs = ["ac-3", "alac", "ec-3", "fLaC", "mp4a"];
  return codecs.find((codec) => {
    const cleanedCodec = codec.split(".")[0];
    return audioCodecs.includes(cleanedCodec);
  });
}

// src/_internal/hls/parse-hls-manifest.ts
import { Parser as M3u8Parser } from "m3u8-parser";
async function parseHlsManifest(manifestUrl, timeoutMs = 5e3) {
  const responseOrError = await raceAgainstTimeout(
    [fetch(manifestUrl)],
    timeoutMs,
    createFoundationError(
      `Timeout of ${timeoutMs}ms exceeded when fetching manifest`,
      { manifestUrl, timeoutMs },
      ErrorCodes.NETWORK_PROBLEM_31000
    )
  );
  if (isFoundationError(responseOrError)) {
    throw responseOrError;
  }
  if (!responseOrError.ok) {
    throw createFoundationError(
      `Failed to fetch manifest: ${responseOrError.statusText}`,
      {
        manifestUrl,
        response: { status: responseOrError.status, statusText: responseOrError.statusText },
        timeoutMs
      },
      ErrorCodes.NETWORK_PROBLEM_31000
    );
  }
  const text = await responseOrError.text();
  const parser = new M3u8Parser();
  parser.push(text);
  parser.end();
  return parser.manifest;
}

// src/_internal/hls/parse-hls-playlist-type.ts
var PlaylistType = {
  VOD: "VOD",
  Event: "EVENT",
  Unknown: "UNKNOWN"
};
async function parseHlsPlaylistType(manifest, assetUrl) {
  const firstPlaylist = manifest.playlists[0];
  if (!firstPlaylist) {
    return PlaylistType.Unknown;
  }
  const manifestBaseUrl = assetUrl.substring(0, assetUrl.lastIndexOf("/") + 1);
  const playlistManifest = await parseHlsManifest(manifestBaseUrl + firstPlaylist.uri);
  switch ((playlistManifest.playlistType || "").toUpperCase()) {
    case "VOD":
      return PlaylistType.VOD;
    case "EVENT":
      return PlaylistType.Event;
    default:
      return PlaylistType.Unknown;
  }
}

// src/_internal/hls/parse-video-tracks.ts
function parseVideoTracks(manifest) {
  if (!manifest.playlists || manifest.playlists.length === 0) {
    return [];
  }
  const videoCodecs = ["avc1", "avc3", "dvh1", "dvh1", "hev1", "hvc1", "mjpg"];
  const tracks = manifest.playlists.map((playlist) => {
    const rawCodecsString = playlist.attributes.CODECS || "";
    const codecs = rawCodecsString.split(",");
    const codec = codecs.find((codec2) => {
      const cleanedCodec = codec2.split(".")[0];
      return videoCodecs.includes(cleanedCodec);
    });
    const { width, height } = playlist.attributes.RESOLUTION || {
      width: -1,
      height: -1
    };
    return {
      trackId: playlist.uri,
      active: false,
      // 9.13. The BANDWIDTH attribute MUST be the largest sum of peak segment bit rates that's produced by any playable combination of renditions.
      bitrateInKbps: Number(playlist.attributes.BANDWIDTH) / 1e3,
      framesPerSecond: playlist.attributes["FRAME-RATE"] ? Number(playlist.attributes["FRAME-RATE"]) : void 0,
      width,
      height,
      codec,
      mimeType: "application/vnd.apple.mpegurl"
    };
  });
  tracks.sort((a, b) => a.bitrateInKbps - b.bitrateInKbps);
  tracks[tracks.length - 1].active = true;
  return tracks;
}

// src/_internal/language/infer-label-from-language.ts
function inferLabelFromLanguage(language, label) {
  if (label) {
    return label;
  }
  if (!Intl?.DisplayNames) {
    return language;
  }
  if (!language) {
    return "";
  }
  let languages = navigator.languages;
  if (!languages || languages.length === 0) {
    languages = navigator.language ? navigator.language.split(",") : [];
  }
  languages = languages.map((lang) => lang.split(";")[0].trim()).filter((lang) => !!lang);
  if (languages.length === 0 || !languages[0]) {
    languages = ["de"];
  }
  const displayNames = new Intl.DisplayNames(languages, {
    type: "language"
  });
  return displayNames.of(language) || language;
}

// src/_internal/mutable-observable.ts
var MutableObservable = class {
  constructor(value) {
    /**
     * Set of observers that are subscribed to this observable.
     */
    this.observers = /* @__PURE__ */ new Set();
    /**
     * Map of value change observers that are subscribed to this observable.
     */
    this.valueChangeObservers = /* @__PURE__ */ new Map();
    /**
     * {@inheritDoc Observable.onValueChange}
     *
     * @privateRemarks
     * Notice the fat arrow function. This is important to ensure that the correct `this` context is used.
     * This allows passing the function directly e.g. this.track(player.state.onValueChange) while maintaining the correct context.
     */
    this.onValueChange = (value, observer) => {
      const metadata = this.valueChangeObservers.get(value) || {
        lastValue: this._value[value],
        observers: /* @__PURE__ */ new Set()
      };
      if (!this.valueChangeObservers.has(value)) {
        this.valueChangeObservers.set(value, metadata);
      }
      metadata.observers.add(observer);
      observer(this._value, metadata.lastValue);
      return () => metadata.observers.delete(observer);
    };
    /**
     * {@inheritDoc Observable.once}
     *
     * @privateRemarks
     * Notice the fat arrow function. This is important to ensure that the correct `this` context is used.
     * This allows passing the function directly e.g. this.track(player.state.once) while maintaining the correct context.
     */
    this.once = (condition, observer) => {
      const result = condition(this._value);
      if (result) {
        observer(this._value);
        return () => {
        };
      }
      const unsubscribe = this.subscribe((state) => {
        const result2 = condition(state);
        if (result2) {
          observer(state);
          unsubscribe();
        }
      });
      return unsubscribe;
    };
    this._value = value;
  }
  /**
   * {@inheritDoc Observable.subscribe}
   */
  subscribe(observer) {
    this.observers.add(observer);
    observer(this._value);
    return () => this.unsubscribe(observer);
  }
  /**
   * {@inheritDoc Observable.unsubscribe}
   */
  unsubscribe(observer) {
    this.observers.delete(observer);
  }
  /**
   * {@inheritDoc Observable.get}
   */
  get() {
    return this._value;
  }
  /**
   * {@inheritDoc Observable.value}
   */
  get value() {
    return this.get();
  }
  /**
   * {@inheritDoc Observable.valueOf}
   */
  valueOf() {
    return this.get();
  }
  /**
   * Fully replace the current value with a new value.
   */
  update(value) {
    this._value = value;
    for (const observer of this.observers) {
      observer(value);
    }
    const valueObservers = this.valueChangeObservers.entries();
    for (const [key, metadata] of valueObservers) {
      const lastValue = metadata.lastValue;
      const changed = this._value[key] !== lastValue;
      if (changed) {
        metadata.lastValue = this._value[key];
        for (const observer of metadata.observers) {
          observer(this._value, lastValue);
        }
      }
    }
  }
  /**
   * Partially replace the current value with a new value.
   *
   * This is only applicable for objects and just does a shallow merge.
   */
  patch(partialValue) {
    this.update({
      ...this._value,
      ...partialValue
    });
  }
  /**
   * Partially replace the current value with a new value without notifying observers.
   *
   * This is only applicable for objects and just does a shallow merge.
   */
  silentPatch(partialValue) {
    this._value = {
      ...this._value,
      ...partialValue
    };
    const valueObservers = this.valueChangeObservers.entries();
    for (const [key, metadata] of valueObservers) {
      const lastValue = metadata.lastValue;
      const changed = this._value[key] !== lastValue;
      if (changed) {
        metadata.lastValue = this._value[key];
      }
    }
  }
};

// src/_internal/polyfills/with-resolvers.ts
function withResolvers() {
  let resolve = void 0;
  let reject = void 0;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return {
    resolve,
    reject,
    promise
  };
}

// src/_internal/adapter/native/parse-browser-error.ts
function parseBrowserError(message) {
  if (message.includes("The request is not allowed by the user agent or the platform") || // as observed in e.g. Safari 16.6
  message.includes("play() can only be initiated by a user gesture") || // as observed in e.g. Edge 120
  message.includes("The operation is not supported") || // as observed in e.g. Safari 16.1
  message.includes(
    "The play() request was interrupted because a pause was requested by the browser"
  ) || // as observed in e.g. Android 10
  message.includes("The play method is not allowed by the user agent") || // as observed in e.g. Chrome 120
  message.includes(`play() failed because the user didn't interact with the document first`)) {
    return ErrorCodes.MISSING_USER_INTERACTION_35310;
  }
  if (message.includes("The operation was aborted")) {
    return ErrorCodes.OPERATION_ABORTED_35400;
  }
  if (message.includes("The play() request was interrupted by a call to pause()") || // as observed in e.g. Chrome 120
  message.includes("The play() request was interrupted because a pause was requested by the user")) {
    return ErrorCodes.OPERATION_ABORTED_PLAY_35410;
  }
  if (message.includes(
    `The fetching process for the media resource was aborted by the user agent at the user's request`
  ) || // as observed in e.g. Firefox 121
  message.includes("The play() request was interrupted by a new load request")) {
    return ErrorCodes.OPERATION_ABORTED_LOAD_35420;
  }
  if (message.includes(
    "The play() request was interrupted because video-only background media was paused to save power"
  )) {
    return ErrorCodes.OPERATION_ABORTED_POWER_SAVING_35430;
  }
  if (message.includes(
    "The play() request was interrupted because the media was removed from the document"
  )) {
    return ErrorCodes.OPERATION_ABORTED_VIDEO_REMOVED_35440;
  }
  if (message.includes("DEMUXER_ERROR_DETECTED_AAC")) {
    return ErrorCodes.MEDIA_FORMAT_UNSUPPORTED_20100;
  }
  return ErrorCodes.ERROR_NOT_TREATED_59000;
}

// src/_internal/adapter/native/map-error.ts
var getCode = (error) => {
  if (error && typeof error === "object" && "code" in error) {
    return error?.code;
  }
  return null;
};
var getMessage = (error) => {
  const defaultMessage = "An error has occurred";
  if (error && typeof error === "object" && "message" in error && typeof error.message === "string") {
    return error.message || defaultMessage;
  }
  return defaultMessage;
};
function mapError(error) {
  let code = ErrorCodes.ERROR_NOT_TREATED_59000;
  const errorCode = getCode(error);
  let userMessage = getMessage(error);
  if (error && typeof error === "object" && "message" in error && typeof error?.message === "string" && error.message) {
    code = parseBrowserError(error?.message);
  } else if (errorCode) {
    switch (errorCode) {
      case MediaError.MEDIA_ERR_ABORTED:
        code = ErrorCodes.OPERATION_ABORTED_35400;
        userMessage = "The operation was aborted by the client or the browser.";
        break;
      case MediaError.MEDIA_ERR_NETWORK:
        code = ErrorCodes.NETWORK_PROBLEM_31000;
        userMessage = "A network error occurred while fetching the media.";
        break;
      case MediaError.MEDIA_ERR_DECODE:
      case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
        code = ErrorCodes.MANIFEST_NOT_SUPPORTED_32220;
        userMessage = "The media format is not supported or could not be decoded.";
        break;
      default:
        code = ErrorCodes.ERROR_NOT_TREATED_59000;
    }
  }
  return createFoundationError(userMessage, { originalEvent: error }, code);
}

// src/_internal/adapter/native/native-player-adapter.ts
var NativePlayerAdapter = class {
  constructor(player, tweaks) {
    this.player = player;
    this.tweaks = tweaks;
    this.state = new MutableObservable({
      state: "ready",
      currentTimeInSeconds: 0,
      durationInSeconds: 0,
      timeShiftedInSeconds: 0,
      // We cannot determine the current track for either HLS nor progressive playback
      currentVideoTrack: void 0,
      // We cannot determine the dropped frames for either HLS nor progressive playback
      droppedFrames: 0,
      // We cannot determine the throughput for either HLS nor progressive playback
      averageThroughputInKbps: 0,
      activeCues: [],
      playbackRate: 1
    });
    this.logger = getLogger("adapter.native");
    /**
     * The current load request.
     */
    this.loadRequest = void 0;
    /**
     * Whether the player can autoplay.
     *
     * @remarks
     * This will be true once any asset was successfully started.
     */
    this.canAutoplay = false;
    this.eventBus = new TypedEventTarget(this.player);
    let stallingDebounce;
    const clearStallingDebounce = () => {
      if (stallingDebounce) {
        clearTimeout(stallingDebounce);
        stallingDebounce = void 0;
      }
    };
    const stallingTimeout = (timeoutInMilliseconds = 1e3) => {
      clearStallingDebounce();
      stallingDebounce = setTimeout(() => {
        this.state.patch({ state: "stalled" });
        clearStallingDebounce();
      }, timeoutInMilliseconds);
    };
    this.eventBus.addEventListener("timeupdate", () => {
      clearStallingDebounce();
      this.state.patch({
        currentTimeInSeconds: this.player.currentTime,
        state: this.player.paused ? "ready" : "playing"
      });
      stallingTimeout(2e3);
    });
    this.eventBus.addEventListener("error", () => {
      const error = mapError(this.player.error);
      this.state.patch({ state: "error", error });
    });
    this.eventBus.addEventListener("ended", () => {
      this.state.patch({ state: "ended" });
    });
    this.eventBus.addEventListener("stalled", () => stallingTimeout());
    this.eventBus.addEventListener("waiting", () => stallingTimeout());
    this.eventBus.addEventListener("playing", () => {
      clearStallingDebounce();
      this.state.patch({ state: "playing" });
      stallingTimeout(5e3);
    });
    this.eventBus.addEventListener("ratechange", () => {
      this.state.patch({ playbackRate: this.player.playbackRate });
    });
    this.eventBus.addEventListener("durationchange", () => {
      if (this.assetInformation?.livestream) {
        return;
      }
      if (!this.player.duration) {
        return;
      }
      this.state.patch({ durationInSeconds: this.player.duration });
      if (this.assetInformation) {
        this.assetInformation.durationInSeconds = this.player.duration;
      }
    });
    this.eventBus.addEventListener("seeked", () => {
      if (this.assetInformation?.livestream) {
        this.state.patch({
          timeShiftedInSeconds: this.getDistanceToLiveEdgeInSeconds()
        });
      }
    });
    const debugEventTypes = [
      "canplay",
      "loadeddata",
      "loadedmetadata",
      "encrypted",
      "error",
      "waiting",
      "playing",
      "stalled",
      "emptied",
      "durationchange"
    ];
    for (const debugEventType of debugEventTypes) {
      const eventLogger = getLogger(`adapter.native.event.${debugEventType}`);
      if (!eventLogger.isLoggingActiveForLevel(LogLevel.Trace)) {
        continue;
      }
      this.eventBus.addEventListener(debugEventType, (event) => {
        eventLogger.debug("", event);
      });
    }
  }
  destroy() {
    this.eventBus.destroy();
    return Promise.resolve();
  }
  getPlayerType() {
    return "native";
  }
  getRootPlayer() {
    return this.player;
  }
  async load(loadRequest) {
    if (this.mediaKeySession) {
      this.logger.debug("Removing previous media key session");
      await this.mediaKeySession.close();
      this.mediaKeySession = void 0;
      await this.player.setMediaKeys(null);
      this.logger.debug("Previous media key session removed");
    }
    if (this.loadRequest) {
      this.logger.debug(
        "Player already loaded, resetting player for new load request",
        loadRequest
      );
      await this.disableTextTrack();
      this.player.pause();
      this.player.removeAttribute("src");
      this.player.load();
      this.logger.debug("Player reset");
    }
    const isHlsRequest = loadRequest.manifestType === ManifestType.Hls;
    const drmPromise = withResolvers();
    if (loadRequest.drmConfig) {
      once(this.player, "encrypted", (event) => {
        handleFairplayDrm(event, loadRequest.drmConfig).then((drmConfig) => drmPromise.resolve(drmConfig)).catch((e) => {
          this.logger.error("Error handling Fairplay DRM. Resetting media keys", e);
          void this.player.setMediaKeys(null);
          drmPromise.reject(e);
        });
      });
    }
    const readyPromise = waitForEvent(this.player, "canplay");
    const errorPromise = waitForEvent(this.player, "error").then(
      () => Promise.reject(mapError(this.player.error))
    );
    const loadedMetadataPromise = waitForEvent(this.player, "loadedmetadata");
    this.logger.debug("Resetting autoplay for new load request", loadRequest);
    this.player.autoplay = false;
    this.player.src = loadRequest.assetUrl;
    this.logger.debug("Player src set to", loadRequest.assetUrl);
    this.logger.debug("Waiting for player to be ready");
    await Promise.race([loadedMetadataPromise, errorPromise]);
    this.logger.debug("Metadata is available");
    if (this.tweaks.playerRequiresLoadBeforeReady) {
      try {
        this.player.load();
      } catch (e) {
        throw mapError(e);
      }
    }
    let usedDrmConfig;
    if (loadRequest.drmConfig) {
      this.logger.debug("Waiting for DRM config to be resolved");
      const fairplayMediaKeyAccess = await Promise.race([drmPromise.promise, errorPromise]);
      usedDrmConfig = fairplayMediaKeyAccess.drmConfig;
      this.mediaKeySession = fairplayMediaKeyAccess.session;
      this.logger.debug("DRM config resolved", usedDrmConfig);
    }
    await Promise.race([readyPromise, errorPromise]);
    if (loadRequest.startTimeInSeconds) {
      this.logger.debug("Seeking to start time", loadRequest.startTimeInSeconds);
      await this.seekTo(loadRequest.startTimeInSeconds);
      this.state.patch({
        currentTimeInSeconds: loadRequest.startTimeInSeconds || 0
      });
      this.logger.debug("Seeked to start time", loadRequest.startTimeInSeconds);
    }
    let audioCodec;
    let videoTracks = [];
    let livestream = this.player.duration === Number.POSITIVE_INFINITY;
    if (isHlsRequest) {
      this.logger.debug("Parsing HLS manifest");
      const manifest = await parseHlsManifest(loadRequest.assetUrl);
      audioCodec = parseAudioCodec(manifest);
      videoTracks = parseVideoTracks(manifest);
      const playlistType = await parseHlsPlaylistType(manifest, loadRequest.assetUrl);
      switch (playlistType) {
        case "VOD":
          livestream = false;
          break;
        case "EVENT":
          livestream = true;
          break;
      }
      this.logger.debug("Parsed HLS manifest", { audioCodec, videoTracks, livestream });
    }
    const durationInSeconds = livestream ? -1 : this.player.duration;
    this.state.patch({
      state: "ready",
      currentTimeInSeconds: this.player.currentTime,
      currentVideoTrack: videoTracks.find((t) => t.active),
      durationInSeconds
    });
    const nativeAudioTracks = this.getAudioTracks();
    await this.disableTextTrack();
    this.loadRequest = loadRequest;
    this.assetInformation = {
      livestream,
      durationInSeconds,
      videoTracks,
      // audio tracks will only be available for HLS playback
      audioTracks: nativeAudioTracks ? Array.from(nativeAudioTracks, (track, idx) => ({
        trackId: String(idx),
        // we use the index, because there are a lot of cases where tracks do not have ids
        language: track.language || "",
        // can be empty e.g. for livestreams
        label: inferLabelFromLanguage(track.language, track.label),
        role: track.kind,
        active: track.enabled,
        codec: audioCodec,
        mimeType: isHlsRequest ? "audio/mp4" : void 0
        // HLS requires audio to be audio/mp4
      })) : [],
      usedDrmConfig,
      textTracks: this.getTextTracks()
    };
    this.logger.debug(
      "Returning asset information after loading the asset.",
      this.assetInformation
    );
    return this.assetInformation;
  }
  getTextTracks() {
    const textTracks = [];
    const nativeTextTracks = this.player.textTracks ? this.player.textTracks : [];
    for (let idx = 0; idx < nativeTextTracks.length; idx++) {
      const track = nativeTextTracks[idx];
      if (!track.language && !track.label) {
        continue;
      }
      textTracks.push({
        trackId: String(idx),
        // we use the index, because there are a lot of cases where tracks do not have ids
        language: track.language || "",
        label: inferLabelFromLanguage(track.language, track.label),
        active: track.mode !== "disabled"
      });
    }
    return textTracks;
  }
  mute() {
    this.player.muted = true;
    return Promise.resolve();
  }
  async pause() {
    const promise = waitForEvent(this.player, "pause");
    this.player.pause();
    await promise;
    this.state.patch({ state: "ready" });
  }
  async play() {
    const playingPromise = waitForEvent(this.player, "playing");
    if (this.assetInformation?.livestream) {
      this.seekToLiveEdge();
    }
    try {
      await (this.player.play() || Promise.resolve());
    } catch (e) {
      throw mapError(e);
    }
    await playingPromise;
    this.canAutoplay = true;
  }
  seekTo(timeInSeconds) {
    const promise = waitForEvent(this.player, "seeked");
    this.player.currentTime = timeInSeconds;
    return promise;
  }
  setAudioTrack(trackId) {
    if (!this.assetInformation) {
      return Promise.resolve();
    }
    const audioTrack = this.assetInformation.audioTracks.find((track2) => track2.trackId === trackId);
    if (!audioTrack) {
      return Promise.reject(
        createFoundationError(
          `Audio track with id ${trackId} not found!`,
          {},
          ErrorCodes.CLIENT_30000
        )
      );
    }
    const nativeTracks = this.getAudioTracks();
    if (!nativeTracks) {
      return Promise.reject(createFoundationError("Native audio track api does not exist!"));
    }
    const currentEnabledTrack = this.assetInformation.audioTracks.find((track2) => track2.active);
    if (currentEnabledTrack) {
      const currentTrack = nativeTracks[Number(currentEnabledTrack.trackId)];
      if (currentTrack) {
        currentTrack.enabled = false;
      }
    }
    const track = nativeTracks[Number(trackId)];
    if (!track) {
      return Promise.reject(
        createFoundationError(
          `Audio track with id ${trackId} not found on native element!`,
          {},
          ErrorCodes.CLIENT_30000
        )
      );
    }
    track.enabled = true;
    return Promise.resolve();
  }
  disableTextTrack() {
    const nativeTextTracks = this.player.textTracks ? this.player.textTracks : [];
    for (const track of nativeTextTracks) {
      track.mode = "disabled";
      track.oncuechange = null;
    }
    this.state.patch({ activeCues: [] });
    return Promise.resolve();
  }
  enableTextTrack(trackId) {
    if (!this.assetInformation) {
      return Promise.resolve();
    }
    const textTrack = this.assetInformation.textTracks.find((track) => track.trackId === trackId);
    if (!textTrack) {
      return Promise.reject(
        createFoundationError(
          `Text track with id ${trackId} not found!`,
          {},
          ErrorCodes.CLIENT_30000
        )
      );
    }
    return this.enableNativeTextTrack(trackId);
  }
  enableNativeTextTrack(trackId) {
    const nativeTracks = this.player.textTracks;
    if (!nativeTracks) {
      return Promise.reject(createFoundationError("Native text track api does not exist!"));
    }
    const track = nativeTracks[Number(trackId)];
    if (!track) {
      return Promise.reject(
        createFoundationError(
          `Text track with id ${trackId} not found on native element!`,
          {},
          ErrorCodes.CLIENT_30000
        )
      );
    }
    this.state.patch({ activeCues: [] });
    track.oncuechange = () => {
      const activeCues = Array.from(track.activeCues || []).map((cue) => ({
        id: cue.id,
        startTimeInSeconds: cue.startTime,
        endTimeInSeconds: cue.endTime,
        text: "text" in cue ? String(cue.text) : ""
      }));
      this.state.patch({ activeCues });
    };
    track.mode = "hidden";
    return Promise.resolve();
  }
  /**
   * It is not possible to set the max video bitrate for progressive playback.
   * We also cannot set the max video bitrate for native HLS playback.
   */
  setMaxVideoBitrate() {
    return Promise.resolve();
  }
  setPlaybackRate(playbackRate) {
    this.player.playbackRate = playbackRate;
    this.state.patch({ playbackRate });
    return Promise.resolve();
  }
  setVolume(volume) {
    this.player.volume = volume;
    return Promise.resolve();
  }
  unmute() {
    this.player.muted = false;
    return Promise.resolve();
  }
  getCapabilities() {
    return {
      manifestTypes: [ManifestType.Hls, ManifestType.Progressive],
      keySystems: [KeySystem.Fairplay]
    };
  }
  /**
   * Returns the audio tracks of the player if available.
   *
   * This wrapper exists because the AudioTrack api is only supported in Safari,
   * and does not exist in the typescript definitions.
   */
  getAudioTracks() {
    return "audioTracks" in this.player ? this.player.audioTracks : void 0;
  }
  getLoadRequest() {
    return this.loadRequest;
  }
  async testAutoplay(isMuted, hasAacCodecSupport) {
    if (this.canAutoplay) {
      return true;
    }
    const result = await testAutoplay(this.player, {
      isMuted,
      hasAacCodecSupport
    });
    this.logger.debug("Test autoplay result", result);
    this.canAutoplay = result.result;
    return this.canAutoplay;
  }
  //These functions are only tested for Safari video player since we only use the native player adapter there.
  timeShift(offsetInSeconds) {
    const seekable = this.player.seekable;
    if (seekable.length === 0) {
      throw createFoundationError("Cannot time shift, seekable range is empty", {
        code: ErrorCodes.OPERATION_NOT_SUPPORTED_35500.code
      });
    }
    const seekableStart = this.player.seekable.start(0);
    const seekableEnd = this.player.seekable.end(0);
    let seekTarget = seekableEnd - offsetInSeconds;
    seekTarget = Math.max(seekableStart, seekTarget);
    if (seekTarget === this.player.currentTime) {
      return Promise.resolve();
    }
    const promise = waitForEvent(this.eventBus, "seeked");
    this.player.currentTime = seekTarget;
    return promise;
  }
  seekToLiveEdge() {
    return this.timeShift(0);
  }
  getDVRWindowInSeconds() {
    return Math.floor(this.player.seekable.end(0) - this.player.seekable.start(0));
  }
  getDistanceToLiveEdgeInSeconds() {
    return Math.max(0, Math.floor(this.player.seekable.end(0) - this.player.currentTime));
  }
  updateContentMetadata() {
  }
};

// src/_internal/adapter/native/create-native-player-adapter.ts
function createNativePlayerAdapter(mountPoint, tweaks) {
  const videoElement = findVideoElement(mountPoint);
  if (!videoElement) {
    throw createFoundationError(
      "Native player adapter requires a video element to be present in the mount point",
      {},
      ErrorCodes.MISSING_PLAYER_ELEMENT_OR_ID_34300
    );
  }
  assertVideoElementAttributes(videoElement);
  return new NativePlayerAdapter(videoElement, tweaks);
}

// src/public/request-header.ts
var RequestType = {
  /**
   * Request to the license server
   *
   * @remarks
   * This type has to be implemented by every client application,
   * unless it fulfills the following conditions:
   * - The client application does not use DRM protected content
   * - The client application does not use RTL license servers
   * - Free/anonymous users does not have user tokens
   *
   * For RTL license servers this should return the following headers:
   * 'x-auth-token': A valid user JWT
   *
   * For other license servers this should return the headers for your particular license server.
   */
  DRM: "foundation.player.drm",
  /**
   * Request to the StUS endpoint
   *
   * @remarks
   * This type has to be implemented by every client application,
   * unless it fulfills the following conditions:
   * - The client application does not use StUS
   * - Free/anonymous users does not have user tokens
   *
   * This should return the following headers:
   * 'x-auth-token': A valid user JWT
   */
  StUS: "foundation.player.stus",
  /**
   * Request from the entitlement plugin
   *
   * @remarks
   * This type has to be implemented by every client application,
   * unless it fulfills the following conditions:
   * - The client application does not use the entitlement plugin
   * - Free/anonymous users does not have user tokens
   *
   * This should return the following headers:
   * 'x-auth-token': A valid user JWT
   */
  Entitlement: "foundation.plugin.entitlement",
  /**
   * Request from the concurrent streamcheck plugin
   *
   * @remarks
   * This type has to be implemented by every client application,
   * unless it fulfills the following conditions:
   * - The client application does not use the concurrent stream check plugin
   * - Free/anonymous users does not have user tokens
   *
   * This should return the following headers:
   * 'jwt': A valid user JWT
   */
  ConcurrentStreamCheck: "foundation.plugin.concurrentStreamCheck",
  /**
   * Request from the nielsen plugin
   *
   * @remarks
   * This type has to be implemented by every client application,
   * unless it fulfills the following conditions:
   * - The client application does not use the nielsen plugin
   * - Free/anonymous users does not have user tokens
   *
   * This should return the following headers:
   * 'x-auth-token': A valid user JWT
   */
  Nielsen: "foundation.plugin.nielsen"
};

// src/_internal/fetch/fetch-with-timeout.ts
var fetchWithTimeout = async (resource, options = {}, rejectError) => {
  const { timeout = 1e4 } = options;
  const response = fetch(resource, {
    ...options
  });
  return raceAgainstTimeoutWithThrowOnFailure([response], timeout, rejectError);
};

// src/_internal/plugin/player-plugin.ts
var PlayerPlugin = class {
  /**
   * In order to alleviate the burden of checking if the player is defined or not,
   * plugins are created after the player is created. At this point the player may just be a shell,
   * where no content is loaded yet, but you may already register state listeners.
   *
   * You may also require an initial plugin configuration here,
   * but be aware that you must react to changes in `beforeSessionStart` and update your internal state accordingly.
   */
  constructor(player) {
    this.player = player;
    /**
     * A list of currently active subscriptions to any observable.
     */
    this.subscriptions = [];
  }
  clearSubscriptions() {
    for (const unsubscribe of this.subscriptions) {
      unsubscribe();
    }
    this.subscriptions = [];
  }
  /**
   * Create a tracked subscription method, where every subscription created can be cleared with the clearSubscriptions method.
   *
   * @param fn - A function that returns a function to unsubscribe from the observable.
   */
  track(fn) {
    return (...args) => {
      const unsubscribe = fn(...args);
      this.subscriptions.push(unsubscribe);
      return unsubscribe;
    };
  }
  /**
   * This hook will be called in parallel for all plugins before a new session is started.
   * This can either happen when the player is first created or a new load request is executed. This
   * call is executed **before** `modifyLoadRequest`.
   *
   * Override this method to perform any initialization that requires the player to be fully initialized,
   * that does not fit your constructor or is asynchronous.
   *
   * This hook must also be used if cleanup between sessions is needed.
   *
   * You may cache the player instance in a class property, but you should prefer to pass the instance instead of caching it.
   * You should cache your plugin config, after you determined if the plugin is needed for the starting session.
   */
  beforeSessionStart(_pluginConfigs, _playerLoadRequest) {
    return Promise.resolve();
  }
  /**
   * This hook will be called in sequence before an asset load request is executed to return an updated configuration e.g. with different asset urls,
   * to ensure all plugins had a chance to prepare and to modify the configuration, before it is loaded for the first time.
   *
   * This is important because loading the urls may cause side effects like tracking or provisioning resources. (e.g. Yospace)
   */
  modifyLoadRequest(loadRequest) {
    return Promise.resolve(loadRequest);
  }
  /**
   * This hook will be called in parallel for all plugins after the load request was possibly modified by all plugins.
   *
   * It is safe here to access the url of the asset, because it is guaranteed that all plugins have modified the load request.
   */
  beforeLoadRequest(_loadRequest) {
    return Promise.resolve();
  }
  /**
   * Executed before the player triggers an error state.
   *
   * @remarks
   * This method must return if the player should handle the error or not.
   *
   * For example if fallbacks are activated, the fallback plugin should return false.
   *
   * Only if no special handling is required, for example if all fallbacks are exhausted, the promise should return true.
   */
  beforeError(_error) {
    return Promise.resolve(true);
  }
};
function hasPublicApi(plugin) {
  return plugin !== null && typeof plugin === "object" && "getKey" in plugin && typeof plugin.getKey === "function" && "getPlugin" in plugin && typeof plugin.getPlugin === "function";
}

// src/_internal/plugin/concurrent-stream-check/concurrent-stream-check-plugin.ts
var DEFAULT_BEAT_INTERVAL_IN_SECONDS = 60;
var ConcurrentStreamCheckPlugin = class extends PlayerPlugin {
  constructor(player, getRequestHeader) {
    super(player);
    this.getRequestHeader = getRequestHeader;
    this.logger = getLogger("plugin.concurrentStreamCheck");
    this.stopWasSend = false;
    this.beforeWindowUnload = async () => {
      await this.stopBeatTracking();
    };
    this.stopBeatTracking = async () => {
      if (this.stopWasSend) {
        return;
      }
      const payload = await this.getPayload();
      if (this.stopUrl) {
        await this.sendRequest(this.stopUrl, payload).catch(
          (e) => this.logger.error("Could not stop concurrent stream check", e)
        );
      }
      this.stopWasSend = true;
      if (this.clearBeatSubscription) {
        this.clearBeatSubscription();
      }
    };
  }
  getKey() {
    return "foundation.plugin.concurrentStreamCheck";
  }
  beforeSessionStart(pluginConfigs) {
    this.clearSubscriptions();
    this.stopWasSend = false;
    const pluginConfig = pluginConfigs[this.getKey()];
    if (!pluginConfig) {
      return Promise.resolve();
    }
    const trackedOnce = this.track(this.player.state.once);
    const trackedOnValueChange = this.track(this.player.state.onValueChange);
    const { startUrl, stopUrl, heartbeatUrl, beatInterval } = pluginConfig;
    this.stopUrl = stopUrl;
    const intervalMilliseconds = (beatInterval || DEFAULT_BEAT_INTERVAL_IN_SECONDS) * 1e3;
    const start = async () => {
      const payload = await this.getPayload();
      const response = await this.sendRequest(startUrl, payload);
      if (response.status === 402) {
        const body = await response.text();
        await this.player.triggerError(
          createFoundationError(
            "Concurrent streams limit reached",
            { response: body },
            ErrorCodes.MAX_CONCURRENT_STREAMS_REACHED_33100
          )
        );
        return false;
      }
      return true;
    };
    let lastBeat;
    const beat = async () => {
      const now = Date.now();
      const diff = now - (lastBeat || now);
      if (diff < intervalMilliseconds) {
        return;
      }
      lastBeat = now;
      const payload = await this.getPayload();
      await this.sendRequest(heartbeatUrl, payload);
    };
    const waitForPlaying = () => trackedOnce(
      ({ state, sessionCompleted }) => state === "playing" && !sessionCompleted,
      onPlaying
    );
    const onPlaying = async ({ sessionCompleted }) => {
      if (sessionCompleted) {
        return;
      }
      const activated = await start().catch((e) => {
        this.logger.error("Could not start concurrent stream check", e);
        return false;
      });
      if (!activated) {
        return;
      }
      lastBeat = Date.now();
      this.clearBeatSubscription = trackedOnValueChange("currentTimeInSeconds", beat);
      const clearSessionEndSubscription = trackedOnce(
        ({ state, linearAdActive, activeAsset, sessionCompleted: sessionCompleted2 }) => {
          if (state === "destroyed") {
            return true;
          }
          if (activeAsset?.livestream) {
            return !linearAdActive && ["ended", "paused", "stopped"].includes(state);
          }
          return sessionCompleted2;
        },
        async () => {
          await this.stopBeatTracking();
          waitForPlaying();
        }
      );
      trackedOnce(
        ({ state }) => state === "destroyed",
        () => {
          clearSessionEndSubscription();
        }
      );
    };
    waitForPlaying();
    return Promise.resolve();
  }
  async sendRequest(endpoint, payload) {
    return fetchWithTimeout(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload),
      timeout: 2e3
    });
  }
  async getPayload() {
    let userValues;
    if (this.getRequestHeader) {
      userValues = await this.getRequestHeader(RequestType.ConcurrentStreamCheck);
    }
    return {
      ...userValues,
      // We use our Player-ID instead of our Session-ID, because the requirement is to track based on the player instance.
      sessionKey: this.player.getPlayerId()
    };
  }
};

// src/_internal/plugin/device-header/device-header-plugin.ts
var DeviceHeaderPlugin = class extends PlayerPlugin {
  getKey() {
    return "foundation.plugin.deviceHeader";
  }
  beforeSessionStart(pluginConfigs) {
    this.pluginConfig = pluginConfigs["foundation.plugin.deviceHeader"];
    return Promise.resolve();
  }
  modifyLoadRequest(loadRequest) {
    const headers = this.pluginConfig?.headers;
    if (!loadRequest.drmConfig || !headers) {
      return Promise.resolve(loadRequest);
    }
    loadRequest.drmConfig = loadRequest.drmConfig.map((config) => {
      config.headers = {
        ...config.headers,
        ...headers
      };
      return config;
    });
    return Promise.resolve(loadRequest);
  }
};

// src/_internal/plugin/entitlement/entitlement-plugin.ts
var EntitlementPlugin = class extends PlayerPlugin {
  constructor(player, getRequestHeader) {
    super(player);
    this.player = player;
    this.getRequestHeader = getRequestHeader;
  }
  getKey() {
    return "foundation.plugin.entitlement";
  }
  async beforeSessionStart(pluginConfigs) {
    this.pluginConfig = pluginConfigs["foundation.plugin.entitlement"];
    if (!this.pluginConfig) {
      return;
    }
    const replacements = {
      "{MEDIA_ID}": this.pluginConfig.id || this.player.state.value.contentId || ""
    };
    if (!replacements["{MEDIA_ID}"]) {
      return;
    }
    let headers = {
      ...this.pluginConfig.headers
    };
    if (this.getRequestHeader) {
      const requestHeader = await this.getRequestHeader(RequestType.Entitlement);
      headers = {
        ...requestHeader,
        ...headers
      };
    }
    const timeout = this.pluginConfig.timeout || 2e3;
    const endpoint = this.replacePlaceholder(this.pluginConfig.endpoint, replacements);
    const response = await fetchWithTimeout(endpoint, {
      method: "POST",
      timeout,
      headers
    }).catch((e) => e);
    if (!this.isFetchResponse(response)) {
      return;
    }
    const responseBody = await response.json().catch(() => ({}));
    if (response.status === 403) {
      const errorResponse = responseBody;
      throw new FoundationError(ErrorCodes.GEOBLOCKING_12100.message, {
        code: errorResponse.code || ErrorCodes.GEOBLOCKING_12100.code,
        context: {
          status: response.status,
          response: responseBody,
          message: errorResponse.message || "Media blocked by entitlement"
        }
      });
    }
    if ("dualAudio" in responseBody) {
      this.dualAudio = responseBody.dualAudio;
    }
  }
  modifyLoadRequest(loadRequest) {
    loadRequest.originalAudioAllowed = this.dualAudio;
    return Promise.resolve(loadRequest);
  }
  replacePlaceholder(rawUrl, replacements) {
    return Object.entries(replacements).reduce((url, [placeholder, value]) => {
      return url.replace(placeholder, String(value));
    }, rawUrl);
  }
  isFetchResponse(response) {
    return !!response && typeof response === "object" && "status" in response && typeof response.status === "number" && "json" in response && typeof response.json === "function";
  }
};

// src/public/advertising-plugin.ts
var AdClipType = {
  /**
   * A clip which usually shows "Advertisement start" due to legal reasons.
   * No UI should be shown during this clip.
   */
  Opener: "opener",
  /**
   * A clip which usually shows "Advertisement finished" due to legal reasons.
   * No UI should be shown during this clip.
   */
  Closer: "closer",
  /**
   * A clip which usually shows the content provider for branding purposes.
   * No UI should be shown during this clip.
   */
  Bumper: "bumper",
  /**
   * A real advertisement clip.
   * The UI should be shown during this clip, but seek should be disabled.
   */
  Commercial: "commercial",
  /**
   * Non-linear ad which will be displayed around of the current content.
   * The content will be resized to fit into the designated space inside the ad.
   * The UI should be shown during this clip, but seek should be disabled.
   */
  ContentFrame: "contentframe",
  /**
   * Non-linear ad which will be displayed on top of the current content
   * No UI should be shown during this clip.
   */
  Overlay: "overlay",
  /**
   * Indicates the sponsored segment at the end of the AdSlot (eg. "presented by <Company>")
   */
  Sponsored: "sponsored",
  /**
   * Fallback if the type can not be determined.
   * This should not happen and will point to an invalid ad returned by the ad server.
   *
   * If this happens the UI should deem this like a `Commercial` clip and display the UI, without seek.
   */
  Unknown: "unknown"
};

// src/public/version.ts
var getVersion = () => {
  return "2.2.0";
};

// src/_internal/plugin/google-analytics-4/google-analytics-4-plugin.ts
var GoogleAnalytics4Plugin = class extends PlayerPlugin {
  constructor(player, pluginConfig) {
    super(player);
    this.pluginConfig = pluginConfig;
    this.DEFAULT_TRACKING_INTERVAL = 10;
    this.googleAnalyticsLogger = getLogger("plugin.googleAnalytics4");
    this.contentEndedEventWasFired = false;
    this.contentType = this.getContentType(this.pluginConfig.contentType);
    this.contentConfig = {
      id: "",
      headline: "",
      start_mode: player.state?.value?.startMethod === "autoplay" ? "auto" : "user",
      player_version: getVersion()
    };
  }
  getKey() {
    return "foundation.plugin.googleAnalytics4";
  }
  beforeSessionStart(pluginConfigs) {
    this.clearSubscriptions();
    const pluginConfig = pluginConfigs[this.getKey()];
    if (!pluginConfig) {
      return Promise.resolve();
    }
    this.lastTimerTriggered = void 0;
    this.contentEndedEventWasFired = false;
    this.pluginConfig = pluginConfig;
    this.contentType = this.getContentType(this.pluginConfig.contentType);
    this.createContentConfig();
    this.addInitialEvents();
    if (this.player.state.value.contentType !== ContentType.Advertisement) {
      this.addContentEvents();
    }
    const adPlugin = this.player.getAdvertisingPlugin();
    if (adPlugin) {
      this.addAdvertisingEvents(adPlugin.state);
    }
    return Promise.resolve();
  }
  getContentConfig() {
    return {
      ...this.contentConfig,
      start_mode: this.player.state.value.startMethod === "autoplay" ? "auto" : "user"
    };
  }
  addInitialEvents() {
    if (!this.player) {
      return;
    }
    this.trackOnce(
      (state) => state.state === "ready",
      () => {
        this.trackPi(`${this.contentType}_player_loaded`, {
          ...this.getContentConfig(),
          [`${this.contentType}_player_loaded`]: 1
        });
      }
    );
    this.trackOnce(
      (state) => state.state === "playing",
      () => {
        this.trackStart();
      }
    );
  }
  trackStart() {
    this.trackPi(`${this.contentType}_started`, {
      ...this.getContentConfig(),
      [`${this.contentType}_started`]: 1
    });
  }
  addAdvertisingEvents(state) {
    const adValueChange = this.track(state.onValueChange);
    adValueChange("numberOfStartedAdClips", (state2) => {
      if (state2.currentAdClip) {
        const adConfig = this.createAdSlotConfig(state2.currentAdClip);
        if (adConfig) {
          this.trackPi(`${this.contentType}_wb_started`, {
            ...adConfig,
            [`${this.contentType}_wb_started`]: 1
          });
        }
      }
    });
    adValueChange("playedAdClips", (state2) => {
      if (state2.playedAdClips.length > 0) {
        const adConfig = this.createAdSlotConfig(
          state2.playedAdClips[state2.playedAdClips.length - 1],
          state2.playedAdClips.length
        );
        if (adConfig) {
          this.trackPi(`${this.contentType}_wb_ended`, {
            ...adConfig,
            [`${this.contentType}_wb_ended`]: 1
          });
        }
      }
    });
    adValueChange("state", (state2, previousStateValue) => {
      if (!this.player) {
        return;
      }
      if (state2.state === "loading") {
        const adConfig = this.createAdConfig();
        if (adConfig) {
          this.trackPi(`${this.contentType}_wb_requested`, {
            ...adConfig,
            [`${this.contentType}_wb_requested`]: 1
          });
        }
      }
      const wbNotLoadedStates = ["ended", "error"];
      if (!wbNotLoadedStates.includes(previousStateValue) && wbNotLoadedStates.includes(state2.state)) {
        const adSlot = this.getCurrentAdSlot();
        const clipsNumber = state2.totalNumberOfAdClips;
        if (clipsNumber === 0 && adSlot) {
          const adConfig = this.createAdConfig();
          if (adConfig) {
            this.trackPi(`${this.contentType}_wb_not_loaded`, {
              ...adConfig,
              [`${this.contentType}_wb_not_loaded`]: 1
            });
          }
        }
      }
    });
  }
  addContentEvents() {
    if (!this.player) {
      return;
    }
    this.trackOnce(
      (state) => state.contentStarted,
      (state) => {
        if (!state.linearAdActive) {
          this.trackPi(`${this.contentType}_content_started`, {
            ...this.getContentConfig(),
            [`${this.contentType}_content_started`]: 1,
            length: Math.ceil(this.getDurationInSeconds() || 0)
          });
        }
        this.trackValueChange("state", (state2, previousState) => {
          if (state2.state === "paused" && previousState === "playing") {
            if (!this.isAd()) {
              this.trackPi(`${this.contentType}_paused`, this.getContentConfig());
            }
          }
          if (state2.state === "playing" && previousState === "paused") {
            if (!this.isAd()) {
              this.trackPi(`${this.contentType}_play_resumed`, this.getContentConfig());
            }
          }
          if (previousState === "seeking") {
            this.trackPi(`${this.contentType}_seeked`, {
              ...this.getContentConfig(),
              [`${this.contentType}_seeked`]: 1
            });
          }
        });
      }
    );
    this.trackValueChange("contentWatchTimeInSeconds", (state) => {
      if (state.contentWatchTimeInSeconds > 0 && !state.linearAdActive) {
        this.trackContentWatchTime(state);
      }
    });
    this.trackOnce(
      (state) => state.contentCompleted,
      (state) => {
        this.trackContentEndedOnce(state);
      }
    );
  }
  trackContentWatchTime(state) {
    if (!this.pluginConfig) {
      return;
    }
    const contentDurationInSeconds = this.getDurationInSeconds() || 0;
    const currentTimeInSeconds = Math.floor(state.currentTimeInSeconds || 0);
    const currentWatchTimeInSeconds = Math.floor(state.contentWatchTimeInSeconds || 0);
    if (!state.activeAsset?.livestream && contentDurationInSeconds - currentTimeInSeconds <= 3) {
      this.trackContentEndedOnce(state);
      return;
    }
    if (this.lastTimerTriggered !== currentWatchTimeInSeconds) {
      const progressTrackingIntervalInSeconds = this.pluginConfig.progressTrackingIntervalInSeconds || this.DEFAULT_TRACKING_INTERVAL;
      if (
        // At least 1 second has to be played, we don't want to send this too early :)
        state.contentWatchTimeInSeconds > 1 && Math.floor(state.contentWatchTimeInSeconds) % progressTrackingIntervalInSeconds === 0
      ) {
        this.lastTimerTriggered = currentWatchTimeInSeconds;
        this.trackPi(`${this.contentType}_progressed`, {
          ...this.getContentConfig(),
          [`${this.contentType}_progressed`]: progressTrackingIntervalInSeconds
        });
      }
    }
  }
  trackContentEndedOnce(state) {
    if (this.contentEndedEventWasFired) {
      return;
    }
    this.contentEndedEventWasFired = true;
    const progressedSinceLastTrackInSeconds = Math.max(
      (state.contentWatchTimeInSeconds || 0) - (this.lastTimerTriggered || 0),
      0
    );
    const remainingContentInSeconds = (this.getDurationInSeconds() || 0) - (state.currentTimeInSeconds || 0);
    this.trackPi(`${this.contentType}_content_ended`, {
      ...this.getContentConfig(),
      [`${this.contentType}_content_ended`]: 1,
      [`${this.contentType}_progressed`]: progressedSinceLastTrackInSeconds + remainingContentInSeconds
    });
  }
  trackPi(eventName, config) {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      media: void 0
    });
    window.dataLayer.push({
      event: eventName,
      media: config
    });
  }
  createContentConfig() {
    if (!this.pluginConfig) {
      return;
    }
    const state = this.player.state.value;
    this.trackValueChange("headline", (state2) => {
      this.contentConfig.headline = state2.headline || "";
    });
    this.contentConfig = {
      id: this.pluginConfig.id,
      headline: this.pluginConfig.headline || state.headline || "",
      player_version: getVersion() || "",
      start_mode: state.startMethod === "autoplay" ? "auto" : "user",
      type: this.pluginConfig.contentType || "video"
    };
    if (this.pluginConfig.tags?.length) {
      this.contentConfig.tags = this.pluginConfig.tags;
    }
    if (this.pluginConfig.editorialSources?.length) {
      this.contentConfig.editorial_sources = this.pluginConfig.editorialSources;
    }
    this.trackValueChange("title", (state2) => {
      this.contentConfig.first_headline = state2.title;
    });
    if (this.pluginConfig.firstHeadline || state.title) {
      this.contentConfig.first_headline = this.pluginConfig.firstHeadline || state.title;
    }
    this.trackValueChange("firstPublicationDate", (state2) => {
      this.contentConfig.first_publication_date = state2.firstPublicationDate;
    });
    if (this.pluginConfig.firstPublicationDate || state.firstPublicationDate) {
      this.contentConfig.first_publication_date = this.pluginConfig.firstPublicationDate || state.firstPublicationDate;
    }
    this.trackValueChange("lastPublicationDate", (state2) => {
      this.contentConfig.last_publication_date = state2.lastPublicationDate;
    });
    if (this.pluginConfig.lastPublicationDate || state.lastPublicationDate) {
      this.contentConfig.last_publication_date = this.pluginConfig.lastPublicationDate || state.lastPublicationDate;
    }
    if (this.pluginConfig.keywords) {
      this.contentConfig.keywords = this.pluginConfig.keywords;
    }
    if (this.pluginConfig.editorialUnit) {
      this.contentConfig.editorial_unit = this.pluginConfig.editorialUnit;
    }
    if (this.pluginConfig.embedType) {
      this.contentConfig.embed_type = this.pluginConfig.embedType;
    }
    if (this.pluginConfig.playlist) {
      this.contentConfig.playlist = this.pluginConfig.playlist;
    }
  }
  getCurrentAdSlot() {
    return this.player?.getAdvertisingPlugin()?.getCurrentAdSlot();
  }
  getCurrentAd() {
    return this.getAdvertisingState()?.value.currentAdClip;
  }
  createAdSlotConfig(currentAd, numberOfStartedCommercials) {
    if (!this.pluginConfig) {
      return;
    }
    const currentAdSlot = this.getCurrentAdSlot();
    if (!this.player || !currentAdSlot || !currentAd) {
      this.googleAnalyticsLogger.error("Advertising tracking called without playing ad.");
      return void 0;
    }
    const adType = this.mapAdType(currentAdSlot);
    if (adType === void 0) {
      return void 0;
    }
    if (!this.shouldTrackAdClip(currentAd?.type)) {
      return void 0;
    }
    return {
      ...this.getContentConfig(),
      ad_id: currentAd?.id,
      ad_slot: `${this.mapAdType(currentAdSlot)} ${numberOfStartedCommercials || this.getAdvertisingState()?.value.numberOfStartedCommercials}`,
      ad_type: adType,
      id: this.pluginConfig.id
    };
  }
  createAdConfig() {
    if (!this.pluginConfig) {
      return;
    }
    const adSlotState = this.getAdvertisingState()?.value.state;
    const adSlot = this.getCurrentAdSlot();
    if (adSlotState === "idle" || adSlotState === "ended" || !adSlot) {
      this.googleAnalyticsLogger.error("Advertising tracking called without playing ad.");
      return void 0;
    }
    const adType = this.mapAdType(adSlot);
    if (adType === void 0) {
      return void 0;
    }
    return {
      ...this.getContentConfig(),
      ad_type: adType,
      id: this.pluginConfig.id
    };
  }
  shouldTrackAdClip(type) {
    switch (type) {
      case AdClipType.Commercial:
      case AdClipType.Sponsored:
      case AdClipType.ContentFrame:
      case AdClipType.Overlay:
        return true;
    }
    return false;
  }
  mapAdType(ad) {
    if (ad.type === "non-linear") {
      return "nonlinear";
    }
    if (ad.offsetInSeconds === 0) {
      return "preroll";
    }
    if (ad.offsetInSeconds === -1) {
      return "postroll";
    }
    return "midroll";
  }
  getContentType(contentType) {
    switch (contentType) {
      case "audio":
      case "audioevent":
      case "audiolivestream":
        return "audio";
      case "video":
      case "videoevent":
      case "videolivestream":
        return "video";
      default:
        return "video";
    }
  }
  getDurationInSeconds() {
    return this.player?.state.value.activeAsset?.durationInSeconds;
  }
  isAd() {
    return this.player?.state.value.linearAdActive;
  }
  getAdvertisingState() {
    return this.player?.getAdvertisingPlugin()?.state;
  }
  trackOnce(condition, callback) {
    this.track(this.player.state.once)(condition, callback);
  }
  trackValueChange(key, callback) {
    this.track(this.player.state.onValueChange)(key, callback);
  }
};

// src/_internal/state/on-value-change.ts
function onValueChange(handler, initialValue) {
  let lastValue = initialValue;
  return (newValue) => {
    if (lastValue !== newValue) {
      lastValue = newValue;
      handler(newValue);
    }
  };
}
function onValueChangeAsync(handler, initialValue) {
  let lastValue = initialValue;
  return (newValue) => {
    if (lastValue !== newValue) {
      lastValue = newValue;
      return handler(newValue);
    }
    return Promise.resolve();
  };
}

// src/_internal/plugin/heartbeat/heartbeat-display-type.ts
var HeartbeatDisplayType = {
  /**
   * This roughly means that the player is embedded in a browser.
   *
   * @remarks
   * This is the fallback type if no specific type is applicable or given.
   */
  Online: 1,
  /**
   * The player is running on a mobile device.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  Smartphone: 2,
  /**
   * The player is running on a tablet.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  Tablet: 3,
  /**
   * The player is running on a SmartTV or a Set-Top-Box.
   * This includes all devices that are connected to a TV.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  SmartTV: 4,
  /**
   * The player is running on a streaming stick like Amazon Fire TV Stick or Google Chromecast.
   * Both are currently not applicable, because the HTML5 Foundation Player is not supported on these devices.
   */
  Stick: 5
};

// src/_internal/plugin/heartbeat/heartbeat-event.ts
var HeartbeatEvent = {
  /**
   * Event is sent once after 30s where watched.
   */
  Watched30Seconds: "5",
  /**
   * Event is sent once after 90s where watched.
   */
  Watched90Seconds: "8",
  /**
   * Event is sent once when the user passes 90% of the video duration
   */
  Duration90PercentReached: "6",
  /**
   * Event is sent once when the user passes 70% of the video duration
   */
  Duration70PercentReached: "9",
  /**
   * Event is sent once when the user passes 97% of the video duration
   */
  Duration97PercentReached: "4",
  /**
   * Content was started with a kids profile
   */
  KidsStart: "7",
  /**
   * The content reached the determine beat interval and will be tracked
   */
  Beat: "99"
};

// src/_internal/plugin/heartbeat/heartbeat-plugin.ts
var HeartbeatPlugin = class extends PlayerPlugin {
  constructor(player, pluginConfig, deviceType) {
    super(player);
    this.pluginConfig = pluginConfig;
    this.deviceType = deviceType;
    const { beatIntervalSeconds, parametersBaseObject } = this.setPluginParameters(
      this.pluginConfig
    );
    this.beatIntervalSeconds = beatIntervalSeconds;
    this.parametersBaseObject = parametersBaseObject;
  }
  getKey() {
    return "foundation.plugin.heartbeat";
  }
  // Setting up when Heartbeat should send what event and beat
  beforeSessionStart(pluginConfigs) {
    this.clearSubscriptions();
    const pluginConfig = pluginConfigs[this.getKey()];
    if (!pluginConfig) {
      return Promise.resolve();
    }
    this.pluginConfig = pluginConfig;
    const { beatIntervalSeconds, parametersBaseObject } = this.setPluginParameters(
      this.pluginConfig
    );
    this.beatIntervalSeconds = beatIntervalSeconds;
    this.parametersBaseObject = parametersBaseObject;
    let contentDuration;
    const trackedOnce = this.track(this.player.state.once);
    const trackedOnValueChange = this.track(this.player.state.onValueChange);
    trackedOnce(
      ({ contentStarted }) => contentStarted,
      ({ activeAsset, assetUrl }) => {
        if (!activeAsset || !assetUrl) {
          return;
        }
        const url = new URL(assetUrl);
        this.parametersBaseObject.videourl = url.pathname;
        if (this.pluginConfig.kidsProfile) {
          this.sendEvent(HeartbeatEvent.KidsStart);
        }
        contentDuration = activeAsset.durationInSeconds;
        if (!activeAsset.livestream) {
          this.registerDurationEvents(contentDuration);
        }
        const onBeatIndexChange = onValueChange((beatIndex) => {
          this.sendEvent(HeartbeatEvent.Beat, beatIndex);
        }, -1);
        trackedOnValueChange("contentWatchTimeInSeconds", ({ contentWatchTimeInSeconds }) => {
          const beatIndex = Math.trunc(contentWatchTimeInSeconds / this.beatIntervalSeconds);
          onBeatIndexChange(beatIndex);
        });
      }
    );
    trackedOnce(
      ({ contentWatchTimeInSeconds }) => contentWatchTimeInSeconds >= 30,
      () => {
        this.sendEvent(HeartbeatEvent.Watched30Seconds);
        trackedOnce(
          ({ contentWatchTimeInSeconds }) => contentWatchTimeInSeconds >= 90,
          () => {
            this.sendEvent(HeartbeatEvent.Watched90Seconds);
          }
        );
      }
    );
    return Promise.resolve();
  }
  setPluginParameters(pluginConfig) {
    const beatIntervalSeconds = pluginConfig.beatIntervalSeconds && pluginConfig.beatIntervalSeconds > 1 ? pluginConfig.beatIntervalSeconds : 30;
    const display = this.getDisplay(this.deviceType);
    const parametersBaseObject = {
      videoid: pluginConfig.id,
      ivw: pluginConfig.ivw || "/developer/default",
      angebot: pluginConfig.offer,
      videoservice: pluginConfig.videoService,
      paystatus: pluginConfig.payStatus || 0,
      starttype: pluginConfig.startType || 0,
      status: pluginConfig.userStatus || 0,
      display,
      rnd: -1,
      videourl: ""
    };
    return {
      beatIntervalSeconds,
      parametersBaseObject
    };
  }
  /**
   * At 70, 90 and 97 percent of the content duration, the corresponding events are sent.
   * @param contentDuration
   */
  registerDurationEvents(contentDuration) {
    const trackedOnce = this.track(this.player.state.once);
    const round = (value) => value >= 30 ? Math.ceil(value) : Math.floor(value);
    trackedOnce(
      ({ currentTimeInSeconds, linearAdActive }) => !linearAdActive && currentTimeInSeconds >= round(contentDuration * 0.7),
      () => {
        this.sendEvent(HeartbeatEvent.Duration70PercentReached);
      }
    );
    trackedOnce(
      ({ currentTimeInSeconds, linearAdActive }) => !linearAdActive && currentTimeInSeconds >= round(contentDuration * 0.9),
      () => {
        this.sendEvent(HeartbeatEvent.Duration90PercentReached);
      }
    );
    trackedOnce(
      ({ currentTimeInSeconds, linearAdActive }) => !linearAdActive && currentTimeInSeconds >= round(contentDuration * 0.97),
      () => {
        this.sendEvent(HeartbeatEvent.Duration97PercentReached);
      }
    );
  }
  getParametersWithBeatOrEvent(event, beatIndex) {
    const parameters = { ...this.parametersBaseObject };
    if (event === HeartbeatEvent.Beat) {
      parameters.beat = beatIndex;
    } else {
      parameters.event = event;
      parameters.value = 0;
    }
    parameters.rnd = Math.round(Number.MAX_SAFE_INTEGER * Math.random());
    return parameters;
  }
  loadPixel(src) {
    const image = new Image();
    image.src = src;
  }
  sendEvent(event, beatIndex) {
    const parameters = Object.entries(this.getParametersWithBeatOrEvent(event, beatIndex)).sort(
      (a, b) => a[0].localeCompare(b[0])
    );
    const endpoint = new URL(this.pluginConfig.endpoint);
    for (const [name, value] of parameters) {
      endpoint.searchParams.set(name, String(value));
    }
    this.loadPixel(endpoint.toString());
  }
  getDisplay(deviceType) {
    switch (deviceType) {
      case DeviceType.Desktop:
        return HeartbeatDisplayType.Online;
      case DeviceType.Mobile:
        return HeartbeatDisplayType.Smartphone;
      case DeviceType.Tablet:
        return HeartbeatDisplayType.Tablet;
      default:
        return HeartbeatDisplayType.SmartTV;
    }
  }
};

// src/_internal/plugin/media-session/media-session-plugin.ts
var MediaSessionPlugin = class extends PlayerPlugin {
  constructor(player, pluginConfig) {
    super(player);
    this.pluginConfig = pluginConfig;
    this.logger = getLogger("plugin.mediaSession");
  }
  getKey() {
    return "foundation.plugin.mediaSession";
  }
  beforeSessionStart(pluginConfigs) {
    this.clearSubscriptions();
    const trackedOnce = this.track(this.player.state.once);
    const trackedValueChange = this.track(this.player.state.onValueChange);
    const pluginConfig = pluginConfigs[this.getKey()];
    if (!pluginConfig) {
      this.logger.debug("MediaSession plugin not configured anymore, but still active");
    }
    this.logger.debug("Setting up MediaSession API");
    navigator.mediaSession.setActionHandler("play", async () => {
      await this.player.play();
      navigator.mediaSession.playbackState = "playing";
    });
    navigator.mediaSession.setActionHandler("pause", async () => {
      await this.player.pause();
      navigator.mediaSession.playbackState = "paused";
    });
    navigator.mediaSession.setActionHandler(
      "seekto",
      async (details) => {
        if (details.seekTime && this.shouldBeAllowedToSeek()) {
          await this.player.seekTo(details.seekTime);
        }
      }
    );
    navigator.mediaSession.setActionHandler(
      "seekbackward",
      async (details) => {
        if (this.shouldBeAllowedToSeek()) {
          const timeToSeekTo = this.player.state.value.currentTimeInSeconds - (details.seekOffset || 10);
          await this.player.seekTo(timeToSeekTo);
        }
      }
    );
    navigator.mediaSession.setActionHandler(
      "seekforward",
      async (details) => {
        if (this.shouldBeAllowedToSeek()) {
          const timeToSeekTo = this.player.state.value.currentTimeInSeconds + (details.seekOffset || 10);
          await this.player.seekTo(timeToSeekTo);
        }
      }
    );
    trackedValueChange("state", ({ state }) => {
      switch (state) {
        case "playing":
          navigator.mediaSession.playbackState = "playing";
          break;
        case "paused":
          navigator.mediaSession.playbackState = "paused";
          break;
      }
    });
    const updatePositionState = (state) => {
      if (state.activeAsset?.livestream) {
        navigator.mediaSession.setPositionState({
          duration: 0,
          playbackRate: 1,
          position: 0
        });
        return;
      }
      navigator.mediaSession.setPositionState({
        duration: state.activeAsset?.durationInSeconds || 0,
        playbackRate: state.playbackRate,
        position: state.currentTimeInSeconds
      });
    };
    trackedValueChange("currentTimeInSeconds", updatePositionState);
    trackedValueChange("activeAsset", updatePositionState);
    const updateMediaMetadata = (state) => {
      const artwork = [];
      const posterUrl = state.posterUrl || this.pluginConfig.posterUrl;
      if (posterUrl) {
        artwork.push({ src: posterUrl });
      }
      const data = {
        title: state.headline || this.pluginConfig.headline,
        artist: state.secondaryHeadline || this.pluginConfig.secondaryHeadline,
        artwork
      };
      this.logger.debug("Setting media metadata", data);
      navigator.mediaSession.metadata = new MediaMetadata(data);
    };
    trackedOnce(
      ({ startMethod }) => startMethod !== "not-started",
      (state) => {
        navigator.mediaSession.playbackState = state.state === "playing" ? "playing" : "paused";
        updateMediaMetadata(state);
      }
    );
    trackedValueChange("headline", updateMediaMetadata);
    trackedValueChange("secondaryHeadline", updateMediaMetadata);
    trackedValueChange("posterUrl", updateMediaMetadata);
    return Promise.resolve();
  }
  shouldBeAllowedToSeek() {
    const { linearAdActive, activeAsset } = this.player.state.value;
    return !linearAdActive && !activeAsset?.livestream;
  }
};

// src/_internal/plugin/nielsen/nielsen-events.ts
var NielsenEvents = {
  /**
   * This event should be triggered whenever the content starts playing e.g. when initial playback starts or after a pause.
   */
  LoadMetadata: "loadMetadata",
  /**
   * This event should be triggered whenever the content stops playing e.g. when the content is paused or interrupted by an ad.
   *
   * @remarks
   * The content session is still active in this case and does not mark the end of the content session, just that it was temporarily stopped.
   */
  Stop: "stop",
  /**
   * This event should be triggered whenever the content playhead changes.
   *
   * @remarks
   * The nielsen SDK will batch these events, so we do not have to throttle them.
   */
  SetPlayHead: "setPlayheadPosition",
  /**
   * This event should be triggered whenever the content session ends e.g. when the content finishes playing,
   * the user navigates away from the content, or the content is interrupted by new content.
   *
   * @remarks
   * This event should only be triggered once per content session.
   * No other events should be triggered after this event except for the `LoadMetadata` event.
   */
  End: "end"
};

// src/_internal/plugin/nielsen/vendor/nielsen.js
function loadNielsenSDK(appId, playerIdentifier, config) {
  !(function(e, n) {
    function t(e2) {
      return "object" == typeof e2 ? JSON.parse(JSON.stringify(e2)) : e2;
    }
    e[n] = e[n] || {
      nlsQ: function(o, r, c) {
        var s = e.document, a = s.createElement("script");
        a.async = 1, a.src = ("http:" === e.location.protocol ? "http:" : "https:") + "//cdn-gl.nmrodam.com/conf/" + o + ".js#name=" + r + "&ns=" + n;
        var i = s.getElementsByTagName("script")[0];
        return i.parentNode.insertBefore(a, i), e[n][r] = e[n][r] || {
          g: c || {},
          ggPM: function(o2, c2, s2, a2, i2) {
            e[n][r].q = e[n][r].q || [];
            try {
              var l = t([o2, c2, s2, a2, i2]);
              e[n][r].q.push(l);
            } catch (e2) {
              console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.");
            }
          },
          trackEvent: function(o2) {
            e[n][r].te = e[n][r].te || [];
            try {
              var c2 = t(o2);
              e[n][r].te.push(c2);
            } catch (e2) {
              console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.");
            }
          }
        }, e[n][r];
      }
    };
  })(window, "NOLBUNDLE");
  return window.NOLBUNDLE.nlsQ(appId, playerIdentifier, config);
}

// src/_internal/plugin/nielsen/nielsen-plugin.ts
var NielsenPlugin = class extends PlayerPlugin {
  constructor() {
    super(...arguments);
    this.isActive = false;
    this.beforeWindowUnload = () => {
      if (this.sdk && this.isActive) {
        this.sdk.ggPM(NielsenEvents.End, this.getPlayHead());
        this.isActive = false;
      }
    };
    this.getPlayHead = () => this.player.state.value.activeAsset?.livestream ? Math.floor(Date.now() / 1e3) : Math.floor(this.player.state.value.currentTimeInSeconds);
  }
  getKey() {
    return "foundation.plugin.nielsen";
  }
  initializeSDK(appId, debug) {
    const config = {
      nol_sdkDebug: debug ? "debug" : void 0
    };
    return loadNielsenSDK(appId, `Foundation Player ${"2.2.0"}`, config);
  }
  beforeSessionStart(pluginConfigs) {
    this.clearSubscriptions();
    const pluginConfig = pluginConfigs[this.getKey()];
    if (!pluginConfig) {
      return Promise.resolve();
    }
    this.sdk = this.initializeSDK(pluginConfig.appId, Boolean(pluginConfig.debug));
    const trackedOnce = this.track(this.player.state.once);
    const trackedOnValueChange = this.track(this.player.state.onValueChange);
    let stopSubscription;
    let endSubscription;
    const onActivation = () => {
      if (!this.sdk) {
        return;
      }
      this.sdk.ggPM(NielsenEvents.LoadMetadata, pluginConfig.metadata);
      this.isActive = true;
      stopSubscription?.();
      endSubscription?.();
      const onFullSecondChange = onValueChange((currentTimeInSeconds) => {
        if (!this.sdk || !this.isActive) {
          return;
        }
        this.sdk.ggPM(NielsenEvents.SetPlayHead, currentTimeInSeconds);
      }, this.getPlayHead());
      const timeSubscription = trackedOnValueChange("currentTimeInSeconds", () => {
        onFullSecondChange(this.getPlayHead());
      });
      stopSubscription = trackedOnce(
        ({ state, linearAdActive }) => this.isActive && (linearAdActive || ["paused", "stopped", "error"].includes(state)),
        () => {
          if (!this.sdk) {
            return;
          }
          timeSubscription();
          this.sdk.ggPM(NielsenEvents.Stop, this.getPlayHead());
          startWatcher();
        }
      );
      endSubscription = trackedOnce(
        ({ contentCompleted, state }) => this.isActive && (contentCompleted || state === "destroyed"),
        () => {
          if (!this.sdk) {
            return;
          }
          timeSubscription();
          stopSubscription?.();
          if (this.isActive) {
            this.sdk.ggPM(NielsenEvents.End, this.getPlayHead());
            this.isActive = false;
          }
        }
      );
    };
    const startWatcher = () => trackedOnce(
      ({ state, linearAdActive, contentStarted }) => state === "playing" && !linearAdActive && contentStarted,
      onActivation
    );
    startWatcher();
    trackedOnce(
      ({ contentCompleted, sessionCompleted }) => (contentCompleted || sessionCompleted) && this.isActive,
      () => {
        if (!this.sdk) {
          return;
        }
        this.sdk.ggPM(NielsenEvents.End, this.getPlayHead());
        this.isActive = false;
      }
    );
    return Promise.resolve();
  }
};

// src/_internal/plugin/rcu-bindings/action-button-mappings.ts
var keyboard = {
  playPause: ["Space", "Enter"],
  seekForward: ["ArrowRight"],
  seekBackward: ["ArrowLeft"],
  volumeUp: ["ArrowUp"],
  volumeDown: ["ArrowDown"],
  exit: ["Escape"]
};
var tizenRemote = {
  playPause: ["Space", "Enter", 13],
  seekForward: ["ArrowRight", 39],
  seekBackward: ["ArrowLeft", 37],
  volumeUp: [],
  // volume is usually controlled by the tv
  volumeDown: [],
  // volume is usually controlled by the tv
  exit: ["Escape", 10009]
};
var lgRemote = {
  play: [415],
  pause: [19],
  playPause: [],
  // 13, but it sometimes doesn't work?!
  seekForward: [39],
  seekBackward: [37],
  volumeUp: [],
  // volume is usually controlled by the tv
  volumeDown: [],
  // volume is usually controlled by the tv
  exit: [461]
};
var skyRemote = {
  playPause: [13, 179],
  seekForward: [228],
  seekBackward: [227],
  volumeUp: [],
  // volume is usually controlled by the tv
  volumeDown: [],
  // volume is usually controlled by the tv
  exit: [27]
};
var magentaG4Remote = {
  playPause: [463, 13],
  seekForward: [39, 417],
  seekBackward: [37, 412],
  volumeUp: [],
  // volume is usually controlled by the tv
  volumeDown: [],
  // volume is usually controlled by the tv
  exit: [461]
};
var magentaG5Remote = {
  playPause: [13],
  seekForward: [39],
  seekBackward: [37],
  volumeUp: [],
  // volume is usually controlled by the tv
  volumeDown: [],
  // volume is usually controlled by the tv
  exit: [461]
};
var vodafoneGtvRemote = {
  playPause: [179],
  seekForward: [227],
  seekBackward: [228],
  volumeUp: [],
  // volume is usually controlled by the tv/stv
  volumeDown: [],
  // volume is usually controlled by the tv/stv
  exit: [461]
};
var vodafoneVtvRemote = {
  play: [415],
  pause: [19],
  playPause: [463],
  seekForward: [417],
  seekBackward: [412],
  volumeUp: [],
  // volume is usually controlled by the tv/stv
  volumeDown: [],
  // volume is usually controlled by the tv/stv
  exit: [461]
};
var telecolumbusRemote = {
  playPause: [13],
  seekForward: [39],
  seekBackward: [37],
  volumeUp: [],
  // volume is usually controlled by the tv
  volumeDown: [],
  // volume is usually controlled by the tv
  exit: ["BrowserBack", 461]
};
function getActionButtonMapping(deviceType) {
  switch (deviceType) {
    case DeviceType.Vodafone_Gtv:
      return vodafoneGtvRemote;
    case DeviceType.Vodafone_Vtv:
      return vodafoneVtvRemote;
    case DeviceType.Webos_3:
    case DeviceType.Webos_4:
    case DeviceType.Webos_5:
    case DeviceType.Webos_6:
    case DeviceType.Webos_22:
    case DeviceType.Webos_23:
    case DeviceType.Webos_24:
    case DeviceType.Webos_25:
      return lgRemote;
    case DeviceType.Tizen_3_0:
    case DeviceType.Tizen_4_0:
    case DeviceType.Tizen_5_0:
    case DeviceType.Tizen_5_5:
    case DeviceType.Tizen_6_0:
    case DeviceType.Tizen_6_5:
    case DeviceType.Tizen_7_0:
    case DeviceType.Tizen_8_0:
    case DeviceType.Tizen_9_0:
      return tizenRemote;
    case DeviceType.Magenta_G4:
      return magentaG4Remote;
    case DeviceType.Magenta_G5:
      return magentaG5Remote;
    case DeviceType.Skyq:
    case DeviceType.Skyxione:
    case DeviceType.Skystream:
      return skyRemote;
    case DeviceType.Telecolumbus:
      return telecolumbusRemote;
    default:
      return keyboard;
  }
}

// src/_internal/plugin/rcu-bindings/rcu-bindings-plugin.ts
var RcuBindingsPlugin = class extends PlayerPlugin {
  constructor(player, pluginConfig, mountPoint, deviceType) {
    super(player);
    this.pluginConfig = pluginConfig;
    this.mountPoint = mountPoint;
    this.logger = getLogger("plugin.rcuBindings");
    this.actionButtonMapping = getActionButtonMapping(deviceType);
    this.seekOffsetInSeconds = this.pluginConfig.seekOffsetInSeconds || 10;
    this.volumeOffsetInPercent = this.pluginConfig.volumeOffsetInPercent || 0.05;
    this.overlay = document.createElement("div");
    this.overlay.id = "foundation-rcu-plugin";
    this.overlay.setAttribute(
      "style",
      `
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      position: absolute;
      color: white;
    `
    );
    mountPoint.appendChild(this.overlay);
    const top = document.createElement("div");
    top.setAttribute(
      "style",
      `
      width: 100%;
      height: 1.5rem;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      position: absolute;
    `
    );
    this.overlay.appendChild(top);
    const bottom = document.createElement("div");
    bottom.setAttribute(
      "style",
      `
      width: 100%;
      height: 3.5rem;
      background: rgba(0, 0, 0, 0.5);
      bottom: 0;
      left: 0;
      position: absolute;
    `
    );
    this.overlay.appendChild(bottom);
    this.version = document.createElement("span");
    this.version.setAttribute(
      "style",
      `left: 0.25rem;
      position: absolute;
    `
    );
    this.overlay.appendChild(this.version);
    this.bitrate = document.createElement("span");
    this.bitrate.setAttribute(
      "style",
      `left: 15rem;
      position: absolute;
    `
    );
    this.overlay.appendChild(this.bitrate);
    this.volume = document.createElement("span");
    this.volume.setAttribute(
      "style",
      `margin-left: 1rem;
      right: 0.25rem;
      position: absolute;
    `
    );
    this.overlay.appendChild(this.volume);
    this.language = document.createElement("span");
    this.language.setAttribute(
      "style",
      `left: 0.25rem;
      bottom: 2rem;
      position: absolute;
    `
    );
    this.overlay.appendChild(this.language);
    this.progress = document.createElement("span");
    this.progress.setAttribute(
      "style",
      `left: 0.25rem;
      bottom: 0.25rem;
      position: absolute;
    `
    );
    this.overlay.appendChild(this.progress);
    this.progressBar = document.createElement("div");
    this.progressBar.setAttribute(
      "style",
      `left: 10rem;
      bottom: 0.25rem;
      position: absolute;
      background: white;
      height: 1rem;
    `
    );
    this.overlay.appendChild(this.progressBar);
  }
  getKey() {
    return "foundation.plugin.rcuBindings";
  }
  pad(num) {
    const st = `00${num}`;
    return st.substring(st.length - 2);
  }
  formatTime(value) {
    const hours = this.pad(Math.floor(value / 3600));
    const minutes = this.pad(Math.floor((value - Number.parseInt(hours, 10) * 3600) / 60));
    const seconds = this.pad(Math.floor(value) % 60);
    return `${hours}:${minutes}:${seconds}`;
  }
  beforeSessionStart(pluginConfigs) {
    this.clearSubscriptions();
    const trackedValueChange = this.track(this.player.state.onValueChange);
    const pluginConfig = pluginConfigs[this.getKey()];
    if (!pluginConfig) {
      this.logger.debug("RCU bindings plugin not configured anymore, but still active");
    }
    const onKeydown = (event) => {
      const action = this.getAction(event);
      if (action) {
        this.handleAction(action);
      }
    };
    document.addEventListener("keydown", onKeydown);
    this.subscriptions.push(() => document.removeEventListener("keydown", onKeydown));
    trackedValueChange("volume", (state) => {
      if (state.muted) {
        this.volume.innerHTML = "Volume: muted";
        return;
      }
      this.volume.innerHTML = `Volume: ${Math.round(state.volume * 100)}%`;
    });
    trackedValueChange("currentAudioTrack", (state) => {
      if (!state.currentAudioTrack) {
        this.language.innerHTML = "Language: unknown";
        return;
      }
      this.language.innerHTML = `Language: ${state.currentAudioTrack.label} (id=${state.currentAudioTrack.trackId}, lang=${state.currentAudioTrack.language})`;
    });
    trackedValueChange("currentVideoTrack", (state) => {
      if (!state.currentVideoTrack) {
        this.bitrate.innerHTML = "Bitrate: unknown";
        return;
      }
      const currentBitrate = state.currentVideoTrack.bitrateInKbps;
      const currentResolution = `${state.currentVideoTrack.width}x${state.currentVideoTrack.height}`;
      this.bitrate.innerHTML = `Bitrate: ${currentBitrate} kbit/s (${currentResolution})(id=${state.currentVideoTrack.trackId})`;
    });
    trackedValueChange("currentTimeInSeconds", (state) => {
      const isLive = state.activeAsset?.livestream || false;
      const duration = state.activeAsset?.durationInSeconds || 0;
      const playhead = state.currentTimeInSeconds;
      if (duration === 0) {
        return;
      }
      if (isLive) {
        const now = Date.now() / 1e3;
        const offset = now - playhead;
        this.progress.innerHTML = `Playhead: ${playhead} - Now: ${now} - Offset: ${offset}`;
      } else {
        this.progress.innerHTML = `${this.formatTime(playhead)}/${this.formatTime(duration)}`;
      }
      const playerWidth = this.mountPoint.getBoundingClientRect().width;
      const progressWidth = this.progress.getBoundingClientRect().width;
      const padding = 10 * 16;
      const maxProgressBarWidth = playerWidth - progressWidth - padding;
      const progressBarWidth = maxProgressBarWidth / duration * playhead;
      this.progressBar.style.width = isLive ? "0" : `${progressBarWidth || 0}px`;
    });
    trackedValueChange("activeAsset", () => {
      const version = getVersion();
      const flavor = this.player.getActivePlayerAdapter()?.getPlayerType() || "unknown";
      this.version.innerHTML = `Version: ${version} (${flavor})`;
    });
    return Promise.resolve();
  }
  getAction(event) {
    const keyMappings = Object.entries(this.actionButtonMapping);
    const entry = keyMappings.find(([_, keyCodes]) => {
      return (keyCodes || []).find((keyCode) => {
        return typeof keyCode === "string" && keyCode === event.code || typeof keyCode === "number" && keyCode === event.keyCode;
      });
    });
    return entry ? entry[0] : void 0;
  }
  handleAction(action) {
    const currentTime = this.player.state.value.currentTimeInSeconds;
    const volume = this.player.state.value.volume;
    switch (action) {
      case "play":
        void this.player.play();
        break;
      case "pause":
        void this.player.pause();
        break;
      case "playPause":
        void this.togglePlayout();
        break;
      case "seekForward":
        void this.player.seekTo(currentTime + this.seekOffsetInSeconds);
        break;
      case "seekBackward":
        void this.player.seekTo(currentTime - this.seekOffsetInSeconds);
        break;
      case "volumeUp":
        void this.player.setVolume(volume + this.volumeOffsetInPercent);
        break;
      case "volumeDown":
        void this.player.setVolume(volume - this.volumeOffsetInPercent);
        break;
      case "exit":
        void this.handleExit();
        break;
      default:
        console.error(`Unkown action '${action}'`);
        break;
    }
  }
  togglePlayout() {
    return this.player.state.value.state === "playing" ? this.player.pause() : this.player.play();
  }
  async handleExit() {
    await this.player.destroy("user-remote-control-unit");
    history.back();
  }
};

// src/_internal/plugin/stream-fallback/stream-fallback-plugin.ts
var StreamFallbackPlugin = class extends PlayerPlugin {
  constructor(player) {
    super(player);
    this.logger = getLogger("plugin.streamFallback");
    this.endSafetyIntervalInSeconds = 30;
    this.minTimeBetweenFallbacksInMilliseconds = 15e3;
    /**
     * This value is only relevant for the fallbacks during the stream,
     * since fallbacks during the start are handled in the player, not here.
     *
     * For example if we have an RTL+ Livestream with the following assets:
     * - Yospace
     * - HD Prod CDN
     * - SD Prod CDN
     * - HD Backup CDN
     * - SD Backup CDN
     *
     * The player will first iterate through the assets during the start.
     * Once this plugin kicks in we will almost always fallback on the same asset URL,
     * which is fine, because we can still exhaust the entire asset list before the player gives up.
     *
     * What we want to prevent is that we e.g. have one Asset URL and a user leaves the tab open for hours,
     * where the first attempt fails due to a timeout or stall and the player may happily restart every 15 seconds,
     * which screw up analytics and also puts unnecessary load on the infrastructure.
     */
    this.maxFallbackAttemptsPerContentId = 3;
    /**
     * The last time we tried to recover from an error via Date.now().
     */
    this.lastFallbackAttemptAtTime = void 0;
    this.isProcessingError = false;
    this.contentTimeInSeconds = 0;
    this.contentDurationInSeconds = 0;
    this.retriedContentIds = [];
    this.player.state.onValueChange(
      "currentTimeInSeconds",
      ({ currentTimeInSeconds, linearAdActive, activeAsset }) => {
        if (!activeAsset || linearAdActive) {
          return;
        }
        this.contentTimeInSeconds = currentTimeInSeconds;
        this.contentDurationInSeconds = activeAsset.durationInSeconds;
      }
    );
  }
  getKey() {
    return "foundation.plugin.streamFallback";
  }
  async beforeError(error) {
    if (this.isProcessingError) {
      this.logger.warn("Already processing an error, skipping this one.", { error });
      return false;
    }
    if (!this.shouldProcessError(error)) {
      return true;
    }
    this.isProcessingError = true;
    this.logger.warn("Processing error, trying to recover from it.", {
      error,
      contentTimeInSeconds: this.contentTimeInSeconds,
      contentDurationInSeconds: this.contentDurationInSeconds,
      retryAttempts: this.retriedContentIds.length,
      lastFallbackAttemptAtTime: this.lastFallbackAttemptAtTime,
      now: Date.now()
    });
    this.retriedContentIds.push(this.player.state.value.contentId);
    this.lastFallbackAttemptAtTime = Date.now();
    void this.player.replay({
      // We add 1 second to the current time to ensure that we do not replay the same segment again or ad slot again,
      // which may have caused the error in the first place.
      startTimeInSeconds: this.contentTimeInSeconds + 1,
      skipPreRolls: true
    }).finally(() => {
      this.isProcessingError = false;
    });
    return false;
  }
  hasReachedSafeEndTime() {
    if (!this.contentDurationInSeconds || this.contentDurationInSeconds <= 0) {
      return false;
    }
    return this.contentTimeInSeconds >= this.contentDurationInSeconds - this.endSafetyIntervalInSeconds;
  }
  shouldProcessError(error) {
    if (error.code === ErrorCodes.OPERATION_ABORTED_35400.code && this.player.state.value.startMethod === "not-started") {
      this.logger.debug("Abort Error triggered during start, trying fallback handling", {
        error,
        startMethod: this.player.state.value.startMethod
      });
      return true;
    }
    if (this.player.state.value.startMethod === "not-started") {
      this.logger.debug(
        "Player has not started yet, skipping error processing for in-stream fallback.",
        {
          error,
          startMethod: this.player.state.value.startMethod
        }
      );
      return false;
    }
    const now = Date.now();
    if (this.lastFallbackAttemptAtTime && Math.abs(now - this.lastFallbackAttemptAtTime) < this.minTimeBetweenFallbacksInMilliseconds) {
      this.logger.warn(
        "Not enough watch time has passed since the last fallback attempt, skipping this error.",
        {
          error,
          lastFallbackAttemptAtTime: this.lastFallbackAttemptAtTime,
          contentTimeInSeconds: this.contentTimeInSeconds,
          minTimeBetweenFallbacksInMilliseconds: this.minTimeBetweenFallbacksInMilliseconds,
          now
        }
      );
      return false;
    }
    const contentId = this.player.state.value.contentId;
    const attemptsForCurrentContentId = this.retriedContentIds.filter(
      (id) => id === contentId
    ).length;
    if (attemptsForCurrentContentId >= this.maxFallbackAttemptsPerContentId) {
      this.logger.warn(
        "Exhausted max fallback attempts for the current content, skipping this error.",
        {
          error,
          contentId,
          retriedContentIds: this.retriedContentIds
        }
      );
      return false;
    }
    if (this.hasReachedSafeEndTime()) {
      this.logger.debug("Stream is close to the end, do not attempt fallback anymore", {
        error,
        contentTimeInSeconds: this.contentTimeInSeconds,
        contentDurationInSeconds: this.contentDurationInSeconds
      });
      return false;
    }
    const ignoredErrorCodes = [
      ErrorCodes.GEOBLOCKING_12100.code,
      // geo-blocking will not be immediately resolved by a retry
      ErrorCodes.MAX_CONCURRENT_STREAMS_REACHED_33100.code,
      // same goes for max concurrent streams
      ErrorCodes.ADBLOCKER_DETECTED_34100.code
      // HOMAD should not cause a retry
    ];
    if (ignoredErrorCodes.includes(error.code)) {
      this.logger.debug("Ignoring error, as it is not recoverable by the stream fallback plugin.", {
        error,
        ignoredErrorCodes
      });
      return false;
    }
    return true;
  }
};

// src/_internal/plugin/visibility/visibility-plugin.ts
var VisibilityPlugin = class extends PlayerPlugin {
  constructor(player, pluginConfig, mountPoint) {
    super(player);
    this.pluginConfig = pluginConfig;
    this.mountPoint = mountPoint;
    this.playerIntersectionThreshold = 0.5;
    this.playerIntersectionRatio = 1;
    // properties for handling page visibility
    this.visibilityListenerRegistered = false;
    this.pageVisibility = "visible";
    /** True when the player was paused either by player or page visibility */
    this.adsPausedByVisibility = false;
    this.contentPausedByVisibility = false;
    // the intersection observer works different on webkit devices. To handle playback
    // properly on those devices we have to check/save if the device is in fullscreen
    this.webkitDisplayingFullscreen = false;
    this.visibilityChangeEvent = async () => {
      if (document.hidden) {
        this.pageVisibility = "hidden";
        await this.onPageLeave();
      } else {
        this.pageVisibility = "visible";
        await this.onPageEnter(this.playerIsVisible());
      }
    };
  }
  getKey() {
    return "foundation.plugin.visibility";
  }
  getPlugin() {
    return this;
  }
  shouldPauseAdsOnLeave() {
    return this.pluginConfig?.pauseAds ?? true;
  }
  shouldPauseContentOnLeave() {
    return this.pluginConfig?.pauseContent ?? false;
  }
  beforeSessionStart() {
    if (!this.player) {
      return Promise.resolve();
    }
    this.player.state.once(
      ({ state }) => state === "destroyed",
      () => {
        this.unbindVisibility();
      }
    );
    this.player.state.onValueChange("state", ({ state }) => {
      if (state === "playing") {
        this.contentPausedByVisibility = false;
        this.adsPausedByVisibility = false;
      }
    });
    const videoElement = this.findVideoElementInMountPoint();
    if (videoElement) {
      videoElement.addEventListener("webkitbeginfullscreen", () => {
        this.webkitDisplayingFullscreen = true;
        this.onPlayerEnteredViewport(true);
      });
      videoElement.addEventListener("webkitendfullscreen", () => {
        this.webkitDisplayingFullscreen = false;
        if (this.playerIntersectionRatio < this.playerIntersectionThreshold) {
          this.onPlayerLeftViewport();
        }
      });
    }
    this.initVisibility();
    return Promise.resolve();
  }
  /**
   * Called when the video element is less than 50% in the visible part of the
   * viewport.
   */
  onPlayerLeftViewport() {
    if (this.player.isFullscreen()) {
      return;
    }
    if (this.shouldPauseAds()) {
      void this.player.pause();
      this.adsPausedByVisibility = true;
    }
    if (this.shouldPauseContent()) {
      void this.player.pause();
      this.contentPausedByVisibility = true;
    }
  }
  shouldPauseAds() {
    return this.player.state.value.state === "playing" && this.shouldPauseAdsOnLeave() && this.isLinearAdActive();
  }
  shouldPauseContent() {
    return this.player.state.value.state === "playing" && this.shouldPauseContentOnLeave() && !this.isLinearAdActive();
  }
  shouldResumeAds() {
    return this.shouldPauseAdsOnLeave() && this.adsPausedByVisibility && this.isLinearAdActive();
  }
  shouldResumeContent() {
    return this.shouldPauseContentOnLeave() && this.contentPausedByVisibility && !this.isLinearAdActive();
  }
  /**
   * Called when the visibility of the video element changed from below 50% to
   * above 50%.
   * @param playerVisible: The page is visible and the player is in the viewport
   */
  async onPlayerEnteredViewport(playerVisible) {
    if (!this.player || !playerVisible || this.player.state.value.state === "playing") {
      return;
    }
    if (this.shouldResumeAds()) {
      this.adsPausedByVisibility = false;
      await this.player.play();
    } else if (this.shouldResumeContent()) {
      this.contentPausedByVisibility = false;
      await this.player.play();
    }
  }
  /**
   * Checks whether the player is in the viewport and the page is visible.
   * @private
   */
  playerIsVisible() {
    return this.pageVisibility === "visible" && this.playerIntersectionRatio >= this.playerIntersectionThreshold;
  }
  initVisibility() {
    if (!this.player || this.visibilityListenerRegistered || // if no pausing is wanted for either ads or content don't init
    !(this.shouldPauseAdsOnLeave() || this.shouldPauseContentOnLeave())) {
      return;
    }
    this.pageVisibility = document.hidden ? "hidden" : "visible";
    this.player.state.onValueChange("currentTimeInSeconds", async () => {
      if (this.pageVisibility === "hidden") {
        await this.onPageLeave();
      }
      if (this.playerIntersectionRatio < this.playerIntersectionThreshold && !this.webkitDisplayingFullscreen) {
        this.onPlayerLeftViewport();
      }
    });
    this.useVisibilityListener();
    this.useIntersectionObserver();
  }
  isLinearAdActive() {
    return this.player.state.value.linearAdActive;
  }
  /**
   * Called when the page is no longer visible, for example when the user
   * switches to another tab or app.
   */
  async onPageLeave() {
    if (this.shouldPauseAds()) {
      await this.player.pause();
      this.adsPausedByVisibility = true;
    } else if (this.shouldPauseContent()) {
      await this.player.pause();
      this.contentPausedByVisibility = true;
    }
  }
  /**
   * Called when the page is visible again, for example when the user
   * comes back from another tab or app.
   * @param playerVisible: The page is visible and the player is in the viewport
   */
  async onPageEnter(playerVisible) {
    if (!this.player || !playerVisible || this.player.state.value.state === "playing") {
      return;
    }
    if (this.shouldResumeAds()) {
      await this.player.play();
      this.adsPausedByVisibility = false;
    } else if (this.shouldResumeContent()) {
      await this.player.play();
      this.contentPausedByVisibility = false;
    }
  }
  useVisibilityListener() {
    document.addEventListener("visibilitychange", this.visibilityChangeEvent);
    this.visibilityListenerRegistered = true;
  }
  useIntersectionObserver() {
    if (!this.player) {
      return;
    }
    if ("IntersectionObserver" in window) {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          this.playerIntersectionRatio = entries[0]?.intersectionRatio ?? 1;
          if (!this.webkitDisplayingFullscreen) {
            const playerIsInViewport = this.playerIntersectionRatio >= this.playerIntersectionThreshold;
            if (playerIsInViewport) {
              this.onPlayerEnteredViewport(this.playerIsVisible());
            } else {
              this.onPlayerLeftViewport();
            }
          }
        },
        { threshold: this.playerIntersectionThreshold }
      );
      this.intersectionObserver.observe(this.mountPoint);
    }
  }
  unbindVisibility() {
    if (this.visibilityListenerRegistered) {
      document.removeEventListener("visibilitychange", this.visibilityChangeEvent);
      this.visibilityListenerRegistered = false;
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = void 0;
    }
  }
  findVideoElementInMountPoint() {
    return findVideoElement(this.mountPoint);
  }
};

// src/_internal/create-player/construct-plugins-and-adapters.ts
var constructPluginsAndAdapters = (player, payload) => {
  const {
    deviceType,
    pluginConfigs,
    playerId,
    resolvedModules,
    manifestConfiguration,
    mountPoint,
    getRequestHeader,
    loadRequest,
    tweaks
  } = payload;
  const partialModules = {};
  for (const module of resolvedModules) {
    partialModules[module[0]] = module[1];
  }
  const plugins = [];
  const playerAdapters = [];
  const mustConstructPlugin = (key) => {
    const config = pluginConfigs[key];
    if (!config) {
      return void 0;
    }
    if (player.hasPlugin(key)) {
      return void 0;
    }
    return config;
  };
  const npawConfig = mustConstructPlugin("foundation.plugin.npaw");
  if (npawConfig) {
    const module = partialModules["@foundation-player/plugin-npaw"];
    if (!module) {
      throw createFoundationError(
        "NPAW plugin is not available, but must be!",
        {
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    plugins.push(new module.NpawPlugin(player, npawConfig, deviceType, playerId));
  }
  const posthogConfig = mustConstructPlugin("foundation.plugin.posthog");
  if (posthogConfig) {
    const module = partialModules["@foundation-player/plugin-posthog"];
    if (!module) {
      throw createFoundationError(
        "Posthog plugin is not available, but must be!",
        {
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    plugins.push(new module.PosthogPlugin(player, posthogConfig, deviceType, playerId));
  }
  const smartclipConfig = mustConstructPlugin("foundation.plugin.smartclip");
  if (smartclipConfig) {
    const module = partialModules["@foundation-player/plugin-smartclip"];
    if (!module) {
      throw createFoundationError(
        "Smartclip plugin is not available, but must be!",
        {
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    const plugin = new module.SmartclipPlugin(
      player,
      smartclipConfig,
      mountPoint,
      loadRequest.user?.consentString
    );
    plugins.push(plugin);
    player.setAdvertisingPlugin(plugin.getPlugin());
  }
  const uiConfig = mustConstructPlugin("foundation.plugin.ui");
  if (uiConfig) {
    const module = partialModules["@foundation-player/plugin-ui"];
    if (!module) {
      throw createFoundationError(
        "UI plugin is not available, but must be!",
        {
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    plugins.push(new module.UiPlugin(player, mountPoint, uiConfig));
  }
  const shortsConfig = mustConstructPlugin("foundation.plugin.shortsUi");
  if (shortsConfig) {
    const module = partialModules["@foundation-player/plugin-shorts"];
    if (!module) {
      throw createFoundationError(
        "Shorts plugin is not available, but must be!",
        {
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    plugins.push(new module.ShortsUiPlugin(player, mountPoint, shortsConfig));
  }
  if (mustConstructPlugin("foundation.plugin.concurrentStreamCheck")) {
    plugins.push(new ConcurrentStreamCheckPlugin(player, getRequestHeader));
  }
  if (mustConstructPlugin("foundation.plugin.nielsen")) {
    plugins.push(new NielsenPlugin(player));
  }
  if (mustConstructPlugin("foundation.plugin.deviceHeader")) {
    plugins.push(new DeviceHeaderPlugin(player));
  }
  if (mustConstructPlugin("foundation.plugin.entitlement")) {
    plugins.push(new EntitlementPlugin(player, getRequestHeader));
  }
  const heartbeatConfig = mustConstructPlugin("foundation.plugin.heartbeat");
  if (heartbeatConfig) {
    plugins.push(new HeartbeatPlugin(player, heartbeatConfig, deviceType));
  }
  const googlePluginConfig = mustConstructPlugin("foundation.plugin.googleAnalytics4");
  if (googlePluginConfig) {
    plugins.push(new GoogleAnalytics4Plugin(player, googlePluginConfig));
  }
  const mediaSessionConfig = mustConstructPlugin("foundation.plugin.mediaSession");
  if (mediaSessionConfig) {
    plugins.push(new MediaSessionPlugin(player, mediaSessionConfig));
  }
  const rcuConfig = mustConstructPlugin("foundation.plugin.rcuBindings");
  if (rcuConfig) {
    plugins.push(new RcuBindingsPlugin(player, rcuConfig, mountPoint, deviceType));
  }
  const visibilityConfig = mustConstructPlugin("foundation.plugin.visibility");
  if (visibilityConfig) {
    plugins.push(new VisibilityPlugin(player, visibilityConfig, mountPoint));
  }
  const streamFallbackConfig = mustConstructPlugin("foundation.plugin.streamFallback");
  if (streamFallbackConfig) {
    plugins.push(new StreamFallbackPlugin(player));
  }
  const hasAdvertising = pluginConfigs["foundation.plugin.smartclip"];
  const isDashManifest = manifestConfiguration?.type === ManifestType.Dash;
  const shouldConstructChromecastAdapter = deviceType === DeviceType.Chromecast;
  const shouldConstructDashAdapter = isDashManifest && !shouldConstructChromecastAdapter;
  const shouldConstructNativeAdapter = (hasAdvertising || !isDashManifest) && !shouldConstructChromecastAdapter;
  if (shouldConstructNativeAdapter && (!player || !player.hasPlayerAdapter("native"))) {
    const nativePlayerAdapter = createNativePlayerAdapter(mountPoint, tweaks);
    playerAdapters.push(nativePlayerAdapter);
  }
  if (shouldConstructDashAdapter && (!player || !player.hasPlayerAdapter("dash.js"))) {
    const module = partialModules["@foundation-player/player-dashjs"];
    if (!module) {
      throw createFoundationError(
        "dash.js is not available, but must be!",
        {
          manifestConfiguration,
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    const dashJsPlayerAdapter = module.createDashJsPlayerAdapter(mountPoint, tweaks);
    playerAdapters.push(dashJsPlayerAdapter);
  }
  if (shouldConstructChromecastAdapter && (!player || !player.hasPlayerAdapter("Chromecast"))) {
    const module = partialModules["@foundation-player/player-chromecast"];
    if (!module) {
      throw createFoundationError(
        "Chromecast is not available, but must be!",
        {
          manifestConfiguration,
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    const chromecastPlayerAdapter = module.createChromecastPlayerAdapter();
    playerAdapters.push(chromecastPlayerAdapter);
  }
  const yospaceConfig = mustConstructPlugin("foundation.plugin.yospace");
  if (yospaceConfig) {
    const module = partialModules["@foundation-player/plugin-yospace"];
    if (!module) {
      throw createFoundationError(
        "Yospace is not available, but must be!",
        {
          manifestConfiguration,
          resolvedModules
        },
        ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
      );
    }
    plugins.push(
      new module.YospacePlugin(
        player,
        yospaceConfig,
        mountPoint,
        deviceType,
        loadRequest.user?.consentString
      )
    );
  }
  return {
    plugins,
    playerAdapters
  };
};

// src/_internal/capability/find-most-suitable-manifest.ts
function findMostSuitableManifest(manifestConfigurations, clientSupport) {
  const manifestTypePriorities = [
    ManifestType.Hls,
    // always prefer HLS because it is the most specific type
    ManifestType.Dash,
    // use DASH where possible when HSL is not supported
    ManifestType.Progressive
    // only fallback to progressive when DASH and HLS are not supported
  ];
  const logger = getLogger("capability.findMostSuitableManifest");
  logger.debug("Applicable capabilities found", clientSupport.capabilities);
  const insufficientDRMCapabilities = [];
  for (const manifestType of manifestTypePriorities) {
    logger.trace(`Try stream type priority for "${manifestType}"`);
    if (!clientSupport.capabilities.manifestTypes.includes(manifestType)) {
      logger.trace(`Skip unsupported stream type "${manifestType}"`);
      continue;
    }
    const foundManifestConfiguration = manifestConfigurations.find((m) => m.type === manifestType);
    if (foundManifestConfiguration) {
      logger.trace(`Filter license servers for "${manifestType}"`);
      const filteredManifest = filterLicenseServers(
        foundManifestConfiguration,
        clientSupport,
        logger
      );
      if (filteredManifest) {
        return filteredManifest;
      }
      insufficientDRMCapabilities.push(foundManifestConfiguration);
    }
  }
  if (insufficientDRMCapabilities.length > 0) {
    throw createFoundationError(
      "Requested DRM key systems not available!",
      {
        manifests: insufficientDRMCapabilities,
        clientSupport
      },
      ErrorCodes.NO_DRM_OPTION_AVAILABLE_ANY_MORE_32110
    );
  }
  throw createFoundationError(
    "Could not determine a suitable manifest for this client and player combination!",
    {
      manifestConfigurations,
      capabilities: clientSupport.capabilities
    },
    ErrorCodes.NO_MANIFESTS_PLAYABLE_32210
  );
}
function filterLicenseServers(manifestConfiguration, clientSupport, logger) {
  const filteredManifest = {
    ...manifestConfiguration,
    licenseServers: (manifestConfiguration.licenseServers || []).filter(
      (licenseServer) => clientSupport.capabilities.keySystems.includes(licenseServer.type)
    )
  };
  if ((manifestConfiguration.licenseServers || []).length > 0 && filteredManifest.licenseServers.length === 0) {
    logger.debug("Requested DRM key systems not available!", {
      manifestConfiguration,
      licenseServers: manifestConfiguration.licenseServers,
      clientSupport
    });
    return void 0;
  }
  return filteredManifest;
}

// src/_internal/environment/detect-tweaks.ts
var detectTweaks = (givenTweaks, remoteConfig) => {
  const userTweaks = !givenTweaks || typeof givenTweaks === "string" ? {} : givenTweaks;
  return {
    playerRequiresLoadBeforeReady: userTweaks.playerRequiresLoadBeforeReady ?? isIphone(),
    enableBolaAbr: userTweaks.enableBolaAbr ?? remoteConfig.settings?.abr?.bola ?? false,
    hasAacCodecSupport: userTweaks.hasAacCodecSupport ?? !(isAndroid() && isEdgeBrowser()),
    hasZeroStartTimeIssue: userTweaks.hasZeroStartTimeIssue ?? (isMagentaSTB() || isSkySTB())
  };
};

// src/_internal/plugin-configuration/concurrent-streamcheck/append-concurrent-stream-check-config.ts
function appendConcurrentStreamCheckConfig(pluginConfigs, loadRequest, remoteConfig) {
  const enabled = [
    loadRequest.plugins?.["foundation.plugin.concurrentStreamCheck"]?.enabled,
    remoteConfig.concurrentStreamCheck?.enable,
    false
  ].find((item) => item !== null && item !== void 0);
  if (!enabled) {
    return;
  }
  const { startUrl, stopUrl, heartbeatUrl, beatInterval } = remoteConfig.concurrentStreamCheck || {};
  if (!startUrl || !stopUrl || !heartbeatUrl) {
    return;
  }
  pluginConfigs["foundation.plugin.concurrentStreamCheck"] = {
    enabled: true,
    startUrl,
    stopUrl,
    heartbeatUrl,
    beatInterval
  };
}

// src/_internal/device-type/is-magenta-stb-device-type.ts
var MAGENTA_STB_DEVICE_LIST = [DeviceType.Magenta_G4, DeviceType.Magenta_G5];
var isMagentaSTBDeviceType = (deviceType) => {
  return MAGENTA_STB_DEVICE_LIST.includes(deviceType);
};

// src/_internal/device-type/is-sky-stb-device-type.ts
var SKY_STB_DEVICE_LIST = [DeviceType.Skyxione, DeviceType.Skystream, DeviceType.Skyq];
var isSkySTBDeviceType = (deviceType) => {
  return SKY_STB_DEVICE_LIST.includes(deviceType);
};

// src/_internal/device-type/is-tizen-device-type.ts
var TIZEN_DEVICE_LIST = [
  DeviceType.Tizen_3_0,
  DeviceType.Tizen_4_0,
  DeviceType.Tizen_5_0,
  DeviceType.Tizen_5_5,
  DeviceType.Tizen_6_0,
  DeviceType.Tizen_6_5,
  DeviceType.Tizen_7_0,
  DeviceType.Tizen_8_0,
  DeviceType.Tizen_9_0
];
var isTizenDeviceType = (deviceType) => {
  return TIZEN_DEVICE_LIST.includes(deviceType);
};

// src/_internal/device-type/is-vodafone-stb-device-type.ts
var VODAFONE_STB_DEVICE_LIST = [DeviceType.Vodafone_Gtv, DeviceType.Vodafone_Vtv];
var isVodafoneSTBDeviceType = (deviceType) => {
  return VODAFONE_STB_DEVICE_LIST.includes(deviceType);
};

// src/_internal/device-type/is-webos-device-type.ts
var WEBOS_DEVICE_LIST = [
  DeviceType.Webos_3,
  DeviceType.Webos_4,
  DeviceType.Webos_5,
  DeviceType.Webos_6,
  DeviceType.Webos_22,
  DeviceType.Webos_23,
  DeviceType.Webos_24,
  DeviceType.Webos_25
];
var isWebOSDeviceType = (deviceType) => {
  return WEBOS_DEVICE_LIST.includes(deviceType);
};

// src/_internal/plugin-configuration/is-plugin-config.ts
var isPluginConfig = (config) => {
  return Boolean(config?.enabled);
};

// src/_internal/plugin-configuration/device-header/append-device-header-config.ts
var STORAGE_KEY = "foundation.deviceId";
function appendDeviceHeaderConfig(pluginConfigs, loadRequest, deviceType, remoteConfig) {
  const loadRequestPluginConfig = loadRequest.plugins?.["foundation.plugin.deviceHeader"];
  const remoteConfigEnableDeviceHeaders = remoteConfig?.drm?.appendDeviceHeaders;
  if (loadRequestPluginConfig && loadRequestPluginConfig.enabled === false || loadRequestPluginConfig?.enabled === void 0 && !remoteConfigEnableDeviceHeaders) {
    return;
  }
  const config = { enabled: true };
  if (isPluginConfig(config)) {
    const storedDeviceId = localStorage.getItem(STORAGE_KEY);
    const deviceId = storedDeviceId || generateId();
    if (!storedDeviceId) {
      localStorage.setItem(STORAGE_KEY, deviceId);
    }
    pluginConfigs["foundation.plugin.deviceHeader"] = {
      ...config,
      headers: {
        "x-device-id": deviceId,
        "x-device-name": getDeviceName(deviceType)
      }
    };
  }
}
var getDeviceName = (deviceType) => {
  if (isTizenDeviceType(deviceType)) {
    return "Samsung TV";
  }
  if (isWebOSDeviceType(deviceType)) {
    return "LG TV";
  }
  if (isVodafoneSTBDeviceType(deviceType)) {
    return "Vodafone";
  }
  if (isMagentaSTBDeviceType(deviceType)) {
    return "Magenta";
  }
  if (isSkySTBDeviceType(deviceType)) {
    return "Sky";
  }
  return `${getOSName()} ${getBrowserName()}`;
};

// src/_internal/stus/map-device-type-to-backend.ts
function mapDeviceTypeToBackend(deviceType) {
  switch (deviceType) {
    case DeviceType.Webos_3:
    case DeviceType.Webos_4:
    case DeviceType.Webos_5:
    case DeviceType.Webos_6:
    case DeviceType.Webos_22:
    case DeviceType.Webos_23:
    case DeviceType.Webos_24:
    case DeviceType.Webos_25:
      return "lg";
    case DeviceType.Tizen_3_0:
    case DeviceType.Tizen_4_0:
    case DeviceType.Tizen_5_0:
    case DeviceType.Tizen_5_5:
    case DeviceType.Tizen_6_0:
    case DeviceType.Tizen_6_5:
    case DeviceType.Tizen_7_0:
    case DeviceType.Tizen_8_0:
    case DeviceType.Tizen_9_0:
      return "tizen";
    case DeviceType.Magenta_G4:
    case DeviceType.Magenta_G5:
      return "magenta";
    case DeviceType.Skyq:
      return "skyq";
    case DeviceType.Skyxione:
      return "skyxi1";
    case DeviceType.Skystream:
      return "skystream";
    case DeviceType.Vodafone_Vtv:
      return "vodafone-vtv";
    case DeviceType.Vodafone_Gtv:
      return "vodafone-gtv";
    case DeviceType.Telecolumbus:
      return "tc";
    case DeviceType.Kepler:
      return "fireweb";
    default:
      return "web";
  }
}

// src/_internal/plugin-configuration/entitlement/append-entilement-config.ts
function appendEntitlementConfig(pluginConfigs, loadRequest, remoteConfig) {
  let entitlementEndpointConfig;
  switch (loadRequest.contentType) {
    case "vod":
      entitlementEndpointConfig = remoteConfig.entitlement?.vod;
      break;
    case "live":
      entitlementEndpointConfig = remoteConfig.entitlement?.livestream;
      break;
    case "event":
      entitlementEndpointConfig = remoteConfig.entitlement?.liveevent;
      break;
  }
  if (!entitlementEndpointConfig?.check?.enable || !entitlementEndpointConfig?.check?.endpoint) {
    return;
  }
  const deviceType = getDeviceType(loadRequest);
  const config = {
    enabled: true,
    headers: {
      "X-Device-Type": mapDeviceTypeToBackend(deviceType)
    },
    ...loadRequest.plugins?.["foundation.plugin.entitlement"]
  };
  if (isPluginConfig(config)) {
    pluginConfigs["foundation.plugin.entitlement"] = {
      ...config,
      endpoint: entitlementEndpointConfig.check.endpoint
    };
  }
}

// src/_internal/plugin-configuration/google-analytics-4/append-google-analytics-4-config.ts
function appendGoogleAnalytics4Config(pluginConfigs, loadRequest) {
  loadRequest.contentId;
  const config = loadRequest.plugins?.["foundation.plugin.googleAnalytics4"] || { enabled: false };
  if (isPluginConfig(config)) {
    pluginConfigs["foundation.plugin.googleAnalytics4"] = {
      ...config,
      id: config.id || loadRequest.contentId,
      firstPublicationDate: config.firstPublicationDate || loadRequest.contentMetadata?.firstPublicationDate,
      lastPublicationDate: config.lastPublicationDate || loadRequest.contentMetadata?.lastPublicationDate
    };
  }
}

// src/_internal/plugin-configuration/heartbeat/append-heartbeat-config.ts
function appendHeartbeatConfig(pluginConfigs, loadRequest, remoteConfig) {
  const logger = getLogger("foundation.plugin.heartbeat");
  const remoteHeartbeatConfig = remoteConfig.heartbeat;
  if (!remoteHeartbeatConfig || !remoteHeartbeatConfig.enable) {
    return;
  }
  if (loadRequest.contentType === ContentType.Advertisement) {
    return;
  }
  const configFromLoadRequest = {
    enabled: true,
    ...loadRequest.plugins?.["foundation.plugin.heartbeat"]
  };
  const offer = configFromLoadRequest.offer || remoteHeartbeatConfig.offer;
  if (!offer || !remoteHeartbeatConfig.videoService || !remoteHeartbeatConfig.endpoints) {
    logger.error("Heartbeat config is missing required fields");
    return;
  }
  let endpoint;
  switch (loadRequest.contentType) {
    case "vod":
      endpoint = remoteHeartbeatConfig.endpoints.vod;
      break;
    case "live":
      endpoint = remoteHeartbeatConfig.endpoints.live;
      break;
    case "event":
      endpoint = remoteHeartbeatConfig.endpoints.event;
      break;
    case "fast":
      endpoint = remoteHeartbeatConfig.endpoints.fast;
      break;
  }
  if (isPluginConfig(configFromLoadRequest) && endpoint) {
    pluginConfigs["foundation.plugin.heartbeat"] = {
      ...configFromLoadRequest,
      id: configFromLoadRequest.id || loadRequest.contentId,
      endpoint,
      offer,
      videoService: remoteHeartbeatConfig.videoService
    };
  }
}

// src/_internal/plugin-configuration/media-session/append-media-session-config.ts
function appendMediaSessionConfig(pluginConfigs, loadRequest) {
  if (!navigator.mediaSession) {
    return;
  }
  const config = loadRequest.plugins?.["foundation.plugin.mediaSession"];
  if (isPluginConfig(config)) {
    pluginConfigs["foundation.plugin.mediaSession"] = {
      enabled: true,
      headline: config.headline || loadRequest.contentMetadata?.headline,
      secondaryHeadline: config.secondaryHeadline || loadRequest.contentMetadata?.secondaryHeadline,
      posterUrl: config.posterUrl || loadRequest.contentMetadata?.posterUrl
    };
  }
}

// src/_internal/plugin-configuration/nielsen/append-nielsen-config.ts
async function appendNielsenConfig(pluginConfigs, loadRequest, remoteConfig, nielsenRequestHeader) {
  if (loadRequest.contentType === "fast") {
    return;
  }
  const logger = getLogger("foundation.plugin.nielsen");
  const remoteNielsenConfig = remoteConfig.nielsen;
  if (!remoteNielsenConfig || !remoteNielsenConfig.enable) {
    return;
  }
  if (!remoteNielsenConfig.endpoint || !remoteNielsenConfig.apid || !remoteNielsenConfig.clientId) {
    logger.error("Nielsen config is missing required fields");
    return;
  }
  const configFromLoadRequest = {
    enabled: true,
    ...loadRequest.plugins?.["foundation.plugin.nielsen"]
  };
  if (isPluginConfig(configFromLoadRequest)) {
    const backendPayload = {
      app_id: remoteNielsenConfig.apid,
      client_id: remoteNielsenConfig.clientId,
      video_id: configFromLoadRequest.id || loadRequest.contentId,
      stream_type: loadRequest.contentType,
      commentpfad: configFromLoadRequest.commentPath
    };
    const metadata = await fetchMetadata(
      backendPayload,
      remoteNielsenConfig.endpoint,
      nielsenRequestHeader,
      logger
    );
    if (!metadata) {
      return;
    }
    pluginConfigs["foundation.plugin.nielsen"] = {
      ...configFromLoadRequest,
      appId: remoteNielsenConfig.apid,
      id: configFromLoadRequest.id || loadRequest.contentId,
      debug: remoteNielsenConfig.debug,
      metadata
    };
  }
}
async function fetchMetadata(backendPayload, endpoint, requestHeader, logger) {
  const remoteParameters = Object.entries(backendPayload);
  const remoteUrl = new URL(endpoint);
  for (const [remoteParameterName, remoteParameterValue] of remoteParameters) {
    if (remoteParameterValue) {
      remoteUrl.searchParams.append(remoteParameterName, remoteParameterValue);
    }
  }
  try {
    const response = await fetchWithTimeout(remoteUrl.toString(), {
      headers: requestHeader
    });
    const metadata = await response.json();
    if (response.status >= 400) {
      logger.error("Endpoint request failed", response.status, metadata);
      return;
    }
    return metadata;
  } catch (e) {
    logger.error("Could not fetch nielsen metadata", e);
  }
}

// src/_internal/plugin-configuration/npaw/append-npaw-config.ts
function appendNpawConfig(options) {
  const { pluginConfigs, loadRequest, remoteConfig, evaluatedClientSupport } = options;
  const accountCode = loadRequest.plugins?.["foundation.plugin.npaw"]?.accountCode || remoteConfig.npawAnalytics?.accountCode || "rtlgermanydev";
  const config = {
    enabled: remoteConfig.npawAnalytics?.enable ?? true,
    ...loadRequest.plugins?.["foundation.plugin.npaw"]
  };
  if (isPluginConfig(config) && config.enabled) {
    pluginConfigs["foundation.plugin.npaw"] = {
      ...config,
      enabled: true,
      userId: config.userId || loadRequest.user?.userId,
      userType: config.userType || loadRequest.user?.userType,
      appName: config.appName || remoteConfig.npawAnalytics?.appName,
      accountCode,
      loadRequest,
      remoteConfig,
      evaluatedClientSupport
    };
  }
}

// src/_internal/plugin-configuration/posthog/append-posthog-config.ts
function appendPosthogConfig(pluginConfigs, loadRequest) {
  const config = loadRequest.plugins?.["foundation.plugin.posthog"] || {};
  if (config.enabled === false) {
    return;
  }
  const isStreamingSiteBuilder = location.host.includes("ssb.player.foundation");
  if (config.enabled || isStreamingSiteBuilder) {
    pluginConfigs["foundation.plugin.posthog"] = {
      ...config,
      enabled: true
    };
  }
}

// src/_internal/plugin-configuration/rcu-bindings/append-rcu-bindings-config.ts
function appendRcuBindingsConfig(pluginConfigs, loadRequest) {
  const config = loadRequest.plugins?.["foundation.plugin.rcuBindings"];
  if (isPluginConfig(config)) {
    pluginConfigs["foundation.plugin.rcuBindings"] = config;
  }
}

// src/_internal/plugin-configuration/shorts-ui/append-shorts-ui-config.ts
function appendShortsUiConfig(pluginConfigs, possibleShortsPluginConfig) {
  if (isPluginConfig(
    possibleShortsPluginConfig
  ) && possibleShortsPluginConfig.enabled) {
    pluginConfigs["foundation.plugin.shortsUi"] = possibleShortsPluginConfig;
  }
}

// src/_internal/plugin-configuration/smartclip/append-smartclip-config.ts
function appendSmartclipConfig(pluginConfigs, loadRequest) {
  const config = loadRequest.plugins?.["foundation.plugin.smartclip"] || {};
  if (isPluginConfig(config)) {
    pluginConfigs["foundation.plugin.smartclip"] = config;
  }
}

// src/_internal/plugin-configuration/stream-fallback/append-stream-fallback-config.ts
function appendStreamFallbackConfig(pluginConfigs, loadRequest, remoteConfig) {
  const config = {
    enabled: loadRequest.plugins?.["foundation.plugin.streamFallback"]?.enabled ?? remoteConfig.fallback?.inStream?.enable ?? true
  };
  if (isPluginConfig(config)) {
    pluginConfigs["foundation.plugin.streamFallback"] = config;
  }
}

// src/_internal/infer-ui-mode.ts
var inferUiMode = (loadRequest) => {
  const videoContentTypes = [
    ContentType.Vod,
    ContentType.Live,
    ContentType.Event,
    ContentType.Fast
  ];
  return videoContentTypes.includes(loadRequest.contentType) ? "video" : "audio";
};

// src/_internal/plugin-configuration/ui/append-ui-config.ts
function appendUiConfig(pluginConfigs, loadRequest, possibleUiPluginConfig) {
  if (isPluginConfig(possibleUiPluginConfig) && possibleUiPluginConfig.enabled) {
    pluginConfigs["foundation.plugin.ui"] = {
      ...possibleUiPluginConfig,
      look: {
        mode: possibleUiPluginConfig.look?.mode ?? inferUiMode(loadRequest)
      }
    };
  }
}

// src/_internal/plugin-configuration/visibility/append-visibility-config.ts
var ALLOWED_DEVICES = [DeviceType.Tablet, DeviceType.Desktop, DeviceType.Mobile];
function appendVisibilityConfig(pluginConfigs, loadRequest, deviceType) {
  const givenConfig = loadRequest.plugins?.["foundation.plugin.visibility"];
  const config = {
    enabled: givenConfig?.enabled ?? true,
    pauseAds: givenConfig?.pauseAds ?? true,
    pauseContent: givenConfig?.pauseContent ?? false
  };
  if (!config.pauseAds && !config.pauseContent) {
    return;
  }
  if (ALLOWED_DEVICES.includes(deviceType) && isPluginConfig(config)) {
    pluginConfigs["foundation.plugin.visibility"] = config;
  }
}

// src/_internal/plugin-configuration/yospace/append-yospace-config.ts
function appendYospaceConfig(pluginConfigs, loadRequest, remoteConfig, manifestConfiguration) {
  if (!manifestConfiguration.sources.some((source) => source.isYospace)) {
    return;
  }
  const config = {
    ...loadRequest.plugins?.["foundation.plugin.yospace"]
  };
  config.enabled = config.enabled ?? remoteConfig.ssai?.enable;
  if (isPluginConfig(config)) {
    let useYospaceSdk = false;
    if (Array.isArray(remoteConfig.ssai?.enableYospaceSdkForSourceTypes)) {
      useYospaceSdk = remoteConfig.ssai.enableYospaceSdkForSourceTypes.includes(
        loadRequest.contentType
      );
    }
    pluginConfigs["foundation.plugin.yospace"] = {
      ...config,
      useYospaceSdk,
      ang_bundle: config.ang_bundle || remoteConfig.ssai?.angBundle,
      ang_ref: config.ang_ref || remoteConfig.ssai?.angRef,
      fetchAtvIdTimeoutInMs: remoteConfig.advertisement?.timeouts?.atv,
      deviceModel: getDeviceModel(),
      deviceVendor: getDeviceVendor(),
      osName: getOSName(),
      osVersion: getOSVersion()
    };
  }
}

// src/public/fetch-remote-config.ts
var MAX_CACHE_AGE_MS = 24 * 60 * 60 * 1e3;
async function fetchRemoteConfig(clientIdentifier, environment) {
  const url = `https://rc.${getEnvironmentDependentSubdomain(environment)}.streamingtech.de/config/${clientIdentifier}`;
  const localStorageKey = `foundation:remoteConfig:${clientIdentifier}`;
  try {
    const options = {
      // 5s is too large for any normal usage, but since a lot of our publishing partner sites,
      // are filled to the brim with ads and tracking scripts, we have to set it to a high value,
      // because unfortunately they refuse to start the player *after* the site is ready,
      // but instead do it alongside the bogged down site.
      timeout: 5e3
    };
    const response = await fetchWithTimeout(url, options);
    if (response.ok) {
      const responseBody = await response.json();
      const cacheEntry = {
        timestamp: Date.now(),
        config: responseBody
      };
      localStorage.setItem(localStorageKey, JSON.stringify(cacheEntry));
      return responseBody;
    }
  } catch (e) {
    console.error(`Failed to fetch remote config from ${url}`, e);
  }
  const possibleCacheEntry = localStorage.getItem(localStorageKey);
  if (possibleCacheEntry) {
    const cacheEntry = JSON.parse(possibleCacheEntry);
    const age = Date.now() - cacheEntry.timestamp;
    if (age < MAX_CACHE_AGE_MS) {
      console.warn(
        `Using cached remote config for clientIdentifier ${clientIdentifier}, age: ${age}ms`
      );
      return cacheEntry.config;
    }
    console.warn(
      `Cached remote config for clientIdentifier ${clientIdentifier} is too old (${age}ms), ignoring and removing.`
    );
    localStorage.removeItem(localStorageKey);
  }
  return {};
}
function getEnvironmentDependentSubdomain(environment) {
  switch (environment) {
    case Environment.Dev:
      return "player-dev";
    case Environment.Preprod:
      return "player-preprod";
    default:
      return "player";
  }
}

// src/_internal/remote-config/is-fetch-config.ts
function shouldFetchRemoteConfig(remoteConfig) {
  return Boolean(
    Object.keys(remoteConfig).length === 2 && remoteConfig.clientIdentifier && remoteConfig.environment
  );
}

// src/_internal/remote-config/determine-remote-config.ts
async function determineRemoteConfig(possibleRemoteConfig) {
  if (!possibleRemoteConfig) {
    return {};
  }
  if (shouldFetchRemoteConfig(possibleRemoteConfig)) {
    return fetchRemoteConfig(
      possibleRemoteConfig.clientIdentifier,
      possibleRemoteConfig.environment
    );
  }
  return possibleRemoteConfig;
}

// src/_internal/stus/fetch-manifest-configuration-from-stus.ts
var filterAndMapVttStUSSubtitle = (stusSubtitles) => {
  if (stusSubtitles === void 0) {
    return [];
  }
  return stusSubtitles.filter((subtitle) => subtitle.outputSet === "WEBVTT_TEXT").map((subtitle) => {
    return {
      vttUrl: subtitle.url,
      label: subtitle.language,
      language: subtitle.languageCode
    };
  });
};
var fetchStUSManifest = async (stusUrl, lastRequestDebugInformation, headers) => {
  let options = {
    // 5s is too large for any normal usage, but since a lot of our publishing partner sites,
    // are filled to the brim with ads and tracking scripts, we have to set it to a high value,
    // because unfortunately they refuse to start the player *after* the site is ready,
    // but instead do it alongside the bogged down site.
    timeout: 5e3,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    method: "GET"
  };
  if (headers) {
    options = {
      ...options,
      headers: {
        ...options.headers,
        ...headers
      }
    };
  }
  const requestDebugInformation = {
    ...lastRequestDebugInformation,
    time: Date.now(),
    url: stusUrl,
    allowed: true
  };
  const responseData = await fetchWithTimeout(
    stusUrl,
    options,
    createFoundationError(
      `StUS request timed out after ${options.timeout} ms`,
      {
        timeout: options.timeout,
        requestDebugInformation
      },
      ErrorCodes.STUS_SCHEDULER_REQUEST_TIMED_OUT_43800
    )
  );
  if (responseData.status !== 200) {
    let errorCode;
    if (responseData.status >= 400 && responseData.status < 500) {
      errorCode = ErrorCodes.STUS_RETURNS_4XX_ERROR_42800;
    } else if (responseData.status >= 500) {
      errorCode = ErrorCodes.STUS_RETURNS_5XX_ERROR_42810;
    } else {
      errorCode = ErrorCodes.STUS_UNAVAILABLE_41800;
    }
    throw createFoundationError(
      `StUS returned status code ${responseData.status}`,
      {
        requestDebugInformation,
        responseDebugInformation: {
          time: Date.now(),
          statusCode: responseData.status,
          body: await responseData.text(),
          usedStUS: true
        }
      },
      errorCode
    );
  }
  const json = await responseData.json();
  const responseDebugInformation = {
    time: Date.now(),
    statusCode: responseData.status,
    body: json,
    usedStUS: true
  };
  const thumbnailUrl = json.find((stus) => stus.thumbnails)?.thumbnails || void 0;
  let stusSubtitles = [];
  if (json[0] && json[0].sources.length > 0) {
    stusSubtitles = json[0].sources.find((stusSource) => (stusSource.subtitles?.length || 0) > 0)?.subtitles || void 0;
  }
  return {
    manifests: mapStUSToManifest(json),
    thumbnailUrl,
    requestDebugInformation,
    responseDebugInformation,
    vttTextTracks: filterAndMapVttStUSSubtitle(stusSubtitles)
  };
};
var generateStUSUrlFromConfig = (loadRequest, remoteConfig, deviceType) => {
  const urlTemplate = remoteConfig.streamingURLService?.[loadRequest.contentType]?.endpoint || "";
  const placeholders = {
    mediaId: loadRequest.contentId,
    platform: mapDeviceTypeToBackend(deviceType)
  };
  const replacedUrl = replaceStUSUrlPlaceholders(urlTemplate, placeholders);
  const requestDebugInformation = {
    time: Date.now(),
    urlTemplate,
    placeholders,
    url: replacedUrl
  };
  if (!loadRequest.contentId || !urlTemplate) {
    return { url: "", requestDebugInformation };
  }
  return { url: replacedUrl, requestDebugInformation };
};
var mapStUSToManifest = (stusData) => {
  const dashHd = stusData.find((manifest) => manifest.name === "dashhd");
  const dashSd = stusData.find((manifest) => manifest.name === "dashsd");
  const hlsHd = stusData.find((manifest) => manifest.name === "hlsfairplayhd");
  const hlsSd = stusData.find((manifest) => manifest.name === "hlsfairplaysd");
  let filteredStusData = stusData;
  if (dashHd && dashSd) {
    filteredStusData = filteredStusData.filter((manifest) => manifest.name !== "dashsd");
  }
  if (hlsHd && hlsSd) {
    filteredStusData = filteredStusData.filter((manifest) => manifest.name !== "hlsfairplaysd");
  }
  return filteredStusData.map(
    (stus) => ({
      type: mapStusNameToType(stus.name),
      licenseServers: stus.licenses.map((license) => ({
        url: license.uri.href,
        type: license.type.toLocaleLowerCase(),
        certificate: license.certificate
      })),
      sources: stus.sources.map((source) => ({
        url: source.url,
        isYospace: source.isYospace,
        npawProfileName: source.npawProfileName
      }))
    })
  ).filter((item) => item.type !== void 0);
};
var replaceStUSUrlPlaceholders = (url, placeholders) => {
  return url.replace("{platform}", placeholders.platform || "").replace("{mediaId}", placeholders.mediaId || "").replace("{MEDIA_ID}", placeholders.mediaId || "");
};
var mapStusNameToType = (name) => {
  const key = name.toLocaleLowerCase();
  if (key.startsWith("hls")) {
    return ManifestType.Hls;
  }
  if (key.startsWith("dash")) {
    return ManifestType.Dash;
  }
  if (key === "progressive") {
    return ManifestType.Progressive;
  }
  return void 0;
};

// src/_internal/create-player/evaluate-load-request.ts
async function evaluateLoadRequest(options) {
  const {
    player,
    loadRequest,
    deviceType,
    clientSupport,
    getRequestHeader,
    possibleUiPluginConfig,
    possibleShortsPluginConfig
  } = options;
  let error;
  let manifestConfiguration;
  const debugInterface = player.getDebugInterface();
  const remoteConfig = await determineRemoteConfig(loadRequest.remoteConfig);
  const tweaks = detectTweaks(loadRequest.tweaks, remoteConfig);
  let manifests = loadRequest.manifests || [];
  const stusRequest = generateStUSUrlFromConfig(loadRequest, remoteConfig, deviceType);
  debugInterface.stusRequestDebugInformation = stusRequest.requestDebugInformation;
  let stusResponse;
  if (stusRequest.url) {
    let headers = {};
    if (getRequestHeader) {
      const stusRequestHeader = await getRequestHeader(RequestType.StUS);
      headers = stusRequestHeader || {};
    }
    stusResponse = await fetchStUSManifest(
      stusRequest.url,
      debugInterface.stusRequestDebugInformation,
      headers
    ).catch((e) => {
      error = isFoundationError(e) ? e : createFoundationError(
        "Failed to fetch StUS manifest!",
        { caughtError: e },
        ErrorCodes.STUS_UNAVAILABLE_41800
      );
      return void 0;
    });
    if (stusResponse) {
      debugInterface.stusRequestDebugInformation = stusResponse.requestDebugInformation;
      debugInterface.stusResponseDebugInformation = stusResponse.responseDebugInformation;
      manifests = stusResponse.manifests;
      loadRequest.thumbnailsUrl = stusResponse.thumbnailUrl || loadRequest.thumbnailsUrl;
      if (stusResponse.vttTextTracks && stusResponse.vttTextTracks.length > 0) {
        loadRequest.vttTextTracks = stusResponse.vttTextTracks;
      }
    }
  }
  if (manifests.length === 0) {
    error = error ?? createFoundationError("No manifests provided!", {}, ErrorCodes.VIDEOSOURCES_CONFIG_34200);
  } else {
    manifestConfiguration = findMostSuitableManifest(manifests, clientSupport);
  }
  const pluginConfigs = {};
  const nielsenRequestHeader = getRequestHeader ? await getRequestHeader(RequestType.Nielsen) || {} : {};
  appendSmartclipConfig(pluginConfigs, loadRequest);
  appendRcuBindingsConfig(pluginConfigs, loadRequest);
  appendEntitlementConfig(pluginConfigs, loadRequest, remoteConfig);
  appendMediaSessionConfig(pluginConfigs, loadRequest);
  appendDeviceHeaderConfig(pluginConfigs, loadRequest, deviceType, remoteConfig);
  appendVisibilityConfig(pluginConfigs, loadRequest, deviceType);
  appendNpawConfig({
    pluginConfigs,
    loadRequest,
    remoteConfig,
    deviceType,
    evaluatedClientSupport: clientSupport,
    stusRequestDebugInformation: stusResponse?.requestDebugInformation,
    stusResponseDebugInformation: stusResponse?.responseDebugInformation
  });
  appendPosthogConfig(pluginConfigs, loadRequest);
  appendUiConfig(pluginConfigs, loadRequest, possibleUiPluginConfig);
  appendShortsUiConfig(pluginConfigs, possibleShortsPluginConfig);
  appendHeartbeatConfig(pluginConfigs, loadRequest, remoteConfig);
  appendGoogleAnalytics4Config(pluginConfigs, loadRequest);
  appendConcurrentStreamCheckConfig(pluginConfigs, loadRequest, remoteConfig);
  appendStreamFallbackConfig(pluginConfigs, loadRequest, remoteConfig);
  await appendNielsenConfig(pluginConfigs, loadRequest, remoteConfig, nielsenRequestHeader);
  if (manifestConfiguration) {
    appendYospaceConfig(pluginConfigs, loadRequest, remoteConfig, manifestConfiguration);
  }
  const uiAlreadyActive = player.getPlugin("foundation.plugin.ui") || player.getPlugin("foundation.plugin.shortsUi");
  const uiActive = uiAlreadyActive || pluginConfigs["foundation.plugin.ui"] || pluginConfigs["foundation.plugin.shortsUi"];
  if (uiActive && pluginConfigs["foundation.plugin.smartclip"]) {
    pluginConfigs["foundation.plugin.smartclip"].handleClickThrough = false;
  }
  if (pluginConfigs["foundation.plugin.shortsUi"] && pluginConfigs["foundation.plugin.npaw"]) {
    pluginConfigs["foundation.plugin.npaw"].shortsPlayer = true;
  }
  const modules = [];
  const isChromecast2 = deviceType === DeviceType.Chromecast;
  if (isChromecast2) {
    modules.push("@foundation-player/player-chromecast");
  }
  if (!isChromecast2 && manifestConfiguration?.type === ManifestType.Dash) {
    modules.push("@foundation-player/player-dashjs");
  }
  if (pluginConfigs["foundation.plugin.smartclip"]) {
    modules.push("@foundation-player/plugin-smartclip");
  }
  if (pluginConfigs["foundation.plugin.npaw"]) {
    modules.push("@foundation-player/plugin-npaw");
  }
  if (pluginConfigs["foundation.plugin.posthog"]) {
    modules.push("@foundation-player/plugin-posthog");
  }
  if (pluginConfigs["foundation.plugin.ui"]) {
    modules.push("@foundation-player/plugin-ui");
  }
  if (pluginConfigs["foundation.plugin.shortsUi"]) {
    modules.push("@foundation-player/plugin-shorts");
  }
  if (pluginConfigs["foundation.plugin.yospace"]) {
    modules.push("@foundation-player/plugin-yospace");
  }
  return {
    modules,
    manifestConfiguration,
    pluginConfigs,
    tweaks,
    error
  };
}

// src/_internal/create-player/load-media.ts
async function internal_loadMedia(player, loadRequest) {
  if (player.state.value.state === "destroyed") {
    throw createFoundationError(
      "Player is destroyed",
      {
        player,
        loadRequest
      },
      ErrorCodes.PLAYER_ALREADY_DESTROYED_35100
    );
  }
  const internal_player = player;
  const foundationWindow = window;
  const deviceType = foundationWindow.foundation?.internal_deviceType;
  if (!deviceType) {
    throw createFoundationError(
      "Device type is not defined in window",
      {},
      ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
    );
  }
  const debugInterfaces = foundationWindow.foundation?.internal_DebugInterfaces;
  if (!debugInterfaces) {
    throw createFoundationError(
      "DebugInterfaces is not defined in window",
      {},
      ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
    );
  }
  const debugInterface = debugInterfaces.find((d) => d.playerInstance === player);
  if (!debugInterface) {
    throw createFoundationError(
      "DebugInterface not found for player",
      { player },
      ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
    );
  }
  debugInterface.providedLoadRequests.push(loadRequest);
  const clientSupport = foundationWindow.foundation?.internal_clientSupport;
  if (!clientSupport) {
    throw createFoundationError(
      "ClientSupport is not defined in window",
      {},
      ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
    );
  }
  const { modules, manifestConfiguration, pluginConfigs, tweaks, error } = await evaluateLoadRequest({
    player: internal_player,
    loadRequest,
    deviceType,
    clientSupport,
    getRequestHeader: internal_player.getRequestHeader
  });
  if (error) {
    await internal_player.triggerError(error);
    throw error;
  }
  if (!manifestConfiguration) {
    await internal_player.triggerError(
      createFoundationError("INVARIANT: No manifest available without error")
    );
    throw error;
  }
  const resolvedModules = await internal_player.moduleLoader(modules);
  const { plugins, playerAdapters } = constructPluginsAndAdapters(internal_player, {
    loadRequest,
    mountPoint: internal_player.mountPoint,
    getRequestHeader: internal_player.getRequestHeader,
    moduleLoader: internal_player.moduleLoader,
    playerId: player.getPlayerId(),
    manifestConfiguration,
    deviceType,
    pluginConfigs,
    resolvedModules,
    tweaks
  });
  await internal_player.loadManifestConfiguration({
    plugins,
    playerAdapters,
    manifestConfiguration,
    pluginConfigs,
    loadRequest
  });
}

// src/public/load-media.ts
async function loadMedia(player, loadRequest) {
  const hook = window.foundation?.api?.internal_loadMedia;
  if (hook) {
    return hook(player, loadRequest);
  }
  return internal_loadMedia(player, loadRequest);
}

// src/vendor/srt-vtt-parser/types.ts
var isEntryFromPartial = (e) => {
  return typeof e.id === "string" && typeof e.from === "number" && typeof e.to === "number" && typeof e.text === "string";
};

// src/vendor/srt-vtt-parser/util.ts
var isBlank = (str) => !str || /^\s*$/.test(str);

// src/vendor/srt-vtt-parser/srtParser.ts
var TRANSITION_NAMES = {
  ID: "ID",
  TIME_LINE: "TIME_LINE",
  TEXT: "TEXT",
  MULTI_LINE_TEXT: "MULTI_LINE_TEXT",
  FIN_ENTRY: "FIN_ENTRY",
  FINISH: "FINISH"
};
var timestampToMillisecond = (value) => {
  let arr = value.split(":");
  let hours, minutes, seconds;
  arr.length === 2 ? [minutes, seconds] = arr : [hours, minutes, seconds] = arr;
  return parseInt(seconds.replace(",", ""), 10) + parseInt(minutes, 10) * 60 * 1e3 + (hours ? parseInt(hours, 10) : 0) * 60 * 60 * 1e3;
};
var SrtMachine = () => ({
  start(raw) {
    let currentTransition = TRANSITION_NAMES.ID;
    let params = {
      tokens: raw.split(/\n/),
      pos: 0,
      result: [],
      current: {}
    };
    while (currentTransition !== TRANSITION_NAMES.FINISH) {
      const result = this[currentTransition](params);
      params = result.params;
      currentTransition = result.next;
    }
    return params.result;
  },
  [TRANSITION_NAMES.ID](params) {
    const { tokens, pos, current } = params;
    if (tokens.length <= pos) {
      return { next: TRANSITION_NAMES.FINISH, params };
    }
    if (isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES.ID, params: { ...params, pos: pos + 1 } };
    }
    const idDoesNotExists = tokens[pos].includes("-->");
    current.id = idDoesNotExists ? "" : tokens[pos];
    return {
      next: TRANSITION_NAMES.TIME_LINE,
      params: {
        ...params,
        current,
        tokens,
        pos: idDoesNotExists ? pos : pos + 1
      }
    };
  },
  [TRANSITION_NAMES.TIME_LINE](params) {
    const { tokens, pos, current } = params;
    const timeLine = tokens[pos];
    const [from, to] = timeLine.split("-->");
    current.from = timestampToMillisecond(from);
    current.to = timestampToMillisecond(to);
    return { next: TRANSITION_NAMES.TEXT, params: { ...params, current, pos: pos + 1 } };
  },
  [TRANSITION_NAMES.TEXT](params) {
    const { tokens, pos, current } = params;
    if (tokens.length <= pos) {
      return { next: TRANSITION_NAMES.FINISH, params };
    }
    current.text = tokens[pos];
    return { next: TRANSITION_NAMES.MULTI_LINE_TEXT, params: { ...params, current, pos: pos + 1 } };
  },
  [TRANSITION_NAMES.MULTI_LINE_TEXT](params) {
    const { tokens, pos, current } = params;
    if (tokens.length <= pos || isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES.FIN_ENTRY, params };
    }
    current.text = `${current.text}
${tokens[pos]}`;
    return { next: TRANSITION_NAMES.MULTI_LINE_TEXT, params: { ...params, current, pos: pos + 1 } };
  },
  [TRANSITION_NAMES.FIN_ENTRY](params) {
    const { pos, current, result } = params;
    if (isEntryFromPartial(current)) {
      result.push(current);
    } else {
      throw new Error(`Parsing error current not complete ${JSON.stringify(current)}`);
    }
    return { next: TRANSITION_NAMES.ID, params: { ...params, current: {}, pos: pos + 1 } };
  },
  [TRANSITION_NAMES.FINISH](params) {
    return {
      next: TRANSITION_NAMES.FINISH,
      params
    };
  }
});
var srtParser = (raw) => {
  return {
    entries: SrtMachine().start(raw)
  };
};

// src/vendor/srt-vtt-parser/vttParser.ts
var TRANSITION_NAMES2 = {
  HEADER: "HEADER",
  ID: "ID",
  TIME_LINE: "TIME_LINE",
  ID_OR_NOTE_OR_STYLE_OR_REGION: "ID_OR_NOTE_OR_STYLE_OR_REGION",
  STYLE: "STYLE",
  NOTE: "NOTE",
  REGION: "REGION",
  LEGACY_HEADER: "LEGACY_HEADER",
  TEXT: "TEXT",
  MULTI_LINE_TEXT: "MULTI_LINE_TEXT",
  FIN_ENTRY: "FIN_ENTRY",
  FINISH: "FINISH"
};
var timestampToMillisecond2 = (value) => {
  let arr = value.split(":");
  let hours, minutes, seconds;
  arr.length === 2 ? [minutes, seconds] = arr : [hours, minutes, seconds] = arr;
  return parseInt(seconds.replace(".", ""), 10) + parseInt(minutes, 10) * 60 * 1e3 + (hours ? parseInt(hours, 10) : 0) * 60 * 60 * 1e3;
};
var VttMachine = () => ({
  start(raw) {
    let currentTransition = TRANSITION_NAMES2.HEADER;
    let params = {
      tokens: raw.split(/\n/),
      pos: 0,
      result: [],
      current: {}
    };
    while (currentTransition !== TRANSITION_NAMES2.FINISH) {
      const result = this[currentTransition](params);
      params = result.params;
      currentTransition = result.next;
    }
    return params.result;
  },
  [TRANSITION_NAMES2.HEADER](params) {
    return { next: TRANSITION_NAMES2.LEGACY_HEADER, params: { ...params, pos: params.pos + 1 } };
  },
  [TRANSITION_NAMES2.LEGACY_HEADER](params) {
    const { tokens, pos } = params;
    if (tokens.length <= pos) {
      return { next: TRANSITION_NAMES2.FINISH, params };
    } else if (tokens[pos].includes(":") && !tokens[pos].includes("-->")) {
      return { next: TRANSITION_NAMES2.LEGACY_HEADER, params: { ...params, pos: pos + 1 } };
    } else {
      return { next: TRANSITION_NAMES2.ID_OR_NOTE_OR_STYLE_OR_REGION, params };
    }
  },
  [TRANSITION_NAMES2.ID_OR_NOTE_OR_STYLE_OR_REGION](params) {
    const { tokens, pos } = params;
    if (tokens.length <= pos) {
      return { next: TRANSITION_NAMES2.FINISH, params };
    } else if (isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES2.ID_OR_NOTE_OR_STYLE_OR_REGION, params: { ...params, pos: pos + 1 } };
    } else if (tokens[pos].toUpperCase().includes("NOTE")) {
      return { next: TRANSITION_NAMES2.NOTE, params };
    } else if (tokens[pos].toUpperCase().includes("STYLE")) {
      return { next: TRANSITION_NAMES2.STYLE, params };
    } else if (tokens[pos].toUpperCase().includes("REGION")) {
      return { next: TRANSITION_NAMES2.REGION, params };
    } else {
      return { next: TRANSITION_NAMES2.ID, params };
    }
  },
  [TRANSITION_NAMES2.STYLE](params) {
    const { tokens, pos } = params;
    if (isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES2.ID_OR_NOTE_OR_STYLE_OR_REGION, params: { ...params, pos: pos + 1 } };
    }
    return { next: TRANSITION_NAMES2.STYLE, params: { ...params, pos: pos + 1 } };
  },
  [TRANSITION_NAMES2.NOTE](params) {
    const { tokens, pos } = params;
    if (isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES2.ID_OR_NOTE_OR_STYLE_OR_REGION, params: { ...params, pos: pos + 1 } };
    }
    return { next: TRANSITION_NAMES2.STYLE, params: { ...params, pos: pos + 1 } };
  },
  [TRANSITION_NAMES2.REGION](params) {
    const { tokens, pos } = params;
    if (isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES2.ID_OR_NOTE_OR_STYLE_OR_REGION, params: { ...params, pos: pos + 1 } };
    }
    return { next: TRANSITION_NAMES2.REGION, params: { ...params, pos: pos + 1 } };
  },
  [TRANSITION_NAMES2.ID](params) {
    const { tokens, pos, current } = params;
    if (tokens.length <= pos) {
      return { next: TRANSITION_NAMES2.FINISH, params };
    }
    if (isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES2.ID, params: { ...params, pos: pos + 1 } };
    }
    const idDoesNotExists = tokens[pos].includes("-->");
    current.id = idDoesNotExists ? "" : tokens[pos];
    return {
      next: TRANSITION_NAMES2.TIME_LINE,
      params: {
        ...params,
        current,
        tokens,
        pos: idDoesNotExists ? pos : pos + 1
      }
    };
  },
  [TRANSITION_NAMES2.TIME_LINE](params) {
    const { tokens, pos, current } = params;
    const timeLine = tokens[pos];
    const [from, to] = timeLine.split("-->");
    current.from = timestampToMillisecond2(from);
    current.to = timestampToMillisecond2(to);
    return { next: TRANSITION_NAMES2.TEXT, params: { ...params, current, pos: pos + 1 } };
  },
  [TRANSITION_NAMES2.TEXT](params) {
    const { tokens, pos, current } = params;
    if (tokens.length <= pos) {
      return { next: TRANSITION_NAMES2.FINISH, params };
    }
    current.text = tokens[pos];
    return { next: TRANSITION_NAMES2.MULTI_LINE_TEXT, params: { ...params, current, pos: pos + 1 } };
  },
  [TRANSITION_NAMES2.MULTI_LINE_TEXT](params) {
    const { tokens, pos, current } = params;
    if (tokens.length <= pos || isBlank(tokens[pos])) {
      return { next: TRANSITION_NAMES2.FIN_ENTRY, params };
    }
    current.text = `${current.text}
${tokens[pos]}`;
    return { next: TRANSITION_NAMES2.MULTI_LINE_TEXT, params: { ...params, current, pos: pos + 1 } };
  },
  [TRANSITION_NAMES2.FIN_ENTRY](params) {
    const { pos, current, result } = params;
    if (isEntryFromPartial(current)) {
      result.push(current);
    } else {
      throw new Error(`Parsing error current not complete ${JSON.stringify(current)}`);
    }
    return { next: TRANSITION_NAMES2.ID_OR_NOTE_OR_STYLE_OR_REGION, params: { ...params, current: {}, pos: pos + 1 } };
  },
  [TRANSITION_NAMES2.FINISH](params) {
    return {
      next: TRANSITION_NAMES2.FINISH,
      params
    };
  }
});
var vttParser = (raw) => {
  return {
    entries: VttMachine().start(raw)
  };
};

// src/vendor/srt-vtt-parser/index.ts
var parse = (raw) => {
  return raw.startsWith("WEBVTT") ? vttParser(raw) : srtParser(raw);
};

// src/_internal/event-bus/event-bus.ts
var EventBus = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Map();
  }
  /**
   * Registers an event listener for a specific event type.
   *
   * @typeParam E - The event type key from the event map
   * @param type - The event type to listen for
   * @param listener - The event handler function or object
   * @returns A cleanup function that removes the event listener when called
   *
   * @example
   * ```ts
   * const cleanup = bus.addEventListener('playerMove', (data) => {
   *   console.log(data.x, data.y);
   * });
   *
   * // Later, when you want to remove the listener:
   * cleanup();
   * ```
   */
  addEventListener(type, listener) {
    let listeners = this.listeners.get(type);
    if (!listeners) {
      listeners = /* @__PURE__ */ new Set();
      this.listeners.set(type, listeners);
    }
    listeners.add(listener);
    return () => {
      this.removeEventListener(type, listener);
    };
  }
  /**
   * Removes a previously registered event listener.
   *
   * @typeParam E - The event type key from the event map
   * @param type - The event type to remove the listener from
   * @param listener - The event handler function or object to remove
   *
   * @example
   * ```ts
   * const handler = (data: { score: number }) => console.log(data.score);
   * bus.addEventListener('score', handler);
   * // Later:
   * bus.removeEventListener('score', handler);
   * ```
   */
  removeEventListener(type, listener) {
    const listeners = this.listeners.get(type);
    if (listeners) {
      listeners.delete(listener);
      if (listeners.size === 0) {
        this.listeners.delete(type);
      }
    }
  }
  /**
   * Dispatches an event on the event bus.
   *
   * @typeParam E - The event type key from the event map
   * @param type - The event type to dispatch
   * @param data - The event data to dispatch
   * @returns Promise that resolves when all listeners have been called
   *
   * @example
   * ```ts
   * await bus.dispatchEvent('playerMove', { x: 100, y: 200 });
   * ```
   */
  async dispatchEvent(type, data) {
    const listeners = this.listeners.get(type);
    if (!listeners) {
      return;
    }
    const promises = [];
    for (const listener of listeners) {
      const result = listener(data);
      if (result instanceof Promise) {
        promises.push(result);
      }
    }
    await Promise.all(promises);
  }
  destroy() {
    this.listeners.clear();
  }
};

// src/_internal/thumbnail/process-thumbnails.ts
async function processThumbnails(url, timeout = 2e3) {
  const logger = getLogger("foundation.core.thumbnails");
  const parsedUrl = new URL(url);
  parsedUrl.pathname = parsedUrl.pathname.split("/").slice(0, -1).join("/");
  const basePath = parsedUrl.href;
  const thumbnails = await fetchWithTimeout(url, { timeout }).then(async (response) => {
    if (response.status !== 200) {
      logger.warn(`Thumbnail URL returned status code ${response.status}`);
      return [];
    }
    const body = await response.text();
    const parsed = parse(body);
    return parsed.entries.map(({ from, to, text }) => ({
      startTimeInSeconds: from / 1e3,
      endTimeInSeconds: to / 1e3,
      image: parseImageUrl(basePath, text)
    }));
  }).catch((e) => {
    logger.warn("Thumbnails could not be retrieved", e);
    return [];
  });
  return thumbnails;
}
function parseImageUrl(base, rawUrl) {
  const coordsKey = "xywh";
  const [imageUrl, coordsString] = rawUrl.split("#xywh=");
  const url = `${base}/${imageUrl}`;
  const coords = coordsString.split(",").map(Number.parseFloat).reduce(
    (coords2, value, idx) => {
      const index = coordsKey[idx];
      coords2[index] = value;
      return coords2;
    },
    {}
  );
  return { url, coords };
}

// src/_internal/player.ts
var TextTrackMode = {
  PlayerAdapter: 0,
  Virtual: 1
};
var Player = class {
  constructor(payload) {
    /**
     * The function to get request headers for specific requests.
     *
     * @remarks
     * This property is not private, because we need to access it for subsequent load requests.
     */
    this.getRequestHeader = () => Promise.resolve({});
    this.playerAdapters = [];
    this.plugins = [];
    this.eventBus = new EventBus();
    this.logger = getLogger("player");
    this.publicPlugins = /* @__PURE__ */ new Map();
    this.thumbnails = [];
    this.cancelledAutoplayViaPause = false;
    this.tryingAutoplay = false;
    /**
     * Virtual text tracks.
     *
     * These are vtt files you can include in the {@link LoadRequest} and will replace the subtitles inside the given asset.
     */
    this.virtualTextTracks = [];
    /**
     * If we use native text tracks or our custom virtual text tracks.
     *
     * @remarks
     * Due to browser inconsistencies, and lack of proper apis,
     * there may be cases where we have to resort to custom text track handling.
     *
     * The biggest culprit is a lack of a removeTextTrack method in the HTML5 spec.
     * This in turn would litter the player with text tracks, which we cannot remove.
     */
    this.textTrackMode = TextTrackMode.PlayerAdapter;
    this.vttCueCache = {};
    this.stallingDebounce = void 0;
    /**
     * The tweaks that were detected for this player instance.
     *
     * @remarks
     * The player instance is created before the tweaks are detected,
     * thus you must use getTweaks() to access the tweaks.
     *
     * getTweaks() will return the tweaks that were detected,
     * or throw an invariant error if the tweaks were not detected yet which is illegal behavior.
     *
     * Unchecked here means that the tweaks may not be checked for validity yet,
     * which is why you must use getTweaks() to access them.
     */
    this.uncheckedTweaks = void 0;
    this.addEventListener = (type, listener) => {
      return this.eventBus.addEventListener(type, listener);
    };
    this.removeEventListener = (type, listener) => {
      return this.eventBus.removeEventListener(type, listener);
    };
    this.dispatchEvent = (type, data) => {
      return this.eventBus.dispatchEvent(type, data);
    };
    this.loadVirtualTextTracks = async (loadRequest) => {
      if (loadRequest?.vttTextTracks === void 0 || loadRequest.vttTextTracks.length === 0) {
        return [];
      }
      const vttTextTrackPromises = loadRequest.vttTextTracks.map(async (track) => {
        return {
          ...track,
          cues: await this.getCuesForVttTrack(track)
        };
      });
      const vttTextTracks = (await Promise.allSettled(vttTextTrackPromises)).filter((result) => result.status === "fulfilled").map((result) => result.value);
      for (let trackIndex = 0; trackIndex < vttTextTracks.length; trackIndex++) {
        const vttTrack = vttTextTracks[trackIndex];
        this.virtualTextTracks.push({
          trackId: String(trackIndex),
          language: vttTrack.language,
          cues: vttTrack.cues,
          label: inferLabelFromLanguage(vttTrack.language, vttTrack.label),
          active: false
        });
      }
      return this.virtualTextTracks.map((t) => ({
        trackId: t.trackId,
        language: t.language,
        label: t.label,
        active: t.active
      }));
    };
    const { playerId, getRequestHeader, moduleLoader } = payload;
    this.playerId = playerId;
    this.debugInterface = payload.debugInterface;
    this.deviceType = payload.deviceType;
    if (getRequestHeader) {
      this.getRequestHeader = getRequestHeader;
    }
    this.moduleLoader = moduleLoader;
    this.mountPoint = payload.mountPoint;
    this.state = new MutableObservable({
      autoplaySupported: false,
      maxVideoBitrateInKbps: -1,
      muted: false,
      playbackRate: 1,
      startMethod: "not-started",
      state: "loading",
      sessionId: "",
      volume: 1,
      droppedFrames: 0,
      averageThroughputInKbps: 0,
      currentTimeInSeconds: 0,
      contentWatchTimeInSeconds: 0,
      sessionStarted: false,
      contentStarted: false,
      contentCompleted: false,
      sessionCompleted: false,
      adActive: false,
      linearAdActive: false,
      metrics: {},
      contentId: "",
      contentType: ContentType.Vod,
      activeCues: [],
      preparePlaying: false,
      timeShiftedInSeconds: 0
    });
    this.state.onValueChange(
      "currentTimeInSeconds",
      ({ currentTimeInSeconds, linearAdActive, contentWatchTimeInSeconds }, previousCurrentTime) => {
        if (linearAdActive) {
          return;
        }
        const timeDelta = Math.max(currentTimeInSeconds - previousCurrentTime, 0);
        if (timeDelta > 1) {
          return;
        }
        this.state.patch({ contentWatchTimeInSeconds: contentWatchTimeInSeconds + timeDelta });
      }
    );
  }
  getPlayerId() {
    return this.playerId;
  }
  async play() {
    if (this.state.value.state === "playing" || this.state.value.state === "ended") {
      return;
    }
    if (this.state.value.sessionCompleted) {
      return;
    }
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    const isAllowed = await this.advertisingPlugin?.beforePlay();
    if (isAllowed === false) {
      return;
    }
    this.state.patch({
      preparePlaying: true
    });
    const mediaPlayStartTime = performance.now();
    const startMethod = this.state.value.startMethod;
    try {
      await this.activePlayerAdapter.play();
    } catch (exception) {
      this.tryingAutoplay = false;
      throw exception;
    }
    const mediaPlayEndTime = performance.now();
    const mediaPlayInMs = mediaPlayEndTime - mediaPlayStartTime;
    const linearAdActive = this.state.value.linearAdActive;
    const metrics = this.state.value.metrics;
    let contentStarted = this.state.value.contentStarted;
    if (!contentStarted && !linearAdActive) {
      contentStarted = true;
    }
    if (startMethod === "not-started") {
      this.logger.debug("Media Play metrics", {
        metrics: {
          ...metrics,
          mediaPlayInMs
        }
      });
    }
    this.tryingAutoplay = false;
    this.state.patch({
      state: "playing",
      metrics,
      sessionStarted: true,
      contentStarted,
      preparePlaying: false
    });
  }
  async pause() {
    if (this.state.value.startMethod === "not-started") {
      this.cancelledAutoplayViaPause = true;
    }
    if (this.state.value.state === "loading" || this.state.value.state === "ready" || this.state.value.state === "paused" || this.state.value.state === "stopped" || this.state.value.state === "error" || this.state.value.state === "ended") {
      return;
    }
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.state.value.activeAsset) {
      return;
    }
    const isAllowed = await this.advertisingPlugin?.beforePause();
    if (isAllowed === false) {
      return;
    }
    await this.activePlayerAdapter.pause();
    this.state.patch({
      state: this.state.value.activeAsset.livestream ? "stopped" : "paused"
    });
  }
  async mute() {
    if (this.activePlayerAdapter) {
      await this.activePlayerAdapter.mute();
    }
    this.state.patch({ muted: true });
  }
  async unmute() {
    if (this.activePlayerAdapter) {
      await this.activePlayerAdapter.unmute();
    }
    this.state.patch({ muted: false });
  }
  async setVolume(volume) {
    if (this.activePlayerAdapter) {
      await this.activePlayerAdapter.setVolume(volume);
    }
    this.state.patch({ volume });
  }
  async seekTo(offsetInSeconds) {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (offsetInSeconds < 0) {
      throw createFoundationError(
        "You cannot seek to a negative offset",
        {
          offsetInSeconds
        },
        ErrorCodes.OPERATION_NOT_SUPPORTED_35500
      );
    }
    if (this.state.value.sessionCompleted) {
      return;
    }
    const activeAsset = this.state.value.activeAsset;
    if (!activeAsset) {
      return;
    }
    if (activeAsset.livestream) {
      throw createFoundationError(
        "Seek was called on a livestream, which is not supported!",
        {},
        ErrorCodes.OPERATION_NOT_SUPPORTED_35500
      );
    }
    const isAllowed = await this.advertisingPlugin?.beforeSeek();
    if (isAllowed === false) {
      return;
    }
    const clampedOffset = Math.min(offsetInSeconds, activeAsset.durationInSeconds - 1);
    if (clampedOffset !== offsetInSeconds) {
      this.logger.warn(
        `The requested seek time of ${offsetInSeconds}s was out of bounds, clamping to ${clampedOffset}s`
      );
    }
    const previousState = this.state.value.state;
    this.state.patch({ state: "seeking" });
    await this.activePlayerAdapter.seekTo(clampedOffset);
    this.state.patch({ state: previousState, currentTimeInSeconds: clampedOffset });
  }
  async setPlaybackRate(playbackRate) {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    const isAllowed = await this.advertisingPlugin?.beforePlaybackRate(playbackRate);
    if (isAllowed === false) {
      return;
    }
    await this.activePlayerAdapter.setPlaybackRate(playbackRate);
    this.state.patch({ playbackRate });
  }
  async setAudioTrack(trackId) {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.state.value.activeAsset) {
      return Promise.resolve();
    }
    await this.activePlayerAdapter.setAudioTrack(trackId);
    const modifiedTrackData = this.state.value.activeAsset.audioTracks.map((track) => ({
      ...track,
      active: track.trackId === trackId
    }));
    this.state.patch({
      activeAsset: {
        ...this.state.value.activeAsset,
        audioTracks: modifiedTrackData
      },
      currentAudioTrack: modifiedTrackData.find((t) => t.trackId === trackId)
    });
  }
  async enableTextTrack(trackId) {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.state.value.activeAsset) {
      return Promise.resolve();
    }
    if (this.textTrackMode === TextTrackMode.PlayerAdapter) {
      await this.activePlayerAdapter.enableTextTrack(trackId);
    } else {
      await this.enableVirtualTextTrack(trackId);
    }
    const modifiedTrackData = this.state.value.activeAsset.textTracks.map((track) => ({
      ...track,
      active: track.trackId === trackId
    }));
    this.state.patch({
      activeAsset: {
        ...this.state.value.activeAsset,
        textTracks: modifiedTrackData
      },
      currentTextTrack: modifiedTrackData.find((t) => t.trackId === trackId),
      activeCues: this.activePlayerAdapter.state.value.activeCues
    });
  }
  enableVirtualTextTrack(trackId) {
    for (const track of this.virtualTextTracks) {
      track.active = track.trackId === trackId;
    }
    if (!this.virtualTextTrackSubscription) {
      this.virtualTextTrackSubscription = this.state.onValueChange(
        "currentTimeInSeconds",
        ({ currentTimeInSeconds, activeCues }) => {
          const activeTrack = this.virtualTextTracks.find((track) => track.active);
          if (!activeTrack) {
            return;
          }
          const filteredActiveCues = activeTrack.cues.reduce((list, vttCue) => {
            if (vttCue.startTimeInSeconds > currentTimeInSeconds) {
              return list;
            }
            if (vttCue.endTimeInSeconds <= currentTimeInSeconds) {
              return list;
            }
            list.push({
              id: vttCue.id,
              startTimeInSeconds: vttCue.startTimeInSeconds,
              endTimeInSeconds: vttCue.endTimeInSeconds,
              text: vttCue.text
            });
            return list;
          }, []);
          if (activeCues.length === 0 && filteredActiveCues.length === 0) {
            return;
          }
          this.state.patch({ activeCues: filteredActiveCues });
        }
      );
    }
    return Promise.resolve();
  }
  async disableTextTrack() {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.state.value.activeAsset) {
      return Promise.resolve();
    }
    if (this.virtualTextTrackSubscription) {
      this.virtualTextTrackSubscription();
      this.virtualTextTrackSubscription = void 0;
    }
    await this.activePlayerAdapter.disableTextTrack();
    this.state.patch({
      activeAsset: {
        ...this.state.value.activeAsset,
        textTracks: this.state.value.activeAsset.textTracks.map((track) => ({
          ...track,
          active: false
        }))
      },
      currentTextTrack: void 0,
      activeCues: []
    });
  }
  getThumbnail(offsetInSeconds) {
    return this.thumbnails.find(
      ({ startTimeInSeconds, endTimeInSeconds }) => offsetInSeconds >= startTimeInSeconds && offsetInSeconds < endTimeInSeconds
    )?.image;
  }
  async setMaxVideoBitrate(bitrateInKbps) {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    await this.activePlayerAdapter.setMaxVideoBitrate(bitrateInKbps);
    this.state.patch({ maxVideoBitrateInKbps: bitrateInKbps });
  }
  hasPlayerAdapter(playerAdapterType) {
    return this.playerAdapters.find((p) => p.getPlayerType() === playerAdapterType) !== void 0;
  }
  hasPlugin(pluginKey) {
    return this.plugins.find((p) => p.getKey() === pluginKey) !== void 0;
  }
  getAdvertisingPlugin() {
    return this.advertisingPlugin;
  }
  setAdvertisingPlugin(plugin) {
    this.advertisingPlugin = plugin;
    this.advertisingPlugin.state.onValueChange("adActive", ({ adActive, linearAdActive }) => {
      this.state.patch({ adActive, linearAdActive });
    });
  }
  getPlugin(pluginName) {
    const plugin = this.plugins.find((p) => p.getKey() === pluginName);
    if (!plugin) {
      return void 0;
    }
    return plugin;
  }
  setMetadata(metadata) {
    this.state.patch(metadata);
    if (this.activePlayerAdapter) {
      this.activePlayerAdapter.updateContentMetadata(metadata);
    }
  }
  async destroy(cause) {
    if (this.state.value.state === "destroyed") {
      return;
    }
    for (const playerAdapter of this.playerAdapters) {
      await playerAdapter.destroy();
    }
    if (typeof cause === "string") {
      this.state.patch({
        state: "destroyed",
        destroyCause: cause
      });
    } else {
      this.state.patch({
        state: "destroyed",
        destroyCause: cause,
        error: cause
      });
    }
    if (this.beforeUnloadListener) {
      window.removeEventListener("beforeunload", this.beforeUnloadListener);
      this.beforeUnloadListener = void 0;
    }
  }
  getDebugInterface() {
    return this.debugInterface;
  }
  async switchContent(loadRequest) {
    this.playerAdapterStateUnsubscribe?.();
    this.virtualTextTracks = [];
    if (this.textTrackMode === TextTrackMode.Virtual) {
      this.virtualTextTrackSubscription?.();
      this.virtualTextTrackSubscription = void 0;
    }
    this.textTrackMode = TextTrackMode.PlayerAdapter;
    this.state.patch({
      assetUrl: loadRequest.assetUrl,
      state: "loading"
    });
    const nextAdapter = this.findSuitablePlayerAdapter(loadRequest);
    if (nextAdapter !== this.activePlayerAdapter) {
      this.activePlayerAdapter = nextAdapter;
    }
    const isMuted = this.state.value.muted;
    const canAutoplay = await this.canAutoplay(isMuted);
    const assetInformationOrError = await raceAgainstTimeout(
      [this.activePlayerAdapter.load(loadRequest)],
      2e4,
      createFoundationError(
        "Load did not finish within 20 seconds",
        {},
        ErrorCodes.NETWORK_PROBLEM_31000
      )
    );
    if (isFoundationError(assetInformationOrError)) {
      throw assetInformationOrError;
    }
    const assetInformation = assetInformationOrError;
    this.subscribeToContentState(this.activePlayerAdapter);
    const currentVideoTrack = assetInformation.videoTracks.find((t) => t.active);
    if (isMuted) {
      this.logger.debug("Muting player adapter after content switch");
      await this.mute();
    } else {
      this.logger.debug("Unmuting player adapter after content switch");
      await this.unmute();
    }
    this.logger.debug("Setting volume on player adapter after content switch", {
      volume: this.state.value.volume
    });
    await this.setVolume(this.state.value.volume);
    this.logger.debug("Setting playback rate on player adapter after content switch", {
      playbackRate: this.state.value.playbackRate
    });
    await this.setPlaybackRate(this.state.value.playbackRate);
    this.logger.debug("Setting max video bitrate on player adapter after content switch", {
      maxVideoBitrateInKbps: this.state.value.maxVideoBitrateInKbps
    });
    await this.setMaxVideoBitrate(this.state.value.maxVideoBitrateInKbps);
    const allowedAudioTracks = this.limitAllowedAudioTracksIfNeeded(
      loadRequest.originalAudioAllowed,
      assetInformation.audioTracks
    );
    assetInformation.audioTracks = allowedAudioTracks;
    const currentAudioTrack = this.getActiveOrFirstAudioTrack(allowedAudioTracks);
    if (currentAudioTrack && !currentAudioTrack.active) {
      await this.activePlayerAdapter.setAudioTrack(currentAudioTrack.trackId);
      currentAudioTrack.active = true;
    }
    if (loadRequest.vttTextTracks && loadRequest.vttTextTracks.length > 0) {
      const textTracks = await this.loadVirtualTextTracks(loadRequest);
      if (textTracks.length > 0) {
        this.textTrackMode = TextTrackMode.Virtual;
        assetInformation.textTracks = textTracks;
      }
    }
    this.state.patch({
      activeAsset: assetInformation,
      state: "ready",
      currentAudioTrack,
      currentTextTrack: assetInformation.textTracks.find((t) => t.active),
      currentVideoTrack,
      currentVideoBitrateInKbps: currentVideoTrack?.bitrateInKbps || void 0
    });
    const result = { assetInformation, canAutoplay };
    this.logger.debug("Successfully switched content", result);
    return result;
  }
  async getCuesForVttTrack(track) {
    if (this.vttCueCache[track.vttUrl]) {
      return this.vttCueCache[track.vttUrl];
    }
    const response = await fetch(track.vttUrl);
    if (response.status !== 200) {
      return Promise.reject(`Server returned status code ${response.status}`);
    }
    const content = await response.text();
    const cues = parse(content).entries.map((entry, cueIndex) => {
      const vttCue = {
        id: String(cueIndex),
        text: entry.text,
        startTimeInSeconds: entry.from / 1e3,
        endTimeInSeconds: entry.to / 1e3
      };
      return vttCue;
    });
    this.vttCueCache[track.vttUrl] = cues;
    return cues;
  }
  limitAllowedAudioTracksIfNeeded(originalAudioAllowed, audioTracks) {
    if (typeof originalAudioAllowed !== "boolean" || originalAudioAllowed) {
      return audioTracks;
    }
    const filteredTracks = audioTracks.filter((track) => track.language === "de");
    if (filteredTracks.length === 0) {
      return audioTracks;
    }
    return filteredTracks;
  }
  getActiveOrFirstAudioTrack(audioTracks) {
    const activeAudioTrack = audioTracks.find((track) => track.active);
    if (activeAudioTrack) {
      return activeAudioTrack;
    }
    return audioTracks[0];
  }
  async canAutoplay(isMuted) {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.playerLoadRequest) {
      throw createFoundationError("No active load request found");
    }
    if (!this.playerLoadRequest.autoplay) {
      return false;
    }
    if (this.state.value.startMethod !== "not-started") {
      return true;
    }
    const isWebDevice = this.deviceType === DeviceType.Desktop || this.deviceType === DeviceType.Mobile || this.deviceType === DeviceType.Tablet;
    if (!isWebDevice) {
      this.logger.debug("Skip autoplay test because device does not require a check", {
        deviceType: this.deviceType,
        isWebDevice
      });
      return true;
    }
    this.logger.debug("Testing autoplay for active adapter", {
      activePlayerAdapter: this.activePlayerAdapter,
      isMuted
    });
    return this.activePlayerAdapter.testAutoplay(isMuted, this.getTweaks().hasAacCodecSupport);
  }
  takeStateSnapshot() {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    const loadRequest = this.activePlayerAdapter.getLoadRequest();
    if (!loadRequest) {
      throw createFoundationError("Cannot take snapshot without active load request!");
    }
    const { currentTimeInSeconds, playbackRate, currentAudioTrack, currentTextTrack } = this.state.value;
    return {
      currentTimeInSeconds,
      playbackRate,
      currentAudioTrackId: currentAudioTrack?.trackId,
      currentTextTrackId: currentTextTrack?.trackId,
      loadRequest: { ...loadRequest }
    };
  }
  async restoreStateSnapshot(snapshot) {
    const { assetInformation } = await this.switchContent({
      ...snapshot.loadRequest,
      // We expect livestreams not be restored, thus there is no check here to remove the start time
      startTimeInSeconds: snapshot.currentTimeInSeconds
    });
    const { playbackRate, currentAudioTrack, currentTextTrack } = this.state.value;
    if (snapshot.playbackRate !== playbackRate) {
      await this.setPlaybackRate(snapshot.playbackRate);
    }
    if (snapshot.currentAudioTrackId && snapshot.currentAudioTrackId !== currentAudioTrack?.trackId) {
      await this.setAudioTrack(snapshot.currentAudioTrackId);
    }
    if (snapshot.currentTextTrackId && snapshot.currentTextTrackId !== currentTextTrack?.trackId) {
      await this.enableTextTrack(snapshot.currentTextTrackId);
    }
    return assetInformation;
  }
  async loadManifestConfiguration(options) {
    const { state, playbackRate, muted, maxVideoBitrateInKbps, sessionStarted } = this.state.value;
    if (sessionStarted) {
      this.state.patch({
        sessionCompleted: true
      });
    }
    if (state === "playing") {
      await this.pause();
    }
    const { playerAdapters, plugins, manifestConfiguration, pluginConfigs } = options;
    const playerLoadRequest = options.loadRequest;
    this.playerLoadRequest = playerLoadRequest;
    for (const playerAdapter of playerAdapters) {
      this.playerAdapters.push(playerAdapter);
    }
    for (const plugin of plugins) {
      this.plugins.push(plugin);
      if (hasPublicApi(plugin)) {
        this.publicPlugins.set(plugin.getKey(), plugin);
      }
    }
    this.cancelledAutoplayViaPause = false;
    this.state.silentPatch({
      // Reset metadata, because the spread would only overwrite data that is newly defined,
      // leaving a mix of stale and new data
      title: void 0,
      program: void 0,
      channelName: void 0,
      season: void 0,
      headline: void 0,
      secondaryHeadline: void 0,
      firstPublicationDate: void 0,
      lastPublicationDate: void 0,
      posterUrl: void 0,
      linkToShare: void 0,
      durationInSeconds: void 0,
      ...playerLoadRequest.contentMetadata,
      maxVideoBitrateInKbps: playerLoadRequest.maxVideoBitrateInKbps || maxVideoBitrateInKbps,
      // use || to avoid 0 as possible user value
      muted: playerLoadRequest.muted ?? muted,
      playbackRate: playerLoadRequest.playbackRate || playbackRate,
      // use || to avoid 0 as possible user value
      contentId: playerLoadRequest.contentId,
      contentType: playerLoadRequest.contentType,
      currentTimeInSeconds: 0,
      contentWatchTimeInSeconds: 0,
      sessionId: generateId(),
      sessionStarted: false,
      contentStarted: false,
      contentCompleted: false,
      sessionCompleted: false,
      adActive: false,
      linearAdActive: false,
      startMethod: "not-started",
      state: "loading",
      error: void 0
    });
    const beforeSessionStartErrorOrUndefined = await Promise.all(
      this.plugins.map((p) => p.beforeSessionStart(pluginConfigs, playerLoadRequest))
    ).then(() => void 0).catch((e) => e);
    if (beforeSessionStartErrorOrUndefined) {
      await this.triggerError(beforeSessionStartErrorOrUndefined);
      throw beforeSessionStartErrorOrUndefined;
    }
    const hasBeforeWindowUnloadHooks = this.plugins.some((plugin) => plugin.beforeWindowUnload);
    if (hasBeforeWindowUnloadHooks) {
      let unloadSent = false;
      this.beforeUnloadListener = () => {
        if (unloadSent) {
          return;
        }
        unloadSent = true;
        for (const plugin of this.plugins) {
          if (plugin.beforeWindowUnload) {
            try {
              plugin.beforeWindowUnload();
            } catch (e) {
              this.logger.error("beforeWindowUnload hook failed for plugin", {
                plugin,
                error: e
              });
            }
          }
        }
      };
      window.addEventListener("beforeunload", this.beforeUnloadListener);
      window.addEventListener("pagehide", this.beforeUnloadListener);
    }
    this.thumbnails = [];
    if (this.playerLoadRequest.thumbnailsUrl) {
      this.thumbnails = await processThumbnails(this.playerLoadRequest.thumbnailsUrl);
    }
    const loadIndex = async (index2) => {
      const mediaLoadStartTime = performance.now();
      this.playerAdapterStateUnsubscribe?.();
      this.state.patch({
        state: "loading"
      });
      const source = manifestConfiguration.sources[index2];
      let drmConfig;
      if (manifestConfiguration.licenseServers && manifestConfiguration.licenseServers.length > 0) {
        const dynamicHeaders = await this.getRequestHeader(RequestType.DRM);
        drmConfig = manifestConfiguration.licenseServers.map((licenseServer) => ({
          keySystem: licenseServer.type,
          licenseServerUrl: licenseServer.url,
          certificateUrl: licenseServer.certificate,
          headers: {
            ...licenseServer.headers || {},
            ...dynamicHeaders
          }
        }));
      }
      const livestreamContentTypes = [
        ContentType.Live,
        ContentType.Event,
        ContentType.Fast,
        ContentType.Radio
      ];
      let loadRequest = {
        contentType: playerLoadRequest.contentType,
        manifestType: manifestConfiguration.type,
        assetUrl: source.url,
        startTimeInSeconds: livestreamContentTypes.includes(playerLoadRequest.contentType) ? void 0 : playerLoadRequest.startTimeInSeconds,
        vttTextTracks: playerLoadRequest.vttTextTracks,
        drmConfig,
        isYospace: source.isYospace,
        contentMetadata: playerLoadRequest.contentMetadata
      };
      for (const plugin of this.plugins) {
        loadRequest = await plugin.modifyLoadRequest(loadRequest);
      }
      await Promise.all(this.plugins.map((p) => p.beforeLoadRequest(loadRequest)));
      const { canAutoplay } = await this.switchContent(loadRequest);
      const mediaLoadEndTime = performance.now();
      const mediaLoadInMs = mediaLoadEndTime - mediaLoadStartTime;
      this.state.patch({
        metrics: {
          ...this.state.value.metrics,
          mediaLoadInMs
        }
      });
      if (playerLoadRequest.autoplay && canAutoplay && !this.cancelledAutoplayViaPause) {
        this.logger.debug("Autoplaying after loading manifest configuration");
        this.tryingAutoplay = true;
        await this.play();
      }
    };
    let index = 0;
    let errorOrUndefined;
    while (index < manifestConfiguration.sources.length) {
      errorOrUndefined = await loadIndex(index).catch((e) => e);
      if (!errorOrUndefined) {
        break;
      }
      this.logger.debug("Failed to load source, trying next one", {
        error: errorOrUndefined,
        index,
        source: manifestConfiguration.sources[index]
      });
      await this.dispatchEvent("player:SuppressedError", this.wrapError(errorOrUndefined));
      index += 1;
    }
    if (errorOrUndefined) {
      this.logger.debug("Failed to switch content", { error: errorOrUndefined });
      const triggeredError = await this.triggerError(errorOrUndefined);
      if (triggeredError) {
        throw triggeredError;
      }
    }
    if (this.playerLoadRequest.preferredAudioLanguage && this.state.value.currentAudioTrack?.language !== this.playerLoadRequest.preferredAudioLanguage) {
      const languageTrackWithPreferredLanguage = this.state.value.activeAsset?.audioTracks.find(
        (track) => {
          return track.language === this.playerLoadRequest?.preferredAudioLanguage;
        }
      );
      if (languageTrackWithPreferredLanguage) {
        await this.setAudioTrack(languageTrackWithPreferredLanguage.trackId);
      }
    }
    if (this.playerLoadRequest.preferredTextTrackLanguage && this.state.value.currentTextTrack?.language !== this.playerLoadRequest.preferredTextTrackLanguage) {
      let languageTrackWithPreferredLanguage = this.state.value.activeAsset?.textTracks.find(
        (track) => {
          return track.language === this.playerLoadRequest?.preferredTextTrackLanguage;
        }
      );
      if (languageTrackWithPreferredLanguage === void 0) {
        languageTrackWithPreferredLanguage = this.state.value.activeAsset?.textTracks[0];
      }
      if (languageTrackWithPreferredLanguage) {
        await this.enableTextTrack(languageTrackWithPreferredLanguage.trackId);
      }
    }
    if (this.playerLoadRequest.playbackRate && this.state.value.playbackRate !== this.playerLoadRequest.playbackRate) {
      await this.setPlaybackRate(this.playerLoadRequest.playbackRate);
    }
  }
  subscribeToContentState(playerAdapter) {
    this.playerAdapterStateUnsubscribe?.();
    const clearStallingDebounce = () => {
      if (this.stallingDebounce) {
        clearTimeout(this.stallingDebounce);
        this.stallingDebounce = void 0;
      }
    };
    const startStallingDebounce = (timeoutInMilliseconds) => {
      clearStallingDebounce();
      this.stallingDebounce = setTimeout(() => {
        void this.triggerError(
          createFoundationError(
            "Player stalled for too long",
            {
              timeoutInMilliseconds
            },
            ErrorCodes.NETWORK_PROBLEM_31000
          )
        );
        clearStallingDebounce();
      }, timeoutInMilliseconds);
    };
    this.playerAdapterStateUnsubscribe = playerAdapter.state.subscribe(async (adapterState) => {
      let state = this.state.value.state;
      if (state === "error") {
        return;
      }
      let contentCompleted = this.state.value.contentCompleted;
      let sessionCompleted = this.state.value.sessionCompleted;
      let preparePlaying = this.state.value.preparePlaying;
      if (adapterState.state !== "stalled") {
        clearStallingDebounce();
      }
      if (adapterState.state === "error" && adapterState.error) {
        const isDRMError = adapterState.error.code >= ErrorCodes.FALLBACK_DRM_ERROR_10000.code && adapterState.error.code < ErrorCodes.CONTENT_20000.code;
        const isContentError = adapterState.error.code >= ErrorCodes.CONTENT_20000.code && adapterState.error.code < ErrorCodes.CLIENT_30000.code;
        const fatalClientErrors = [
          ErrorCodes.NO_PLAYABLE_TRACK_LEFT_30100.code
        ];
        const isFatalError = isDRMError || isContentError || fatalClientErrors.includes(adapterState.error.code);
        if (isFatalError) {
          await this.triggerError(adapterState.error);
          return;
        }
      }
      if (adapterState.state === "ended") {
        state = "ended";
        const linearAdActive = this.state.value.linearAdActive;
        const hasPostRoll = this.advertisingPlugin?.getAdSlotAtOffset(-1);
        contentCompleted = contentCompleted || !linearAdActive;
        sessionCompleted = sessionCompleted || contentCompleted && !hasPostRoll;
      }
      if (adapterState.state === "stalled" && state === "playing") {
        state = "stalled";
        startStallingDebounce(1e4);
      }
      let startMethod = this.state.value.startMethod;
      if (adapterState.state === "playing" && state !== "seeking") {
        state = "playing";
        preparePlaying = false;
        if (startMethod === "not-started") {
          startMethod = this.tryingAutoplay ? "autoplay" : "user-interaction";
          this.logger.debug("Start method was changed", {
            nextValue: startMethod
          });
        }
      }
      const currentTextTrack = this.state.value.currentTextTrack;
      const currentCues = this.state.value.activeCues;
      let activeCues = this.textTrackMode === TextTrackMode.Virtual ? currentCues : adapterState.activeCues;
      if (!currentTextTrack && activeCues.length > 0) {
        activeCues = currentCues.length === 0 ? currentCues : [];
      }
      let activeAsset = this.state.value.activeAsset;
      if (activeAsset && !activeAsset.livestream && adapterState.durationInSeconds !== activeAsset.durationInSeconds) {
        activeAsset = {
          ...activeAsset,
          durationInSeconds: adapterState.durationInSeconds
        };
      }
      let durationInSeconds = this.state.value.durationInSeconds;
      if (activeAsset && durationInSeconds !== activeAsset.durationInSeconds) {
        durationInSeconds = activeAsset.durationInSeconds;
      }
      this.state.patch({
        state,
        preparePlaying,
        contentCompleted,
        sessionCompleted,
        startMethod,
        currentTimeInSeconds: adapterState.currentTimeInSeconds,
        timeShiftedInSeconds: adapterState.timeShiftedInSeconds,
        currentVideoTrack: adapterState.currentVideoTrack,
        currentVideoBitrateInKbps: adapterState.currentVideoTrack?.bitrateInKbps,
        droppedFrames: adapterState.droppedFrames,
        averageThroughputInKbps: adapterState.averageThroughputInKbps,
        liveLatencyInSeconds: adapterState.liveLatencyInSeconds,
        playbackRate: adapterState.playbackRate,
        activeCues,
        activeAsset,
        durationInSeconds
      });
    });
  }
  getActivePlayerAdapter() {
    return this.activePlayerAdapter;
  }
  replay(options = {}) {
    if (!this.playerLoadRequest) {
      throw createFoundationError("No active load request found when calling replay!");
    }
    let startTimeInSeconds = options.startTimeInSeconds || void 0;
    if (this.state.value.activeAsset?.livestream) {
      startTimeInSeconds = void 0;
    }
    const smartClipPluginConfig = this.playerLoadRequest.plugins?.["foundation.plugin.smartclip"];
    return loadMedia(this, {
      ...this.playerLoadRequest,
      ...smartClipPluginConfig && options.skipPreRolls ? {
        plugins: {
          ...this.playerLoadRequest.plugins,
          "foundation.plugin.smartclip": {
            ...smartClipPluginConfig,
            adSlots: (smartClipPluginConfig.adSlots || []).filter(
              (adSlot) => adSlot.offsetInSeconds !== 0
            )
          }
        }
      } : {},
      autoplay: true,
      startTimeInSeconds
    });
  }
  /**
   * Returns the non-linear ad container element if it has been set.
   */
  getNonLinearElement() {
    return this.nonLinearElement;
  }
  /**
   * Sets the non-linear ad container element.
   * @remarks
   * This is used to display non-linear ads, such as banners or l-frames.
   *
   * This must be called before the manifest configuration is loaded,
   * otherwise the plugins must assume that the non-linear ad container is not available.
   */
  setNonLinearElement(element) {
    this.nonLinearElement = element;
  }
  findSuitablePlayerAdapter(loadRequest) {
    this.logger.trace("Find most suitable player adapter for request", loadRequest);
    for (const adapter of this.playerAdapters) {
      const capabilities = adapter.getCapabilities();
      this.logger.trace("Checking adapter", adapter, capabilities, loadRequest);
      const canPlayManifestType = capabilities.manifestTypes.includes(loadRequest.manifestType);
      if (!canPlayManifestType) {
        continue;
      }
      this.logger.trace("Adapter can play manifest");
      const hasDrmConfig = loadRequest.drmConfig && loadRequest.drmConfig.length > 0;
      if (!hasDrmConfig) {
        return adapter;
      }
      this.logger.trace(
        "Has DRM config. Checking if adapter can play it",
        hasDrmConfig,
        loadRequest.drmConfig
      );
      const canPlayDrmType = (loadRequest.drmConfig || []).some(
        (drmConfig) => capabilities.keySystems.includes(drmConfig.keySystem)
      );
      if (canPlayDrmType) {
        return adapter;
      }
    }
    throw createFoundationError("No suitable player adapter found for asset URL");
  }
  wrapError(error) {
    return isFoundationError(error) ? error : createFoundationError("Non FoundationError occurred", { originalError: error });
  }
  /**
   * This method is used to trigger an error state in the player.
   *
   * @remarks
   * It should be used during runtime to indicate that a fatal error has occurred,
   * and playback is either already stopped, or should be stopped.
   *
   * The method will return the error, if the state was changed to 'error'.
   */
  async triggerError(error) {
    const nonTransitionalStates = ["destroyed", "error", "ended"];
    if (nonTransitionalStates.includes(this.state.value.state)) {
      this.logger.error("Trigger error called in non transitional state", {
        state: this.state.value.state,
        nonTransitionalStates,
        error
      });
      return;
    }
    const foundationError = this.wrapError(error);
    for (const plugin of this.plugins) {
      const isAllowed = await plugin.beforeError(foundationError);
      if (!isAllowed) {
        this.logger.debug("Plugin prevented error handling", {
          pluginKey: plugin.getKey(),
          error: foundationError
        });
        await this.dispatchEvent("player:SuppressedError", foundationError);
        return;
      }
    }
    await this.pause().catch((e) => {
      this.logger.error("Trigger Error Pause failed", e);
    });
    this.state.patch({
      state: "error",
      error: foundationError
    });
    return foundationError;
  }
  /**
   * This method will return true if the content is shown
   * in a real fullscreen element. We do not check
   * for fake fullscreens (e.g. full browser window players),
   * because that is too complex and could create false
   * positives.
   */
  isFullscreen() {
    const videoElement = findVideoElement(this.mountPoint);
    if (!videoElement) {
      return false;
    }
    const {
      fullscreenElement,
      webkitFullscreenElement,
      mozFullScreenElement,
      msFullscreenElement
    } = document;
    const element = fullscreenElement || webkitFullscreenElement || mozFullScreenElement || msFullscreenElement;
    return !!element && element.contains(videoElement);
  }
  timeShift(offsetInSeconds) {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.state.value.activeAsset?.livestream) {
      throw createFoundationError(
        "timeShift is only available for livestreams",
        {},
        ErrorCodes.OPERATION_NOT_SUPPORTED_35500
      );
    }
    if (offsetInSeconds < 0) {
      throw createFoundationError(
        "timeShift offset must be a positive number",
        {},
        ErrorCodes.OPERATION_NOT_SUPPORTED_35500
      );
    }
    return this.activePlayerAdapter.timeShift(offsetInSeconds);
  }
  seekToLiveEdge() {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.state.value.activeAsset?.livestream) {
      throw createFoundationError(
        "seekToLiveEdge is only available for livestreams",
        {},
        ErrorCodes.OPERATION_NOT_SUPPORTED_35500
      );
    }
    return this.activePlayerAdapter.seekToLiveEdge();
  }
  getDVRWindowInSeconds() {
    if (!this.activePlayerAdapter) {
      throw createFoundationError("No active player adapter found");
    }
    if (!this.state.value.activeAsset?.livestream) {
      throw createFoundationError(
        "getDVRWindowInSeconds is only available for livestreams",
        {},
        ErrorCodes.OPERATION_NOT_SUPPORTED_35500
      );
    }
    return this.activePlayerAdapter.getDVRWindowInSeconds();
  }
  /**
   * Tweaks are only evaluated once during the player initialization,
   * but this happens after the player instance is created.
   */
  setTweaks(tweaks) {
    this.uncheckedTweaks = tweaks;
  }
  getTweaks() {
    if (!this.uncheckedTweaks) {
      throw createFoundationError("INVARIANT: Tried to access Tweaks before they have been set");
    }
    return this.uncheckedTweaks;
  }
  /**
   * In order to present visual feedback to the user,
   * the core player offers a rudimentary loading spinner.
   *
   * @remarks
   * This effectively closes the gap between the player is bootstrapped,
   * and the Foundation UI is ready to take over.
   */
  showInitialLoadingSpinner(options) {
    const spinnerColor = options.spinnerColor || "#f0f0f0";
    const backgroundColor = options.backgroundColor || "#000000";
    const aspectRatio = options.aspectRatio;
    const maxSpinnerSize = options.maxSpinnerSize || "140px";
    if (!this.loadingSpinnerStyles) {
      this.loadingSpinnerStyles = document.createElement("style");
      this.loadingSpinnerStyles.innerHTML = `[loading-spinner] {
      --max-spinner-size: ${maxSpinnerSize};
      box-sizing: border-box;
      font-size: 3em;
      font-size: clamp(calc(0.5 * var(--max-spinner-size)), 12cqw + 1em, var(--max-spinner-size));
      width: 1em;
      height: 1em;
      aspect-ratio: 1;
      border-radius: 50%;
      border: 6px solid;
      border-right-color: transparent;
      color: ${spinnerColor};
      animation: --rotate linear 1.2s infinite;
    }

    @media (prefers-reduced-motion: reduce) {
      [loading-spinner] {
        animation: none;
      }
    }

    @keyframes --rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    [loading-spinner-container] {
      display: flex;
      width: 100%;
      height: 100%;
      max-height: 100vh;
      min-height: 180px; // Minimum height to ensure the layout does not shift too much in audio mode
      position: relative;
      overflow: hidden;
      ${aspectRatio ? `aspect-ratio: ${aspectRatio};` : ""}
    }

    [loading-spinner-wrapper] {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        max-width: 100vw;
        max-height: 100vh;
        position: relative;
        padding: 0.5rem;
        background: ${backgroundColor};
      }`;
      document.head.appendChild(this.loadingSpinnerStyles);
    }
    if (!this.loadingSpinnerContainer) {
      this.loadingSpinnerContainer = document.createElement("div");
      this.loadingSpinnerContainer.setAttribute("loading-spinner-container", "true");
      const wrapper = document.createElement("div");
      wrapper.setAttribute("loading-spinner-wrapper", "true");
      this.loadingSpinnerContainer.appendChild(wrapper);
      const spinner = document.createElement("div");
      spinner.setAttribute("loading-spinner", "true");
      spinner.setAttribute("aria-label", "Wird geladen");
      spinner.setAttribute("role", "progressbar");
      wrapper.appendChild(spinner);
      this.mountPoint.appendChild(this.loadingSpinnerContainer);
    }
  }
  /**
   * Hide the loading spinner if it is shown.
   */
  hideInitialLoadingSpinner() {
    if (this.loadingSpinnerContainer && this.loadingSpinnerContainer.parentElement === this.mountPoint) {
      this.mountPoint.removeChild(this.loadingSpinnerContainer);
    }
  }
};

// src/_internal/script/load-script.ts
function loadScript(url) {
  const CUSTOM_ATTRIBUTE_FINISHED_LOADING = "data-loaded";
  const addListeners = (element, onLoad, onError) => {
    const loadListener = () => onLoad();
    const errorListener = (e) => onError(e);
    const abortListener = (e) => onError(e);
    element.addEventListener("load", loadListener);
    element.addEventListener("error", errorListener);
    element.addEventListener("abort", abortListener);
  };
  const existingScriptElement = document.querySelector(`script[src="${url}"]`);
  if (existingScriptElement) {
    if (existingScriptElement.getAttribute(CUSTOM_ATTRIBUTE_FINISHED_LOADING)) {
      return new Promise((resolve) => resolve());
    }
    return new Promise((resolve, reject) => {
      addListeners(existingScriptElement, resolve, reject);
    });
  }
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement("script");
    const onLoad = () => {
      scriptElement.setAttribute(CUSTOM_ATTRIBUTE_FINISHED_LOADING, "1");
      resolve();
    };
    addListeners(scriptElement, onLoad, reject);
    scriptElement.fetchPriority = "high";
    scriptElement.src = url;
    document.body.appendChild(scriptElement);
  });
}

// src/_internal/create-player/cdn-module-loader.ts
var createCdnModuleLoader = (bundleOptions, foundationWindow) => {
  if (!bundleOptions) {
    throw createFoundationError(
      "No module loader provided and bundle options are undefined!",
      {},
      ErrorCodes.PLAYER_DEPENDENCY_INVALID_52130
    );
  }
  const { version, cdnUrl } = bundleOptions;
  return async (modules) => {
    const getBundle = (module) => {
      const cdnPath = module.split("/")[1];
      const globalName = cdnPath.replace("-", ".").split(".");
      let bundle = foundationWindow.foundation;
      for (const segment of globalName) {
        bundle = typeof bundle === "object" && bundle && segment in bundle ? bundle[segment] : void 0;
      }
      return bundle;
    };
    const mustLoadModule = (module) => {
      if (!modules.includes(module)) {
        return false;
      }
      return !getBundle(module);
    };
    const bitmask = convertFlagsToBinary({
      "@foundation-player/player-dashjs": mustLoadModule("@foundation-player/player-dashjs"),
      "@foundation-player/player-chromecast": mustLoadModule(
        "@foundation-player/player-chromecast"
      ),
      "@foundation-player/plugin-npaw": mustLoadModule("@foundation-player/plugin-npaw"),
      "@foundation-player/plugin-posthog": mustLoadModule("@foundation-player/plugin-posthog"),
      "@foundation-player/plugin-smartclip": mustLoadModule("@foundation-player/plugin-smartclip"),
      "@foundation-player/plugin-ui": mustLoadModule("@foundation-player/plugin-ui"),
      "@foundation-player/plugin-shorts": mustLoadModule("@foundation-player/plugin-shorts"),
      "@foundation-player/plugin-yospace": mustLoadModule("@foundation-player/plugin-yospace")
    });
    const isZeroBitmask = bitmask.split("").every((char) => char === "0");
    if (!isZeroBitmask) {
      const packageUrl = new URL(`/cdn-modules/${version}/bundle.${bitmask}.evergreen.js`, cdnUrl);
      await loadScript(packageUrl.href);
    }
    return modules.map((m) => [m, getBundle(m)]);
  };
};

// src/_internal/merge-deep.ts
var isObject = (value) => value !== void 0 && value !== null && typeof value === "object" && !Array.isArray(value);
var mergeDeep = (target, source) => {
  let output = { ...target };
  if (isObject(target) && isObject(source)) {
    const keys = Object.keys(source);
    for (const key of keys) {
      if (isObject(source[key])) {
        if (!(key in target)) {
          output = { ...output, [key]: source[key] };
        } else {
          output = { ...output, [key]: mergeDeep(target[key], source[key]) };
        }
      } else {
        output = { ...output, [key]: source[key] };
      }
    }
  }
  return output;
};

// src/_internal/logger/logger-configuration-from-string.ts
function fromString(configurationString) {
  const logLevelEntries = Object.entries(LogLevel);
  const logLevels = logLevelEntries.map(([level, value]) => [level.toLowerCase(), value]);
  return configurationString.split(",").reduce(
    (list, part) => {
      if (!part.includes("=")) {
        return list;
      }
      const [segmentString, logLevelString] = part.trim().split("=").map((s) => s.trim());
      const segments = segmentString.includes(".") ? segmentString.split(".") : [segmentString];
      const logLevel = logLevels.find(([level]) => level === logLevelString.toLowerCase())?.[1];
      if (typeof logLevel === "number") {
        list.push([segments, logLevel]);
      }
      return list;
    },
    []
  ).map(([configuration, logLevel]) => {
    const reverse = configuration.reverse();
    let data = { [reverse[0]]: logLevel };
    for (let i = 1; i < reverse.length; i++) {
      data = { [reverse[i]]: data };
    }
    return data;
  }).reduce(
    (finalValue, currentValue) => mergeDeep(finalValue, currentValue),
    {}
  );
}

// src/_internal/logger/logger-implementation.ts
var DEFAULT_LOG_LEVEL = LogLevel.Warn;
var LoggerImplementation = class _LoggerImplementation {
  constructor(configuration = {
    [WILDCARD_NAMESPACE]: DEFAULT_LOG_LEVEL
  }, namespace = WILDCARD_NAMESPACE, backend = console) {
    this.configuration = configuration;
    this.namespace = namespace;
    this.backend = backend;
    this.logLevel = DEFAULT_LOG_LEVEL;
    if (!this.namespace) {
      this.namespace = WILDCARD_NAMESPACE;
    }
    const parts = this.namespace.split(".");
    parts.push(WILDCARD_NAMESPACE);
    let config = this.configuration;
    for (const part of parts) {
      config = part in config ? config[part] : config[WILDCARD_NAMESPACE];
      if (typeof config === "number") {
        this.logLevel = config;
        break;
      }
      if (!config) {
        this.logLevel = DEFAULT_LOG_LEVEL;
        break;
      }
    }
  }
  getLogger(providedNamespace) {
    let namespace = providedNamespace;
    if (!namespace) {
      return this;
    }
    const prefix = "foundation.";
    if (namespace.startsWith(prefix)) {
      namespace = namespace.slice(prefix.length);
    }
    return new _LoggerImplementation(this.configuration, namespace, this.backend);
  }
  log(level, message, ...context) {
    if (this.isLoggingActiveForLevel(level)) {
      const prefixedMsg = `[${this.namespace}]: ${message}`;
      switch (level) {
        case LogLevel.Trace:
          this.backend.trace(prefixedMsg, ...context);
          break;
        case LogLevel.Debug:
          this.backend.debug(prefixedMsg, ...context);
          break;
        case LogLevel.Info:
          this.backend.info(prefixedMsg, ...context);
          break;
        case LogLevel.Warn:
          this.backend.warn(prefixedMsg, ...context);
          break;
        case LogLevel.Error:
          this.backend.error(prefixedMsg, ...context);
          break;
        case LogLevel.None:
          break;
      }
    }
  }
  getLevel() {
    return this.logLevel;
  }
  debug(message, ...context) {
    this.log(LogLevel.Debug, message, ...context);
  }
  error(message, ...context) {
    this.log(LogLevel.Error, message, ...context);
  }
  info(message, ...context) {
    this.log(LogLevel.Info, message, ...context);
  }
  trace(message, ...context) {
    this.log(LogLevel.Trace, message, ...context);
  }
  warn(message, ...context) {
    this.log(LogLevel.Warn, message, ...context);
  }
  isLoggingActiveForLevel(logLevel) {
    return logLevel <= this.logLevel;
  }
};

// src/_internal/create-player/create-root-logger.ts
var PLAYER_LOG_QUERY_PARAMETER = "playerLog";
function internal_createRootLogger(loggerBackend, providedLoggerConfig) {
  const foundationWindow = window;
  if (foundationWindow.foundation?.internal_RootLogger && !loggerBackend && !providedLoggerConfig) {
    const rootLogger2 = foundationWindow.foundation.internal_RootLogger;
    rootLogger2.debug("Root logger reused from window object");
    return rootLogger2;
  }
  const url = new URL(location.href);
  const playerLogQueryParameter = url.searchParams.get(PLAYER_LOG_QUERY_PARAMETER);
  const loggerConfig = providedLoggerConfig ?? (playerLogQueryParameter ? fromString(playerLogQueryParameter) : void 0);
  const rootLogger = new LoggerImplementation(loggerConfig, WILDCARD_NAMESPACE, loggerBackend);
  foundationWindow.foundation = {
    ...foundationWindow.foundation || {},
    internal_RootLogger: rootLogger
  };
  if (rootLogger.isLoggingActiveForLevel(LogLevel.Debug)) {
    rootLogger.debug("Logger initialized with config:", JSON.stringify(loggerConfig));
  }
  return rootLogger;
}

// src/_internal/create-player/default-styles.text.css
var default_styles_text_default = '[data-foundation-player-styles] {\n  padding: 0;\n  margin: 0;\n  position: relative;\n  overflow: hidden;\n  min-height: 150px;\n  min-width: 260px;\n  box-sizing: content-box;\n  background-color: transparent;\n  width: 100%;\n  height: 100%;\n}\n\n[data-foundation-player-styles]::before {\n  display: block;\n  content: "";\n  width: 100%;\n}\n\n/*\nThis is a magic hack initially copied from Bitmovin and applied in general to the player container,\nto unify the aspect ratio handling for all players.\n\nThis rule is important for certain devices e.g. Magenta, where if this rule is not applied,\nthe player will shrink to a very small size.\n*/\n[data-foundation-player-styles~="aspect-16x9"]::before {\n  padding-bottom: 56.25%;\n}\n\n[data-foundation-player-styles] > * {\n  box-sizing: border-box;\n  padding: 0;\n}\n\n[data-foundation-player-styles] video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n';

// src/_internal/create-player/get-initial-loading-spinner-options.ts
function getInitialLoadingSpinnerOptions(createPlayerOptions) {
  const showInitialLoadingSpinner = createPlayerOptions.initialLoadingSpinnerOptions?.enabled ?? createPlayerOptions.ui?.enabled ?? createPlayerOptions.shortsUi?.enabled;
  if (!showInitialLoadingSpinner) {
    return void 0;
  }
  let aspectRatio = createPlayerOptions.initialLoadingSpinnerOptions?.aspectRatio;
  let backgroundColor = createPlayerOptions.initialLoadingSpinnerOptions?.backgroundColor;
  let spinnerColor = createPlayerOptions.initialLoadingSpinnerOptions?.spinnerColor;
  let maxSpinnerSize = createPlayerOptions.initialLoadingSpinnerOptions?.maxSpinnerSize;
  if (createPlayerOptions.ui?.enabled) {
    const uiMode = createPlayerOptions.ui?.look?.mode ?? inferUiMode(createPlayerOptions.loadRequest);
    if (!aspectRatio && uiMode !== "audio") {
      aspectRatio = createPlayerOptions.ui?.look?.aspectRatio === "9:16" ? "9 / 16" : "16 / 9";
    }
    if (createPlayerOptions.ui?.look?.theme === "light") {
      backgroundColor = backgroundColor ?? "#ffffff";
      spinnerColor = spinnerColor ?? "#000000";
    }
    if (uiMode === "audio") {
      maxSpinnerSize = maxSpinnerSize ?? "88px";
    }
  }
  if (createPlayerOptions.shortsUi?.enabled) {
    if (!backgroundColor) {
      backgroundColor = "transparent";
    }
  }
  return {
    aspectRatio,
    backgroundColor,
    spinnerColor,
    maxSpinnerSize
  };
}

// src/_internal/create-player/create-player.ts
async function internal_createPlayer(options, bundleOptions) {
  const {
    mountPoint,
    nonLinearElement,
    loadRequest,
    getRequestHeader,
    generateVideoElement,
    applyDefaultStyles
  } = options;
  const foundationWindow = window;
  foundationWindow.foundation ||= {};
  let moduleLoader;
  if (options.moduleLoader) {
    moduleLoader = options.moduleLoader;
  } else {
    moduleLoader = createCdnModuleLoader(bundleOptions, foundationWindow);
  }
  const debugInterface = new internal_DebugInterface(options);
  const rootLogger = internal_createRootLogger();
  const playerId = generateId();
  const deviceType = getDeviceType(loadRequest);
  foundationWindow.foundation.internal_deviceType = deviceType;
  if (generateVideoElement) {
    rootLogger.debug("Generating video element due to generateVideoElement option.");
    const videoElement = document.createElement("video");
    mountPoint.appendChild(videoElement);
  }
  if (applyDefaultStyles) {
    doApplyDefaultStyles(mountPoint, rootLogger);
  }
  const player = new Player({
    playerId,
    getRequestHeader,
    moduleLoader,
    debugInterface,
    deviceType,
    mountPoint
  });
  const inferredInitialLoadingSpinnerOptions = getInitialLoadingSpinnerOptions(options);
  if (inferredInitialLoadingSpinnerOptions) {
    player.showInitialLoadingSpinner(inferredInitialLoadingSpinnerOptions);
  }
  if (nonLinearElement) {
    player.setNonLinearElement(nonLinearElement);
  }
  debugInterface.playerInstance = player;
  let clientSupport = foundationWindow.foundation?.internal_clientSupport;
  if (!clientSupport) {
    clientSupport = await detectClientSupport(mountPoint);
    debugInterface.evaluatedClientSupport = clientSupport;
    foundationWindow.foundation.internal_clientSupport = clientSupport;
  }
  const { modules, manifestConfiguration, pluginConfigs, tweaks, error } = await evaluateLoadRequest({
    player,
    loadRequest,
    deviceType,
    clientSupport,
    getRequestHeader,
    possibleUiPluginConfig: options.ui,
    possibleShortsPluginConfig: options.shortsUi
  });
  player.setTweaks(tweaks);
  if ((pluginConfigs["foundation.plugin.ui"] || pluginConfigs["foundation.plugin.shortsUi"]) && (applyDefaultStyles || generateVideoElement || nonLinearElement)) {
    throw createFoundationError(
      '"CreatePlayerOptions" of "createPlayer()" are not valid. Do not use the UI in conjunction with "applyDefaultStyles", "generateVideoElement" or "nonLinearElement".',
      {
        uiConfig: pluginConfigs["foundation.plugin.ui"],
        shortsConfig: pluginConfigs["foundation.plugin.shortsUi"],
        applyDefaultStyles,
        generateVideoElement,
        nonLinearElement
      },
      ErrorCodes.PLAYERCONFIG_PROBLEM_34000
    );
  }
  const resolvedModules = await moduleLoader(modules);
  const { plugins, playerAdapters } = constructPluginsAndAdapters(player, {
    loadRequest,
    mountPoint,
    getRequestHeader,
    moduleLoader,
    playerId,
    manifestConfiguration,
    deviceType,
    pluginConfigs,
    resolvedModules,
    tweaks
  });
  player.hideInitialLoadingSpinner();
  if (error) {
    await player.triggerError(error);
    throw error;
  }
  if (!manifestConfiguration) {
    await player.triggerError(
      createFoundationError("INVARIANT: No manifest available without error")
    );
    throw error;
  }
  await player.loadManifestConfiguration({
    plugins,
    playerAdapters,
    manifestConfiguration,
    pluginConfigs,
    loadRequest
  }).catch((e) => rootLogger.error("Error loading manifest configuration", e));
  return player;
}
var getDeviceType = (loadRequest) => {
  return !loadRequest.deviceType || loadRequest.deviceType === "auto-detect" ? detectDeviceType() : loadRequest.deviceType;
};
var doApplyDefaultStyles = (mountPoint, rootLogger) => {
  rootLogger.debug("Applying default styles due to applyDefaultStyles option.");
  let styleElement = document.getElementById("foundation-styles") || void 0;
  if (!styleElement) {
    const head = document.head || document.getElementsByTagName("head")[0];
    styleElement = document.createElement("style");
    styleElement.innerHTML = default_styles_text_default;
    styleElement.id = "foundation-styles";
    head.appendChild(styleElement);
  }
  mountPoint.setAttribute("data-foundation-player-styles", "aspect-16x9");
};

// src/_internal/state/once.ts
function once2(fn) {
  let called = false;
  return (...args) => {
    if (!called) {
      called = true;
      fn(...args);
    }
  };
}

// src/public/create-linear-ad-load-request.ts
function createLinearAdLoadRequest(linearAdSlot, loadRequestPartial) {
  const tweaks = detectTweaks(loadRequestPartial?.tweaks, {});
  const videoSource = tweaks.hasAacCodecSupport ? getMinimalVideoSourceAac() : getMinimalVideoSourceMp3();
  const url = URL.createObjectURL(videoSource);
  return {
    ...loadRequestPartial,
    contentType: "advertisement",
    contentId: "ad-load-request",
    manifests: [
      {
        type: "progressive",
        sources: [{ url }]
      }
    ],
    plugins: {
      ...loadRequestPartial?.plugins,
      "foundation.plugin.smartclip": {
        ...loadRequestPartial?.plugins?.["foundation.plugin.smartclip"],
        enabled: true,
        adSlots: [
          {
            ...linearAdSlot,
            type: "linear",
            offsetInSeconds: -1
          }
        ]
      }
    }
  };
}

// src/_internal/environment/detect-bundle-target.ts
function detectBundleTarget() {
  if (isModernBundleTarget()) {
    return "chrome108";
  }
  if (isLegacyBundleTarget()) {
    return "chrome47";
  }
  return "chrome63";
}
function isModernBundleTarget() {
  const hasBigInt = (0, eval)("window.BigInt && window.BigInt.prototype");
  const hasFlatArrayMethods = (
    // biome-ignore lint/security/noGlobalEval: this is a deliberate feature check
    // biome-ignore lint/complexity/noCommaOperator: this is a deliberate feature check
    (0, eval)('Array && Array.prototype && Array.prototype.hasOwnProperty("flat")')
  );
  let hasOptionalChain;
  try {
    (0, eval)("var a = {foo: 1};var b = a?.foo;");
    hasOptionalChain = true;
  } catch {
    hasOptionalChain = false;
  }
  let hasLogicalOr;
  try {
    (0, eval)("var a = 5; a ||= 10;");
    hasLogicalOr = true;
  } catch {
    hasLogicalOr = false;
  }
  const hasAtArrayMethods = (
    // biome-ignore lint/security/noGlobalEval: this is a deliberate feature check
    // biome-ignore lint/complexity/noCommaOperator: this is a deliberate feature check
    (0, eval)('Array && Array.prototype && Array.prototype.hasOwnProperty("at")')
  );
  const hasFindLastArrayMethods = (
    // biome-ignore lint/security/noGlobalEval: this is a deliberate feature check
    // biome-ignore lint/complexity/noCommaOperator: this is a deliberate feature check
    (0, eval)('Array && Array.prototype && Array.prototype.hasOwnProperty("findLast")')
  );
  return hasBigInt && hasFlatArrayMethods && hasOptionalChain && hasLogicalOr && hasAtArrayMethods && hasFindLastArrayMethods;
}
function isLegacyBundleTarget() {
  const hasSearchParams = (
    // biome-ignore lint/security/noGlobalEval: this is a deliberate feature check
    // biome-ignore lint/complexity/noCommaOperator: this is a deliberate feature check
    (0, eval)(
      'window.URLSearchParams && window.URLSearchParams.prototype && window.URL && URL.prototype && URL.prototype.hasOwnProperty("searchParams")'
    )
  );
  const hasPrepend = (
    // biome-ignore lint/security/noGlobalEval: this is a deliberate feature check
    // biome-ignore lint/complexity/noCommaOperator: this is a deliberate feature check
    (0, eval)('Element && Element.prototype && Element.prototype.hasOwnProperty("prepend")')
  );
  const hasObjectEntries = (0, eval)('Object && Object.hasOwnProperty("entries")');
  let hasObjectSpread;
  try {
    (0, eval)("var a = {foo: 1};var b = {...a};");
    hasObjectSpread = true;
  } catch {
    hasObjectSpread = false;
  }
  return !hasSearchParams || !hasPrepend || !hasObjectEntries || !hasObjectSpread;
}

// src/_internal/environment/determine-version.ts
function determineVersion(version) {
  const match = /foundationVersion=(\d+.\d+.\d+(-[a-z]+\.\d+)?)/.exec(location.href);
  if (match) {
    console.warn("Overwrite foundation player version", match[1]);
    return match[1];
  }
  return version ?? getVersion();
}

// src/_internal/create-player/fetch-desired-api-version-from-cdn.ts
var getPreferredVersionIfDefined = (version) => {
  if (version && version !== "bundled-version") {
    return version;
  }
  return void 0;
};
async function fetchDesiredApiVersionFromCDN(options) {
  const { loadRequest, version: preferredVersion, _internal = {} } = options;
  const requestedVersion = getPreferredVersionIfDefined(preferredVersion) || getPreferredVersionIfDefined(loadRequest.version) || getVersion();
  const cdnUrl = _internal.cdnUrl || "https://cdn.player.foundation/";
  const bundleTarget = _internal.bundleTarget || detectBundleTarget();
  const version = determineVersion(requestedVersion);
  const apiPackage = window.foundation?.api;
  if (!apiPackage || apiPackage.getVersion() !== version) {
    const apiPackageUrl = new URL(`/api/${version}/bundle.evergreen.js`, cdnUrl);
    await loadScript(apiPackageUrl.href);
  }
  const hook = window.foundation?.api?.internal_createPlayer;
  if (!hook) {
    throw createFoundationError("The api package is not correctly loaded!");
  }
  return hook(options, {
    version,
    cdnUrl,
    bundleTarget
  });
}

// src/public/create-player.ts
async function createPlayer(options) {
  const createPlayerStartTime = performance.now();
  let player;
  if (!options.moduleLoader) {
    player = await fetchDesiredApiVersionFromCDN(options);
  } else {
    player = await internal_createPlayer(options);
  }
  const createPlayerEndTime = performance.now();
  const playerCreationInMs = createPlayerEndTime - createPlayerStartTime;
  player.state.patch({
    metrics: {
      ...player.state.value.metrics,
      playerCreationInMs
    }
  });
  return player;
}

// src/public/playlist.ts
var Playlist = class {
  /**
   * Creates a playlist with a non-empty array of loadRequests and an optional
   * startIndex.
   *
   * @remarks
   * If the array is empty, an error is thrown.
   *
   * Since the Foundation Player needs a loadRequest on creation, the first item (index=0)
   * of the array is considered as the current loadRequest. If you start the
   * player with a different loadRequest, set the startIndex parameter.
   */
  constructor(loadRequests, options = {}) {
    if (loadRequests.length === 0) {
      throw new Error("Playlist must contain at least one loadRequest.");
    }
    this.playlistOptions = {
      startIndex: options.startIndex ?? 0,
      automaticallyPlayNextItem: options.automaticallyPlayNextItem ?? true
    };
    const { startIndex } = this.playlistOptions;
    this.state = new MutableObservable({
      index: startIndex,
      length: loadRequests.length,
      loadRequests,
      currentLoadRequest: loadRequests[startIndex],
      isLast: startIndex === loadRequests.length - 1,
      isFirst: startIndex === 0,
      isSwitching: false
    });
    if (!this.isValidIndex(startIndex)) {
      throw new Error("Index out of bounds.");
    }
  }
  getPlaylistOptions() {
    return this.playlistOptions;
  }
  /**
   * Retrieve the load requests in the playlist.
   */
  getLoadRequests() {
    return this.state.value.loadRequests;
  }
  /**
   * Get the current pointer in the playlist.
   */
  getCurrentIndex() {
    return this.state.value.index;
  }
  /**
   * Get the current load request in the playlist.
   */
  getCurrentLoadRequest() {
    return this.state.value.currentLoadRequest;
  }
  reconcileState() {
    const loadRequestsLength = this.state.value.loadRequests.length;
    const stateLength = this.state.value.length;
    if (stateLength !== loadRequestsLength) {
      console.error(
        "[Foundation Player] Playlist load requests changed externally! You must use playlist.push instead! Reconciling state for length and isLast.",
        {
          given: stateLength,
          actual: loadRequestsLength
        }
      );
      this.state.patch({
        length: loadRequestsLength,
        isLast: this.state.value.index === loadRequestsLength - 1
      });
    }
  }
  /**
   * Get the number of items in this playlist.
   */
  get length() {
    this.reconcileState();
    return this.state.value.length;
  }
  /**
   * Whether the current medium is the last one in the list.
   */
  isLast() {
    this.reconcileState();
    return this.state.value.isLast;
  }
  /**
   * Whether the current medium is the first one in the list.
   */
  isFirst() {
    return this.state.value.isFirst;
  }
  /**
   * Whether the playlist is currently switching to a new item.
   *
   * @see {@link PlaylistState#isSwitching} for more information.
   */
  isSwitching() {
    return this.state.value.isSwitching;
  }
  /**
   * Change the start index of the playlist after creation but before connecting
   * to a player.
   *
   * @remarks
   * If the index is out of bounds, an error will be thrown.
   * If the playlist is already connected to a player, an error will be thrown.
   */
  changeStartIndex(nextIndex) {
    if (!this.isValidIndex(nextIndex)) {
      throw new Error("Index out of bounds.");
    }
    if (this.player) {
      throw new Error("Cannot change start index when playlist is already connected to a player.");
    }
    this.playlistOptions.startIndex = nextIndex;
    this.state.patch({
      index: nextIndex,
      currentLoadRequest: this.state.value.loadRequests[nextIndex],
      isLast: nextIndex === this.length - 1,
      isFirst: nextIndex === 0
    });
  }
  /**
   * Append a load request to the end of the playlist.
   *
   * @remarks
   * If the playlist is connected to a player and the last session is completed,
   * the new load request will be loaded immediately.
   */
  async push(loadRequest) {
    const isLast = this.isLast();
    const isSwitching = this.player && isLast && this.player.state.value.sessionCompleted;
    const nextLoadRequests = [...this.state.value.loadRequests, loadRequest];
    this.state.patch({
      loadRequests: nextLoadRequests,
      length: nextLoadRequests.length,
      isLast: false,
      // After pushing, we are not at the last item anymore
      isSwitching
    });
    if (isSwitching) {
      await this.next();
    }
  }
  /**
   * Try to advance the pointer in the playlist.
   *
   * @remarks
   * If the pointer is already at the end of the playlist, nothing will happen.
   *
   * If the playlist is not connected to a player, this will just update the state.
   */
  async next() {
    if (this.isLast()) {
      return;
    }
    const nextIndex = this.state.value.index + 1;
    this.state.patch({
      index: nextIndex,
      currentLoadRequest: this.state.value.loadRequests[nextIndex],
      isLast: nextIndex === this.length - 1,
      isFirst: false,
      isSwitching: true
    });
    return this.loadCurrentPlaylistItem();
  }
  /**
   * Try to rewind the pointer in the playlist.
   *
   * @remarks
   * If the pointer is already at the beginning of the playlist, nothing will
   * happen.
   *
   * If the playlist is not connected to a player, this will just update the state.
   */
  async previous() {
    const currentIndex = this.state.value.index;
    if (currentIndex <= 0) {
      return;
    }
    const nextIndex = currentIndex - 1;
    this.state.patch({
      index: nextIndex,
      currentLoadRequest: this.state.value.loadRequests[nextIndex],
      isFirst: nextIndex === 0,
      isLast: false,
      isSwitching: true
    });
    await this.loadCurrentPlaylistItem();
  }
  /**
   * Add a load request at a specific index in the playlist.
   *
   * @remarks
   * If the index is out of bounds, an error will be thrown.
   * All items starting with the index will be shifted to the right.
   *
   * If you insert a load request at the current index the newly added load
   * request will be loaded immediately.
   * If you insert a load request before the current index, the pointer will be
   * incremented.
   */
  async insertAt(index, loadRequest) {
    if (!this.isValidIndex(index)) {
      throw new Error("Index out of bounds");
    }
    const currentIndex = this.state.value.index;
    const nextIndex = currentIndex > index ? currentIndex + 1 : currentIndex;
    const nextLoadRequests = [...this.state.value.loadRequests];
    nextLoadRequests.splice(index, 0, loadRequest);
    const isSwitching = this.player && index === nextIndex;
    this.state.patch({
      index: nextIndex,
      loadRequests: nextLoadRequests,
      length: nextLoadRequests.length,
      currentLoadRequest: nextLoadRequests[nextIndex],
      isLast: nextIndex === nextLoadRequests.length - 1,
      isFirst: nextIndex === 0,
      isSwitching
    });
    if (isSwitching) {
      await this.loadCurrentPlaylistItem();
    }
  }
  /**
   * Play a specific load request in the playlist.
   *
   * @remarks
   * If the index is out of bounds, an error will be thrown.
   *
   * If the index is already the current index and the session is not yet
   * completed, nothing will happen.
   * Otherwise, the load request will be loaded immediately.
   *
   * If the playlist is not connected to a player, this will do nothing.
   * If you have to change the start index before connecting the player,
   * use {@link Playlist#changeStartIndex} instead.
   */
  async loadLoadRequestAt(index) {
    if (!this.isValidIndex(index)) {
      throw new Error("Index out of bounds");
    }
    if (this.player) {
      const currentIndex = this.state.value.index;
      if (index !== currentIndex || this.player.state.value.sessionCompleted) {
        this.state.patch({
          index,
          currentLoadRequest: this.state.value.loadRequests[index],
          isLast: index === this.length - 1,
          isFirst: index === 0,
          isSwitching: true
        });
        await this.loadCurrentPlaylistItem();
      }
    }
  }
  /**
   * Connect the playlist to a player.
   *
   * @remarks
   * If the playlist is already connected to a player, an error will be thrown.
   *
   * Once connected, the playlist will observe the player progress and start the
   * next load request when the current session is completed.
   */
  connect(player) {
    if (this.player === player) {
      return;
    }
    if (this.player) {
      throw createFoundationError(
        "Playlist is already connected to another player. Please create a new playlist instead.",
        {
          connected: this.player,
          provided: player
        },
        ErrorCodes.PLAYERCONFIG_PROBLEM_34000
      );
    }
    this.player = player;
    this.subscribeToPlayerStateChanges();
  }
  async loadCurrentPlaylistItem() {
    if (!this.player) {
      return;
    }
    if (this.subscription) {
      this.subscription();
      this.subscription = void 0;
    }
    this.state.patch({
      isSwitching: true
    });
    await this.player.pause();
    await loadMedia(this.player, this.getCurrentLoadRequest()).catch(
      (error) => console.error(error)
    );
    this.state.patch({
      isSwitching: false
    });
    this.subscribeToPlayerStateChanges();
  }
  subscribeToPlayerStateChanges() {
    if (!this.player) {
      throw createFoundationError(
        "A player must be connected before subscribing to its state changes."
      );
    }
    if (this.subscription) {
      this.subscription();
      this.subscription = void 0;
    }
    this.reconcileState();
    if (!this.playlistOptions.automaticallyPlayNextItem) {
      return;
    }
    this.subscription = this.player.state.onValueChange("sessionCompleted", (state) => {
      if (state.sessionCompleted) {
        void this.next();
      }
    });
  }
  isValidIndex(index) {
    return index >= 0 && index < this.length && Math.floor(index) === index;
  }
};
export {
  AdClipType,
  ContentType,
  DeviceType,
  ErrorCodes,
  EventBus,
  FoundationError,
  KeySystem,
  LogLevel,
  ManifestType,
  MutableObservable,
  PlayerPlugin,
  Playlist,
  RequestType,
  TypedEventTarget,
  UserType,
  assertVideoElementAttributes,
  createFoundationError,
  createLinearAdLoadRequest,
  createPlayer,
  fetchRemoteConfig,
  fetchWithTimeout,
  findVideoElement,
  getLogger,
  getVersion,
  inferLabelFromLanguage,
  internal_BundleOptions,
  internal_createBundleOptionsMap,
  internal_createPlayer,
  internal_createRootLogger,
  internal_loadMedia,
  isFoundationError,
  loadMedia,
  onValueChange,
  onValueChangeAsync,
  once2 as once,
  once as polyfill_once,
  withResolvers as polyfill_withResolvers,
  testAutoplay,
  waitForEvent
};
